"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PermissionSetTypeEnum = exports.PermissionEnum = exports.PaymentRuleShortFlexEnum = exports.OrderVisibilityEnum = exports.OrderSideEnum = exports.OrderCompletionTypeEnum = exports.NotificationTypeEnum = exports.MfrrMessageTypeEnum = exports.MfrrEndpointTypeEnum = exports.MfrrAckStatusTypeEnum = exports.MeterReadingsAggregationLevelEnum = exports.MeterReadingProviderEnum = exports.MaxUsageLimitTypeEnum = exports.MarketStatisticTypeEnum = exports.MarketPermissionTypeEnum = exports.IspGateClosedPolicyEnum = exports.InvoiceFileTypeEnum = exports.InvoiceChannelEnum = exports.GridNodePolygonVisibilityEnum = exports.FillTypeEnum = exports.EventTypeEnum = exports.DateCalculationBaseEnum = exports.CounterOrderPolicyEnum = exports.ContractTypeEnum = exports.ContractCalculationRuleEnum = exports.ColumnDataTypeEnum = exports.BillingPolicyEnum = exports.BaselineProviderEnum = exports.AllowedToSellEnum = exports.AllowedToBuyEnum = exports.FlexibilityTypeEnum = exports.FeatureFlagsEnum = exports.CimTimeSeriesCurveTypeEnum = exports.CimStatusTypeSvkEnum = exports.CimStatusTypeStatnettEnum = exports.CimRoleTypeSvkEnum = exports.CimRoleTypeStatnettEnum = exports.CimReasonTypeEnum = exports.CimProductTypeEnum = exports.CimProcessTypeSvkEnum = exports.CimProcessTypeStatnettEnum = exports.CimPowerUnitTypeEnum = exports.CimDocumentTypeEnum = exports.CimDirectionTypeEnum = exports.CimCurrencyTypeEnum = exports.CimContractTypeEnum = exports.CimCodingSchemeTypeEnum = exports.CimBusinessTypeSvkEnum = exports.CimBusinessTypeStatnettEnum = exports.CimBooleanTypeEnum = void 0;
exports.Job = exports.NodesMessage = exports.ColumnDescription = exports.QueryReport = exports.QueryReportParameter = exports.MarketSurveillanceLine = exports.Property = exports.TimeZoneInfo = exports.Operation = exports.Batch = exports.ValidationError = exports.DryRunResponse = exports.DryRunRequest = exports.Counterpart = exports.ClientCredentialsLogin = exports.UserInfo = exports.IHasLinks = exports.DTOBase = exports.LoginConfiguration = exports.NodesLink = exports.Coordinate = exports.DateTimeRange = exports.PublicOrderSearchResult = exports.PublicOrderSearch = exports.SearchOptions = exports.HistoricalFilter = exports.Discriminator = exports.OrderBlockInfo = exports.OrderAggregateSearch = exports.PriceAggregate = exports.TradeAggregateQuery = exports.TradeAggregateInfo = exports.TradeAggregate = exports.OrderAggregate = exports.ContractSchedule = exports.WeekTemplate = exports.BlockTemplate = exports.RelationsEnum = exports.VisibilityPolicyEnum = exports.UserTypeEnum = exports.TradeVisibilityEnum = exports.SubscriptionTypeEnum = exports.StatusEnum = exports.RenewableTypeEnum = exports.RegulationTypeEnum = exports.QueryReportParamTypeEnum = exports.QuantityTypeEnum = exports.PriceTypeEnum = exports.PreQualificationResponseTypeEnum = exports.PermissionTypeEnum = void 0;
exports.MarketPermission = exports.MarketParticipationRequirement = exports.MarketParticipation = exports.MarketMessage = exports.Market = exports.MapPolygon = exports.LongFlexContract = exports.InvoicingInfo = exports.InvoiceLine = exports.InvoiceFile = exports.Invoice = exports.Invitation = exports.GridNodeMarketAssignment = exports.GridNodeLink = exports.GridNode = exports.GridLocation = exports.GridGroupAssignment = exports.GridGroup = exports.GridArea = exports.DispatchNotification = exports.DispatchConfiguration = exports.DigestSubscription = exports.DigestLog = exports.DigestEvent = exports.Deal = exports.DayAheadAuctionSettings = exports.Currency = exports.Country = exports.BaseLinePrognosisSettings = exports.BaseLineInterval = exports.BankInfo = exports.AssetType = exports.AssetPortfolioAssignment = exports.AssetPortfolioAggregation = exports.AssetPortfolio = exports.AssetGridAssignment = exports.Asset = exports.ApplicationUserMapping = exports.BalanceReportQuery = exports.BalanceReportRow = exports.BaseLineDeletionQuery = exports.DigestProviderInfo = exports.SimplePolygon = exports.Polygon = exports.RecommendationWeightedParameter = exports.RecommendationWeightedScore = exports.RecommendationScore = exports.RecommendationScoreCard = exports.OrderChangeEvent = exports.OrderChangeCommand = void 0;
exports.AssetGridAssignmentView = exports.FSPAssetView = exports.AssetPortfolioInfo = exports.VatRate = exports.User = exports.TradingThreshold = exports.Trade = exports.Subscription = exports.SettledTradeLine = exports.SettledMaxUsageLine = exports.SettledLongFlexLine = exports.SettledLineBase = exports.RecommendationTemplate = exports.PublicOrder = exports.PrivateGridNodeData = exports.PriceArea = exports.PreQualificationSubmission = exports.PreQualificationRequirement = exports.PreQualificationFile = exports.Preferences = exports.PermissionSet = exports.PermissionAssignment = exports.OrganizationVisibilitySettings = exports.Organization = exports.Order = exports.MfrrTimeSeries = exports.MfrrInterchangeConfiguration = exports.MfrrInterchange = exports.MeterReading = exports.Membership = exports.MaxUsageTender = exports.MaxUsageContract = exports.MarketStatistic = exports.MarketSettlementConfig = void 0;
var CimBooleanTypeEnum;
(function (CimBooleanTypeEnum) {
  CimBooleanTypeEnum["True"] = "True";
  CimBooleanTypeEnum["False"] = "False";
})(CimBooleanTypeEnum = exports.CimBooleanTypeEnum || (exports.CimBooleanTypeEnum = {}));
var CimBusinessTypeStatnettEnum;
(function (CimBusinessTypeStatnettEnum) {
  CimBusinessTypeStatnettEnum["Production"] = "Production";
  CimBusinessTypeStatnettEnum["InternalTrade"] = "InternalTrade";
  CimBusinessTypeStatnettEnum["ExternalTradeExplicitCapacity"] = "ExternalTradeExplicitCapacity";
  CimBusinessTypeStatnettEnum["Consumption"] = "Consumption";
  CimBusinessTypeStatnettEnum["ExternalTradeTotal"] = "ExternalTradeTotal";
  CimBusinessTypeStatnettEnum["ExternalTradeWithoutExplicitCapacity"] = "ExternalTradeWithoutExplicitCapacity";
  CimBusinessTypeStatnettEnum["NetProductionOrConsumption"] = "NetProductionOrConsumption";
  CimBusinessTypeStatnettEnum["NetInternalTrade"] = "NetInternalTrade";
  CimBusinessTypeStatnettEnum["IndependentPowerProducer"] = "IndependentPowerProducer";
  CimBusinessTypeStatnettEnum["TertiaryControl"] = "TertiaryControl";
  CimBusinessTypeStatnettEnum["PrimaryControl"] = "PrimaryControl";
  CimBusinessTypeStatnettEnum["SecondaryControl"] = "SecondaryControl";
  CimBusinessTypeStatnettEnum["LoadProfile"] = "LoadProfile";
  CimBusinessTypeStatnettEnum["AggregatedEnergyData"] = "AggregatedEnergyData";
  CimBusinessTypeStatnettEnum["Losses"] = "Losses";
  CimBusinessTypeStatnettEnum["Transits"] = "Transits";
  CimBusinessTypeStatnettEnum["SettlementDeviation"] = "SettlementDeviation";
  CimBusinessTypeStatnettEnum["TechnicalConstraintDeviation"] = "TechnicalConstraintDeviation";
  CimBusinessTypeStatnettEnum["BalanceEnergyDeviation"] = "BalanceEnergyDeviation";
  CimBusinessTypeStatnettEnum["ImbalanceVolume"] = "ImbalanceVolume";
  CimBusinessTypeStatnettEnum["InadvertantDeviation"] = "InadvertantDeviation";
  CimBusinessTypeStatnettEnum["FrequencyControl"] = "FrequencyControl";
  CimBusinessTypeStatnettEnum["BalanceManagement"] = "BalanceManagement";
  CimBusinessTypeStatnettEnum["TotalTrade"] = "TotalTrade";
  CimBusinessTypeStatnettEnum["GeneralCapacityInformation"] = "GeneralCapacityInformation";
  CimBusinessTypeStatnettEnum["AvailableTransferCapacity"] = "AvailableTransferCapacity";
  CimBusinessTypeStatnettEnum["NetTransferCapacity"] = "NetTransferCapacity";
  CimBusinessTypeStatnettEnum["ControlAreaProgram"] = "ControlAreaProgram";
  CimBusinessTypeStatnettEnum["AlreadyAllocatedCapacity"] = "AlreadyAllocatedCapacity";
  CimBusinessTypeStatnettEnum["InternalInterAreaTrade"] = "InternalInterAreaTrade";
  CimBusinessTypeStatnettEnum["OfferedCapacity"] = "OfferedCapacity";
  CimBusinessTypeStatnettEnum["CapacityTransferNotification"] = "CapacityTransferNotification";
  CimBusinessTypeStatnettEnum["AuthorisedAAC"] = "AuthorisedAAC";
  CimBusinessTypeStatnettEnum["CapacityRights"] = "CapacityRights";
  CimBusinessTypeStatnettEnum["MinimumAuthorisedAAC"] = "MinimumAuthorisedAAC";
  CimBusinessTypeStatnettEnum["MaximumAuthorisedAAC"] = "MaximumAuthorisedAAC";
  CimBusinessTypeStatnettEnum["InstalledGeneration"] = "InstalledGeneration";
  CimBusinessTypeStatnettEnum["AvailableGeneration"] = "AvailableGeneration";
  CimBusinessTypeStatnettEnum["InterconnectionTradeResponsibleDesignation"] = "InterconnectionTradeResponsibleDesignation";
  CimBusinessTypeStatnettEnum["ReleasedAAC"] = "ReleasedAAC";
  CimBusinessTypeStatnettEnum["RequestedCapacityWithPrice"] = "RequestedCapacityWithPrice";
  CimBusinessTypeStatnettEnum["RequestedCapacityWithoutPrice"] = "RequestedCapacityWithoutPrice";
  CimBusinessTypeStatnettEnum["CompensationProgram"] = "CompensationProgram";
  CimBusinessTypeStatnettEnum["ScheduleActivatedReserves"] = "ScheduleActivatedReserves";
  CimBusinessTypeStatnettEnum["SystemOperatorRedispatching"] = "SystemOperatorRedispatching";
  CimBusinessTypeStatnettEnum["MarketCapacityPrice"] = "MarketCapacityPrice";
  CimBusinessTypeStatnettEnum["MarketCapacityPriceDifferential"] = "MarketCapacityPriceDifferential";
  CimBusinessTypeStatnettEnum["Inflow"] = "Inflow";
  CimBusinessTypeStatnettEnum["WaterExtraction"] = "WaterExtraction";
  CimBusinessTypeStatnettEnum["TurbinedWater"] = "TurbinedWater";
  CimBusinessTypeStatnettEnum["WaterSpillage"] = "WaterSpillage";
  CimBusinessTypeStatnettEnum["PlannedMaintenance"] = "PlannedMaintenance";
  CimBusinessTypeStatnettEnum["ForcedOutage"] = "ForcedOutage";
  CimBusinessTypeStatnettEnum["UseItOrSellItPricing"] = "UseItOrSellItPricing";
  CimBusinessTypeStatnettEnum["CompensationForAuctionCancellationWhereCapacityIsForResale"] = "CompensationForAuctionCancellationWhereCapacityIsForResale";
  CimBusinessTypeStatnettEnum["ResalePricing"] = "ResalePricing";
  CimBusinessTypeStatnettEnum["CurtailedCapacityCompensation"] = "CurtailedCapacityCompensation";
  CimBusinessTypeStatnettEnum["UseItOrSellItCompensation"] = "UseItOrSellItCompensation";
  CimBusinessTypeStatnettEnum["MinimumPossible"] = "MinimumPossible";
  CimBusinessTypeStatnettEnum["MaximumAvailable"] = "MaximumAvailable";
  CimBusinessTypeStatnettEnum["SpotPrice"] = "SpotPrice";
  CimBusinessTypeStatnettEnum["MinimumATC"] = "MinimumATC";
  CimBusinessTypeStatnettEnum["MeterMeasurementData"] = "MeterMeasurementData";
  CimBusinessTypeStatnettEnum["AccountingPointRelevantData"] = "AccountingPointRelevantData";
  CimBusinessTypeStatnettEnum["EnergyFlow"] = "EnergyFlow";
  CimBusinessTypeStatnettEnum["PowerPlantEnergySchedule"] = "PowerPlantEnergySchedule";
  CimBusinessTypeStatnettEnum["CompensationRequirementsForTheCompensationPeriod"] = "CompensationRequirementsForTheCompensationPeriod";
  CimBusinessTypeStatnettEnum["MarketCouplingResults"] = "MarketCouplingResults";
  CimBusinessTypeStatnettEnum["ProductionUnavailable"] = "ProductionUnavailable";
  CimBusinessTypeStatnettEnum["SupplementryAvailableGeneration"] = "SupplementryAvailableGeneration";
  CimBusinessTypeStatnettEnum["InterruptibleConsumption"] = "InterruptibleConsumption";
  CimBusinessTypeStatnettEnum["SummarisedMarketBalanceAreaSchedule"] = "SummarisedMarketBalanceAreaSchedule";
  CimBusinessTypeStatnettEnum["LoadFrequencyControlProgramSchedule"] = "LoadFrequencyControlProgramSchedule";
  CimBusinessTypeStatnettEnum["TimeframeIndependentSchedule"] = "TimeframeIndependentSchedule";
  CimBusinessTypeStatnettEnum["ConsumptionCurtailment"] = "ConsumptionCurtailment";
  CimBusinessTypeStatnettEnum["ProductionDispatchable"] = "ProductionDispatchable";
  CimBusinessTypeStatnettEnum["ConsumptionDispatchable"] = "ConsumptionDispatchable";
  CimBusinessTypeStatnettEnum["ProductionNonDispatchable"] = "ProductionNonDispatchable";
  CimBusinessTypeStatnettEnum["ConsumptionNonDispatchable"] = "ConsumptionNonDispatchable";
  CimBusinessTypeStatnettEnum["TotalTransferCapacity"] = "TotalTransferCapacity";
  CimBusinessTypeStatnettEnum["MutualEmergencyAssistanceService"] = "MutualEmergencyAssistanceService";
  CimBusinessTypeStatnettEnum["AuctionCancelation"] = "AuctionCancelation";
  CimBusinessTypeStatnettEnum["NominationCurtailment"] = "NominationCurtailment";
  CimBusinessTypeStatnettEnum["InternalRedispatch"] = "InternalRedispatch";
  CimBusinessTypeStatnettEnum["ControlAreaBalanceEnergy"] = "ControlAreaBalanceEnergy";
  CimBusinessTypeStatnettEnum["BalancingEnergyPrice"] = "BalancingEnergyPrice";
  CimBusinessTypeStatnettEnum["EconomisedSecondaryReserve"] = "EconomisedSecondaryReserve";
  CimBusinessTypeStatnettEnum["SpinningReserve"] = "SpinningReserve";
  CimBusinessTypeStatnettEnum["Solar"] = "Solar";
  CimBusinessTypeStatnettEnum["PositiveForecastMargin"] = "PositiveForecastMargin";
  CimBusinessTypeStatnettEnum["NegativeForecastMargin"] = "NegativeForecastMargin";
  CimBusinessTypeStatnettEnum["WindGeneration"] = "WindGeneration";
  CimBusinessTypeStatnettEnum["SolarGeneration"] = "SolarGeneration";
  CimBusinessTypeStatnettEnum["FrequencyContainmentReserve"] = "FrequencyContainmentReserve";
  CimBusinessTypeStatnettEnum["AutomaticFrequencyRestorationReserve"] = "AutomaticFrequencyRestorationReserve";
  CimBusinessTypeStatnettEnum["ManualFrequencyRestorationReserve"] = "ManualFrequencyRestorationReserve";
  CimBusinessTypeStatnettEnum["ReplacementReserve"] = "ReplacementReserve";
  CimBusinessTypeStatnettEnum["FinancialInformation"] = "FinancialInformation";
  CimBusinessTypeStatnettEnum["InterconnectorNetworkEvolution"] = "InterconnectorNetworkEvolution";
  CimBusinessTypeStatnettEnum["InterconnectorNetworkDismantling"] = "InterconnectorNetworkDismantling";
  CimBusinessTypeStatnettEnum["CounterTrade"] = "CounterTrade";
  CimBusinessTypeStatnettEnum["CongestionCosts"] = "CongestionCosts";
  CimBusinessTypeStatnettEnum["CapacityAllocated"] = "CapacityAllocated";
  CimBusinessTypeStatnettEnum["DCLinkConstraint"] = "DCLinkConstraint";
  CimBusinessTypeStatnettEnum["AuctionRevenue"] = "AuctionRevenue";
  CimBusinessTypeStatnettEnum["TotalNominatedCapacity"] = "TotalNominatedCapacity";
  CimBusinessTypeStatnettEnum["NetPosition"] = "NetPosition";
  CimBusinessTypeStatnettEnum["CongestionIncome"] = "CongestionIncome";
  CimBusinessTypeStatnettEnum["ProductionUnit"] = "ProductionUnit";
  CimBusinessTypeStatnettEnum["RoundedMarketCouplingResults"] = "RoundedMarketCouplingResults";
  CimBusinessTypeStatnettEnum["AllocationRevenue"] = "AllocationRevenue";
  CimBusinessTypeStatnettEnum["ProductionDeviation"] = "ProductionDeviation";
  CimBusinessTypeStatnettEnum["ConsumptionDeviation"] = "ConsumptionDeviation";
  CimBusinessTypeStatnettEnum["TransmissionAsset"] = "TransmissionAsset";
  CimBusinessTypeStatnettEnum["ConsumptionUnit"] = "ConsumptionUnit";
  CimBusinessTypeStatnettEnum["InFeedATC"] = "InFeedATC";
  CimBusinessTypeStatnettEnum["OutFeedATC"] = "OutFeedATC";
  CimBusinessTypeStatnettEnum["BalanceUpRegulationPrice"] = "BalanceUpRegulationPrice";
  CimBusinessTypeStatnettEnum["BalanceDownRegulationPrice"] = "BalanceDownRegulationPrice";
  CimBusinessTypeStatnettEnum["MainDirection"] = "MainDirection";
  CimBusinessTypeStatnettEnum["ConsumptionImbalancePrice"] = "ConsumptionImbalancePrice";
  CimBusinessTypeStatnettEnum["ProductionSalesImbalancePrice"] = "ProductionSalesImbalancePrice";
  CimBusinessTypeStatnettEnum["ProductionPurchaseImbalancePrice"] = "ProductionPurchaseImbalancePrice";
  CimBusinessTypeStatnettEnum["AverageBalancePriceBetweenMBAs"] = "AverageBalancePriceBetweenMBAs";
  CimBusinessTypeStatnettEnum["Pumped"] = "Pumped";
  CimBusinessTypeStatnettEnum["LargeInstallationConsumption"] = "LargeInstallationConsumption";
  CimBusinessTypeStatnettEnum["MeteringGridAreaImbalance"] = "MeteringGridAreaImbalance";
})(CimBusinessTypeStatnettEnum = exports.CimBusinessTypeStatnettEnum || (exports.CimBusinessTypeStatnettEnum = {}));
var CimBusinessTypeSvkEnum;
(function (CimBusinessTypeSvkEnum) {
  CimBusinessTypeSvkEnum["Production_A01"] = "Production_A01";
  CimBusinessTypeSvkEnum["Internal_Trade"] = "Internal_Trade";
  CimBusinessTypeSvkEnum["External_Trade_Explicit_Capacity"] = "External_Trade_Explicit_Capacity";
  CimBusinessTypeSvkEnum["Consumption_A04"] = "Consumption_A04";
  CimBusinessTypeSvkEnum["External_Trade_Total"] = "External_Trade_Total";
  CimBusinessTypeSvkEnum["External_Trade_Without_Explicit_Capacity"] = "External_Trade_Without_Explicit_Capacity";
  CimBusinessTypeSvkEnum["Net_Production_Or_Consumption"] = "Net_Production_Or_Consumption";
  CimBusinessTypeSvkEnum["Net_Internal_Trade"] = "Net_Internal_Trade";
  CimBusinessTypeSvkEnum["IPP"] = "IPP";
  CimBusinessTypeSvkEnum["Tertiary_Control"] = "Tertiary_Control";
  CimBusinessTypeSvkEnum["Primary_Control"] = "Primary_Control";
  CimBusinessTypeSvkEnum["Secondary_Control"] = "Secondary_Control";
  CimBusinessTypeSvkEnum["Load_Profile"] = "Load_Profile";
  CimBusinessTypeSvkEnum["Aggregated_Energy_Data"] = "Aggregated_Energy_Data";
  CimBusinessTypeSvkEnum["Losses"] = "Losses";
  CimBusinessTypeSvkEnum["Transits"] = "Transits";
  CimBusinessTypeSvkEnum["Settlement_Deviation"] = "Settlement_Deviation";
  CimBusinessTypeSvkEnum["Technical_Constraint_Deviation"] = "Technical_Constraint_Deviation";
  CimBusinessTypeSvkEnum["Balance_Energy_Deviation"] = "Balance_Energy_Deviation";
  CimBusinessTypeSvkEnum["Imbalance_Volume"] = "Imbalance_Volume";
  CimBusinessTypeSvkEnum["Unintended_Energy"] = "Unintended_Energy";
  CimBusinessTypeSvkEnum["Frequency_Control"] = "Frequency_Control";
  CimBusinessTypeSvkEnum["Balance_Management"] = "Balance_Management";
  CimBusinessTypeSvkEnum["Total_Trade"] = "Total_Trade";
  CimBusinessTypeSvkEnum["General_Capacity_Information"] = "General_Capacity_Information";
  CimBusinessTypeSvkEnum["Available_Transfer_Capacity"] = "Available_Transfer_Capacity";
  CimBusinessTypeSvkEnum["Net_Transfer_Capacity"] = "Net_Transfer_Capacity";
  CimBusinessTypeSvkEnum["Control_Area_Program"] = "Control_Area_Program";
  CimBusinessTypeSvkEnum["Already_Allocated_Capacity"] = "Already_Allocated_Capacity";
  CimBusinessTypeSvkEnum["Internal_Inter_Area_Trade"] = "Internal_Inter_Area_Trade";
  CimBusinessTypeSvkEnum["Offered_Capacity"] = "Offered_Capacity";
  CimBusinessTypeSvkEnum["Capacity_Transfer_Notification"] = "Capacity_Transfer_Notification";
  CimBusinessTypeSvkEnum["Authorised_AAC"] = "Authorised_AAC";
  CimBusinessTypeSvkEnum["Capacity_Rights"] = "Capacity_Rights";
  CimBusinessTypeSvkEnum["Minimum_Authorised_AAC"] = "Minimum_Authorised_AAC";
  CimBusinessTypeSvkEnum["Maximum_Authorised_AAC"] = "Maximum_Authorised_AAC";
  CimBusinessTypeSvkEnum["Installed_Generation"] = "Installed_Generation";
  CimBusinessTypeSvkEnum["Available_Generation"] = "Available_Generation";
  CimBusinessTypeSvkEnum["Interconnection_Trade_Responsible_Designation"] = "Interconnection_Trade_Responsible_Designation";
  CimBusinessTypeSvkEnum["Released_AAC"] = "Released_AAC";
  CimBusinessTypeSvkEnum["Requested_Capacity_Including_Price"] = "Requested_Capacity_Including_Price";
  CimBusinessTypeSvkEnum["Requested_Capacity_Excluding_Price"] = "Requested_Capacity_Excluding_Price";
  CimBusinessTypeSvkEnum["Compensation_Program"] = "Compensation_Program";
  CimBusinessTypeSvkEnum["Schedule_Activated_Reserves"] = "Schedule_Activated_Reserves";
  CimBusinessTypeSvkEnum["System_Operator_Redispatching"] = "System_Operator_Redispatching";
  CimBusinessTypeSvkEnum["Market_Capacity_Price"] = "Market_Capacity_Price";
  CimBusinessTypeSvkEnum["Market_Capacity_Price_Differential"] = "Market_Capacity_Price_Differential";
  CimBusinessTypeSvkEnum["Inflow"] = "Inflow";
  CimBusinessTypeSvkEnum["Water_Extraction"] = "Water_Extraction";
  CimBusinessTypeSvkEnum["Turbined_Water"] = "Turbined_Water";
  CimBusinessTypeSvkEnum["Water_Spillage"] = "Water_Spillage";
  CimBusinessTypeSvkEnum["Planned_Maintenance"] = "Planned_Maintenance";
  CimBusinessTypeSvkEnum["Unplanned_Outage"] = "Unplanned_Outage";
  CimBusinessTypeSvkEnum["Use_It_Or_Sell_It_Pricing"] = "Use_It_Or_Sell_It_Pricing";
  CimBusinessTypeSvkEnum["Compensation_For_Auction_Cancellation_Where_Capacity_Is_For_Resale"] = "Compensation_For_Auction_Cancellation_Where_Capacity_Is_For_Resale";
  CimBusinessTypeSvkEnum["Resale_Pricing"] = "Resale_Pricing";
  CimBusinessTypeSvkEnum["Curtailed_Capacity_Compensation"] = "Curtailed_Capacity_Compensation";
  CimBusinessTypeSvkEnum["Use_It_Or_Sell_It_Compensation"] = "Use_It_Or_Sell_It_Compensation";
  CimBusinessTypeSvkEnum["Minimum_Possible"] = "Minimum_Possible";
  CimBusinessTypeSvkEnum["Maximum_Available"] = "Maximum_Available";
  CimBusinessTypeSvkEnum["Spot_Price"] = "Spot_Price";
  CimBusinessTypeSvkEnum["Minimum_ATC"] = "Minimum_ATC";
  CimBusinessTypeSvkEnum["Meter_Measurement_Data"] = "Meter_Measurement_Data";
  CimBusinessTypeSvkEnum["Accounting_Point_Relevant_Data"] = "Accounting_Point_Relevant_Data";
  CimBusinessTypeSvkEnum["Energy_Flow"] = "Energy_Flow";
  CimBusinessTypeSvkEnum["Power_Plant_Energy_Schedule"] = "Power_Plant_Energy_Schedule";
  CimBusinessTypeSvkEnum["Compensation_Requirements_For_The_Compensation_Period"] = "Compensation_Requirements_For_The_Compensation_Period";
  CimBusinessTypeSvkEnum["Market_Coupling_Results"] = "Market_Coupling_Results";
  CimBusinessTypeSvkEnum["Production_Unavailable"] = "Production_Unavailable";
  CimBusinessTypeSvkEnum["Supplementary_Available_Generation"] = "Supplementary_Available_Generation";
  CimBusinessTypeSvkEnum["Interruptible_Consumption"] = "Interruptible_Consumption";
  CimBusinessTypeSvkEnum["Summarised_Market_Balance_Area_Schedule"] = "Summarised_Market_Balance_Area_Schedule";
  CimBusinessTypeSvkEnum["Load_Frequency_Control_Program_Schedule"] = "Load_Frequency_Control_Program_Schedule";
  CimBusinessTypeSvkEnum["Timeframe_Independent_Schedule"] = "Timeframe_Independent_Schedule";
  CimBusinessTypeSvkEnum["Consumption_Curtailment"] = "Consumption_Curtailment";
  CimBusinessTypeSvkEnum["Production_Dispatchable"] = "Production_Dispatchable";
  CimBusinessTypeSvkEnum["Consumption_Dispatchable"] = "Consumption_Dispatchable";
  CimBusinessTypeSvkEnum["Production_NonDispatchable"] = "Production_NonDispatchable";
  CimBusinessTypeSvkEnum["Consumption_NonDispatchable"] = "Consumption_NonDispatchable";
  CimBusinessTypeSvkEnum["Total_Transfer_Capacity"] = "Total_Transfer_Capacity";
  CimBusinessTypeSvkEnum["Mutual_Emergency_Assistance_Service"] = "Mutual_Emergency_Assistance_Service";
  CimBusinessTypeSvkEnum["Auction_Cancelation"] = "Auction_Cancelation";
  CimBusinessTypeSvkEnum["Nomination_Curtailment"] = "Nomination_Curtailment";
  CimBusinessTypeSvkEnum["Internal_Redispatch"] = "Internal_Redispatch";
  CimBusinessTypeSvkEnum["Control_Area_Balance_Energy"] = "Control_Area_Balance_Energy";
  CimBusinessTypeSvkEnum["Balancing_Energy_Price"] = "Balancing_Energy_Price";
  CimBusinessTypeSvkEnum["Economised_Secondary_Reserve"] = "Economised_Secondary_Reserve";
  CimBusinessTypeSvkEnum["Spinning_Reserve"] = "Spinning_Reserve";
  CimBusinessTypeSvkEnum["Solar"] = "Solar";
  CimBusinessTypeSvkEnum["positive_Forecast_Margin"] = "positive_Forecast_Margin";
  CimBusinessTypeSvkEnum["Negative_Forecast_Margin"] = "Negative_Forecast_Margin";
  CimBusinessTypeSvkEnum["Wind_Generation"] = "Wind_Generation";
  CimBusinessTypeSvkEnum["Solar_Generation"] = "Solar_Generation";
  CimBusinessTypeSvkEnum["Frequency_Containment_Reserve_A95"] = "Frequency_Containment_Reserve_A95";
  CimBusinessTypeSvkEnum["Automatic_Frequency_Restoration_Reserve"] = "Automatic_Frequency_Restoration_Reserve";
  CimBusinessTypeSvkEnum["Manual_Frequency_Restoration_Reserve"] = "Manual_Frequency_Restoration_Reserve";
  CimBusinessTypeSvkEnum["Replacement_Reserve"] = "Replacement_Reserve";
  CimBusinessTypeSvkEnum["Financial_Information"] = "Financial_Information";
  CimBusinessTypeSvkEnum["Interconnector_Network_Evolution"] = "Interconnector_Network_Evolution";
  CimBusinessTypeSvkEnum["Interconnector_Network_Dismantling"] = "Interconnector_Network_Dismantling";
  CimBusinessTypeSvkEnum["Counter_Trade"] = "Counter_Trade";
  CimBusinessTypeSvkEnum["Congestion_Costs"] = "Congestion_Costs";
  CimBusinessTypeSvkEnum["Capacity_Allocated_Including_Price"] = "Capacity_Allocated_Including_Price";
  CimBusinessTypeSvkEnum["DC_Link_Constraint"] = "DC_Link_Constraint";
  CimBusinessTypeSvkEnum["Auction_Revenue"] = "Auction_Revenue";
  CimBusinessTypeSvkEnum["Total_Nominated_Capacity"] = "Total_Nominated_Capacity";
  CimBusinessTypeSvkEnum["Net_Position"] = "Net_Position";
  CimBusinessTypeSvkEnum["Congestion_Income"] = "Congestion_Income";
  CimBusinessTypeSvkEnum["Production_Unit"] = "Production_Unit";
  CimBusinessTypeSvkEnum["Rounded_Market_Coupling_Results"] = "Rounded_Market_Coupling_Results";
  CimBusinessTypeSvkEnum["Allocation_Revenue"] = "Allocation_Revenue";
  CimBusinessTypeSvkEnum["Production_Deviation"] = "Production_Deviation";
  CimBusinessTypeSvkEnum["Consumption_Deviation"] = "Consumption_Deviation";
  CimBusinessTypeSvkEnum["Transmission_Asset"] = "Transmission_Asset";
  CimBusinessTypeSvkEnum["Consumption_Unit"] = "Consumption_Unit";
  CimBusinessTypeSvkEnum["InFeed_ATC"] = "InFeed_ATC";
  CimBusinessTypeSvkEnum["OutFeed_ATC"] = "OutFeed_ATC";
  CimBusinessTypeSvkEnum["Balance_Up_Regulation_Price"] = "Balance_Up_Regulation_Price";
  CimBusinessTypeSvkEnum["Balance_Down_Regulation_Price"] = "Balance_Down_Regulation_Price";
  CimBusinessTypeSvkEnum["Main_Direction"] = "Main_Direction";
  CimBusinessTypeSvkEnum["Consumption_Imbalance_Price"] = "Consumption_Imbalance_Price";
  CimBusinessTypeSvkEnum["Production_Sales_Imbalance_Price"] = "Production_Sales_Imbalance_Price";
  CimBusinessTypeSvkEnum["Production_Purchase_Imbalance_Price"] = "Production_Purchase_Imbalance_Price";
  CimBusinessTypeSvkEnum["Average_Balance_Price_Between_MBAs"] = "Average_Balance_Price_Between_MBAs";
  CimBusinessTypeSvkEnum["Pumped"] = "Pumped";
  CimBusinessTypeSvkEnum["Large_Installation_Consumption"] = "Large_Installation_Consumption";
  CimBusinessTypeSvkEnum["Metering_Grid_Area_Imbalance"] = "Metering_Grid_Area_Imbalance";
  CimBusinessTypeSvkEnum["HVDC_Link_Settings"] = "HVDC_Link_Settings";
  CimBusinessTypeSvkEnum["Transmission_Reliability_Margin"] = "Transmission_Reliability_Margin";
  CimBusinessTypeSvkEnum["Imbalance_Component_For_A_Pool"] = "Imbalance_Component_For_A_Pool";
  CimBusinessTypeSvkEnum["Area_Control_Error"] = "Area_Control_Error";
  CimBusinessTypeSvkEnum["Area_Control_Error_After_Imbalance_Netting"] = "Area_Control_Error_After_Imbalance_Netting";
  CimBusinessTypeSvkEnum["Implicit_And_Explicit_Trade_Total"] = "Implicit_And_Explicit_Trade_Total";
  CimBusinessTypeSvkEnum["Production_Units_Own_Consumption"] = "Production_Units_Own_Consumption";
  CimBusinessTypeSvkEnum["Constraint_Situation"] = "Constraint_Situation";
  CimBusinessTypeSvkEnum["Initial_Domain"] = "Initial_Domain";
  CimBusinessTypeSvkEnum["Flow_Based_Domain_Adjusted_To_Long_Term_Schedules"] = "Flow_Based_Domain_Adjusted_To_Long_Term_Schedules";
  CimBusinessTypeSvkEnum["Network_Element_Constraint"] = "Network_Element_Constraint";
  CimBusinessTypeSvkEnum["Calculation_Opposition"] = "Calculation_Opposition";
  CimBusinessTypeSvkEnum["Base_Case_Proportional_Shift_Key"] = "Base_Case_Proportional_Shift_Key";
  CimBusinessTypeSvkEnum["Proportional_To_Participation_Factors_Shift_Key"] = "Proportional_To_Participation_Factors_Shift_Key";
  CimBusinessTypeSvkEnum["Proportional_To_The_Remaining_Capacity_Shift_Key"] = "Proportional_To_The_Remaining_Capacity_Shift_Key";
  CimBusinessTypeSvkEnum["Merit_Order_Shift_Key"] = "Merit_Order_Shift_Key";
  CimBusinessTypeSvkEnum["Wind_Speed"] = "Wind_Speed";
  CimBusinessTypeSvkEnum["Wind_Direction"] = "Wind_Direction";
  CimBusinessTypeSvkEnum["Solar_Irradiance"] = "Solar_Irradiance";
  CimBusinessTypeSvkEnum["Air_Temperature"] = "Air_Temperature";
  CimBusinessTypeSvkEnum["Cloudiness"] = "Cloudiness";
  CimBusinessTypeSvkEnum["Air_Humidity"] = "Air_Humidity";
  CimBusinessTypeSvkEnum["Atmospheric_Pressure"] = "Atmospheric_Pressure";
  CimBusinessTypeSvkEnum["Precipitation"] = "Precipitation";
  CimBusinessTypeSvkEnum["Network_Constraint_Situation_That_Constraints_The_Market"] = "Network_Constraint_Situation_That_Constraints_The_Market";
  CimBusinessTypeSvkEnum["Contingency"] = "Contingency";
  CimBusinessTypeSvkEnum["Remedial_Action"] = "Remedial_Action";
  CimBusinessTypeSvkEnum["Monitored_Network_Element"] = "Monitored_Network_Element";
  CimBusinessTypeSvkEnum["Busbar"] = "Busbar";
  CimBusinessTypeSvkEnum["Network_Element"] = "Network_Element";
  CimBusinessTypeSvkEnum["SPS"] = "SPS";
  CimBusinessTypeSvkEnum["Aggregated_Netted_External_Market_Schedule"] = "Aggregated_Netted_External_Market_Schedule";
  CimBusinessTypeSvkEnum["Aggregated_Netted_External_TSO_Schedule"] = "Aggregated_Netted_External_TSO_Schedule";
  CimBusinessTypeSvkEnum["Aggregated_Netted_External_Schedule"] = "Aggregated_Netted_External_Schedule";
  CimBusinessTypeSvkEnum["Netted_Area_AC_Position"] = "Netted_Area_AC_Position";
  CimBusinessTypeSvkEnum["Netted_Area_Position"] = "Netted_Area_Position";
  CimBusinessTypeSvkEnum["Interconnection_Shift_Key"] = "Interconnection_Shift_Key";
  CimBusinessTypeSvkEnum["DC_Flow_With_Losses"] = "DC_Flow_With_Losses";
  CimBusinessTypeSvkEnum["DC_Flow_Without_Losses"] = "DC_Flow_Without_Losses";
  CimBusinessTypeSvkEnum["minimum_Value_Of_Netted_Area_Position"] = "minimum_Value_Of_Netted_Area_Position";
  CimBusinessTypeSvkEnum["maximum_Value_Of_Netted_Area_Position"] = "maximum_Value_Of_Netted_Area_Position";
  CimBusinessTypeSvkEnum["maximum_Value_Of_DC_Flow"] = "maximum_Value_Of_DC_Flow";
  CimBusinessTypeSvkEnum["minimum_Value_Of_DC_Flow"] = "minimum_Value_Of_DC_Flow";
  CimBusinessTypeSvkEnum["indicative_AC_Flow"] = "indicative_AC_Flow";
  CimBusinessTypeSvkEnum["Offer"] = "Offer";
  CimBusinessTypeSvkEnum["Need"] = "Need";
  CimBusinessTypeSvkEnum["Opportunity_Costs_Or_Benefits"] = "Opportunity_Costs_Or_Benefits";
  CimBusinessTypeSvkEnum["Financial_Compensation_Or_Penalties"] = "Financial_Compensation_Or_Penalties";
  CimBusinessTypeSvkEnum["Global_Radiation"] = "Global_Radiation";
  CimBusinessTypeSvkEnum["Diffuse_Radiation"] = "Diffuse_Radiation";
  CimBusinessTypeSvkEnum["Direct_Solar_Radiation"] = "Direct_Solar_Radiation";
  CimBusinessTypeSvkEnum["Outage"] = "Outage";
  CimBusinessTypeSvkEnum["Special_Switching_State"] = "Special_Switching_State";
  CimBusinessTypeSvkEnum["Testing"] = "Testing";
  CimBusinessTypeSvkEnum["Auxiliary_Busbar_Operation"] = "Auxiliary_Busbar_Operation";
  CimBusinessTypeSvkEnum["Automatic_Reclosing"] = "Automatic_Reclosing";
  CimBusinessTypeSvkEnum["Busbar_Protection"] = "Busbar_Protection";
  CimBusinessTypeSvkEnum["Phase_Shift_Angle"] = "Phase_Shift_Angle";
  CimBusinessTypeSvkEnum["Base_Case_Network_Situation"] = "Base_Case_Network_Situation";
  CimBusinessTypeSvkEnum["Inter_TSO_Assistance"] = "Inter_TSO_Assistance";
  CimBusinessTypeSvkEnum["FlexibleNeed"] = "FlexibleNeed";
  CimBusinessTypeSvkEnum["GLSK_Limitation"] = "GLSK_Limitation";
  CimBusinessTypeSvkEnum["Capacity_Ramping_Limitation"] = "Capacity_Ramping_Limitation";
  CimBusinessTypeSvkEnum["interconnector_Capacity"] = "interconnector_Capacity";
  CimBusinessTypeSvkEnum["Must_Run"] = "Must_Run";
  CimBusinessTypeSvkEnum["Procured_Capacity"] = "Procured_Capacity";
  CimBusinessTypeSvkEnum["Used_Capacity"] = "Used_Capacity";
  CimBusinessTypeSvkEnum["Estimated_Costs"] = "Estimated_Costs";
  CimBusinessTypeSvkEnum["Estimated_Benefits"] = "Estimated_Benefits";
  CimBusinessTypeSvkEnum["Load_Shedding"] = "Load_Shedding";
  CimBusinessTypeSvkEnum["Remaining_Capacity"] = "Remaining_Capacity";
  CimBusinessTypeSvkEnum["Indicator_Of_Generation_Capacity_Adequacy"] = "Indicator_Of_Generation_Capacity_Adequacy";
  CimBusinessTypeSvkEnum["Income_From_Price_Divergence_Without_Congestions"] = "Income_From_Price_Divergence_Without_Congestions";
  CimBusinessTypeSvkEnum["Push_Button"] = "Push_Button";
  CimBusinessTypeSvkEnum["Intertripping"] = "Intertripping";
  CimBusinessTypeSvkEnum["Emergency_Instruction"] = "Emergency_Instruction";
  CimBusinessTypeSvkEnum["Ramp_Management"] = "Ramp_Management";
  CimBusinessTypeSvkEnum["Profile_Smoothing"] = "Profile_Smoothing";
  CimBusinessTypeSvkEnum["Emergency_Reallocation_Deselection"] = "Emergency_Reallocation_Deselection";
  CimBusinessTypeSvkEnum["SO_SO_trade"] = "SO_SO_trade";
  CimBusinessTypeSvkEnum["Production_Reduction"] = "Production_Reduction";
  CimBusinessTypeSvkEnum["Maximum_Power_Exchange"] = "Maximum_Power_Exchange";
  CimBusinessTypeSvkEnum["Maximum_Power_Exchange_After_Remedial_Actions"] = "Maximum_Power_Exchange_After_Remedial_Actions";
  CimBusinessTypeSvkEnum["Network_Constraint_Situation_That_Cannot_Limit_The_Market"] = "Network_Constraint_Situation_That_Cannot_Limit_The_Market";
  CimBusinessTypeSvkEnum["Flat_Participation_For_All_Generators_Or_Loads"] = "Flat_Participation_For_All_Generators_Or_Loads";
  CimBusinessTypeSvkEnum["Proportional_To_Installed_Capacity_Of_Generators"] = "Proportional_To_Installed_Capacity_Of_Generators";
  CimBusinessTypeSvkEnum["Market_Price_And_Total_Volume"] = "Market_Price_And_Total_Volume";
  CimBusinessTypeSvkEnum["Import_Price"] = "Import_Price";
  CimBusinessTypeSvkEnum["Capacity_Allocated"] = "Capacity_Allocated";
  CimBusinessTypeSvkEnum["Common_Grid_Model_Equipment"] = "Common_Grid_Model_Equipment";
  CimBusinessTypeSvkEnum["Exchanged_Balancing_Reserve_Capacity"] = "Exchanged_Balancing_Reserve_Capacity";
  CimBusinessTypeSvkEnum["Shared_Balancing_Reserve_Capacity"] = "Shared_Balancing_Reserve_Capacity";
  CimBusinessTypeSvkEnum["Share_Of_Reserve_Capacity"] = "Share_Of_Reserve_Capacity";
  CimBusinessTypeSvkEnum["Actual_Reserve_Capacity"] = "Actual_Reserve_Capacity";
  CimBusinessTypeSvkEnum["K_factor"] = "K_factor";
  CimBusinessTypeSvkEnum["Frequency_Containment_Reserve_Normal"] = "Frequency_Containment_Reserve_Normal";
  CimBusinessTypeSvkEnum["Frequency_Containment_Reserve_Disturbance"] = "Frequency_Containment_Reserve_Disturbance";
  CimBusinessTypeSvkEnum["Internal_Trade_Difference"] = "Internal_Trade_Difference";
  CimBusinessTypeSvkEnum["Small_Scale_Production"] = "Small_Scale_Production";
  CimBusinessTypeSvkEnum["System_Price"] = "System_Price";
  CimBusinessTypeSvkEnum["Wind_Gust"] = "Wind_Gust";
  CimBusinessTypeSvkEnum["Area_Imbalance"] = "Area_Imbalance";
  CimBusinessTypeSvkEnum["Unintended_Energy_Price"] = "Unintended_Energy_Price";
  CimBusinessTypeSvkEnum["Frequency_Containment_Process_Energy"] = "Frequency_Containment_Process_Energy";
  CimBusinessTypeSvkEnum["Frequency_Containment_Process_Energy_Price"] = "Frequency_Containment_Process_Energy_Price";
  CimBusinessTypeSvkEnum["Ramping_Period_Energy"] = "Ramping_Period_Energy";
  CimBusinessTypeSvkEnum["Ramping_Period_Energy_Price"] = "Ramping_Period_Energy_Price";
  CimBusinessTypeSvkEnum["Frequency_Deviation"] = "Frequency_Deviation";
  CimBusinessTypeSvkEnum["Day_Ahead_Market_Price"] = "Day_Ahead_Market_Price";
  CimBusinessTypeSvkEnum["Conditional_Bid"] = "Conditional_Bid";
  CimBusinessTypeSvkEnum["Thermal_Limit"] = "Thermal_Limit";
  CimBusinessTypeSvkEnum["Frequency_Limit"] = "Frequency_Limit";
  CimBusinessTypeSvkEnum["Voltage_Limit"] = "Voltage_Limit";
  CimBusinessTypeSvkEnum["Current_Limit"] = "Current_Limit";
  CimBusinessTypeSvkEnum["Short_Circuit_Current_Limit"] = "Short_Circuit_Current_Limit";
  CimBusinessTypeSvkEnum["Dynamic_Stability_Limit"] = "Dynamic_Stability_Limit";
  CimBusinessTypeSvkEnum["Disconnection"] = "Disconnection";
  CimBusinessTypeSvkEnum["Intended_Energy_With_Positive_Price"] = "Intended_Energy_With_Positive_Price";
  CimBusinessTypeSvkEnum["Intended_Energy_With_Negative_Price"] = "Intended_Energy_With_Negative_Price";
  CimBusinessTypeSvkEnum["Decopuling"] = "Decopuling";
  CimBusinessTypeSvkEnum["Resource_Capacity_Unit"] = "Resource_Capacity_Unit";
  CimBusinessTypeSvkEnum["Resource_Entry_Capacity_Data"] = "Resource_Entry_Capacity_Data";
  CimBusinessTypeSvkEnum["Resource_Capacity_Obligation_Data"] = "Resource_Capacity_Obligation_Data";
  CimBusinessTypeSvkEnum["Available_Energy"] = "Available_Energy";
  CimBusinessTypeSvkEnum["Production_Curtailment"] = "Production_Curtailment";
  CimBusinessTypeSvkEnum["Rounding_Error"] = "Rounding_Error";
  CimBusinessTypeSvkEnum["Metered_Frequency"] = "Metered_Frequency";
  CimBusinessTypeSvkEnum["Adjusted_TTC_To_The_Nominal_Criteria"] = "Adjusted_TTC_To_The_Nominal_Criteria";
  CimBusinessTypeSvkEnum["Adjusted_TTC_To_The_Nominal_Criteria_With_TSOs_Limitation"] = "Adjusted_TTC_To_The_Nominal_Criteria_With_TSOs_Limitation";
  CimBusinessTypeSvkEnum["Frequency_Deviation_Larger_Than_Standard_Deviation"] = "Frequency_Deviation_Larger_Than_Standard_Deviation";
  CimBusinessTypeSvkEnum["Frequency_Deviation_Larger_Than_Maximum_Deviation"] = "Frequency_Deviation_Larger_Than_Maximum_Deviation";
  CimBusinessTypeSvkEnum["Frequency_Deviation_Not_Returned_To_50_Percent"] = "Frequency_Deviation_Not_Returned_To_50_Percent";
  CimBusinessTypeSvkEnum["Frequency_Deviation_Not_Returned_To_Restoration_Range"] = "Frequency_Deviation_Not_Returned_To_Restoration_Range";
  CimBusinessTypeSvkEnum["Frequency_Deviation_Outside_Recovery_Range"] = "Frequency_Deviation_Outside_Recovery_Range";
  CimBusinessTypeSvkEnum["Frequency"] = "Frequency";
  CimBusinessTypeSvkEnum["Mean_Value"] = "Mean_Value";
  CimBusinessTypeSvkEnum["Standard_Deviation"] = "Standard_Deviation";
  CimBusinessTypeSvkEnum["Percentile"] = "Percentile";
  CimBusinessTypeSvkEnum["Measured_Frequency_Resolution"] = "Measured_Frequency_Resolution";
  CimBusinessTypeSvkEnum["Accuracy"] = "Accuracy";
  CimBusinessTypeSvkEnum["FRCE_Outside_Level_1_Range"] = "FRCE_Outside_Level_1_Range";
  CimBusinessTypeSvkEnum["FRCE_Outside_Level_2_Range"] = "FRCE_Outside_Level_2_Range";
  CimBusinessTypeSvkEnum["FRCE_Exceeded_60_Percent_Of_FRR_Capacity"] = "FRCE_Exceeded_60_Percent_Of_FRR_Capacity";
  CimBusinessTypeSvkEnum["FRCE_Exceeded_Steady_State_Deviation"] = "FRCE_Exceeded_Steady_State_Deviation";
  CimBusinessTypeSvkEnum["FRCE_Calculation_And_Accuracy_Descriptor"] = "FRCE_Calculation_And_Accuracy_Descriptor";
  CimBusinessTypeSvkEnum["Forecasted_Capacity"] = "Forecasted_Capacity";
  CimBusinessTypeSvkEnum["Minimum_Available_Capacity"] = "Minimum_Available_Capacity";
  CimBusinessTypeSvkEnum["Average_Available_Capacity"] = "Average_Available_Capacity";
  CimBusinessTypeSvkEnum["Maximum_Available_Capacity"] = "Maximum_Available_Capacity";
  CimBusinessTypeSvkEnum["Frequency_And_Accuracy_Descriptor"] = "Frequency_And_Accuracy_Descriptor";
})(CimBusinessTypeSvkEnum = exports.CimBusinessTypeSvkEnum || (exports.CimBusinessTypeSvkEnum = {}));
var CimCodingSchemeTypeEnum;
(function (CimCodingSchemeTypeEnum) {
  CimCodingSchemeTypeEnum["NULL"] = "NULL";
  CimCodingSchemeTypeEnum["EIC"] = "EIC";
  CimCodingSchemeTypeEnum["GS1"] = "GS1";
  CimCodingSchemeTypeEnum["AndorraNationalCodingScheme"] = "AndorraNationalCodingScheme";
  CimCodingSchemeTypeEnum["AlbaniaNationalCodingScheme"] = "AlbaniaNationalCodingScheme";
  CimCodingSchemeTypeEnum["ArmeniaNationalCodingScheme"] = "ArmeniaNationalCodingScheme";
  CimCodingSchemeTypeEnum["AustriaNationalCodingScheme"] = "AustriaNationalCodingScheme";
  CimCodingSchemeTypeEnum["AzerbaijanNationalCodingScheme"] = "AzerbaijanNationalCodingScheme";
  CimCodingSchemeTypeEnum["BelgiumNationalCodingScheme"] = "BelgiumNationalCodingScheme";
  CimCodingSchemeTypeEnum["BosniaAndHerzegovinaNationalCodingScheme"] = "BosniaAndHerzegovinaNationalCodingScheme";
  CimCodingSchemeTypeEnum["BulgariaNationalCodingScheme"] = "BulgariaNationalCodingScheme";
  CimCodingSchemeTypeEnum["CroatiaNationalCodingScheme"] = "CroatiaNationalCodingScheme";
  CimCodingSchemeTypeEnum["CzechRepublicNationalCodingScheme"] = "CzechRepublicNationalCodingScheme";
  CimCodingSchemeTypeEnum["DenmarkNationalCodingScheme"] = "DenmarkNationalCodingScheme";
  CimCodingSchemeTypeEnum["EstoniaNationalCodingScheme"] = "EstoniaNationalCodingScheme";
  CimCodingSchemeTypeEnum["FinlandNationalCodingScheme"] = "FinlandNationalCodingScheme";
  CimCodingSchemeTypeEnum["FranceNationalCodingScheme"] = "FranceNationalCodingScheme";
  CimCodingSchemeTypeEnum["GeorgiaNationalCodingScheme"] = "GeorgiaNationalCodingScheme";
  CimCodingSchemeTypeEnum["GermanyNationalCodingScheme"] = "GermanyNationalCodingScheme";
  CimCodingSchemeTypeEnum["GibraltarNationalCodingScheme"] = "GibraltarNationalCodingScheme";
  CimCodingSchemeTypeEnum["GreeceNationalCodingScheme"] = "GreeceNationalCodingScheme";
  CimCodingSchemeTypeEnum["HungaryNationalCodingScheme"] = "HungaryNationalCodingScheme";
  CimCodingSchemeTypeEnum["IrelandNationalCodingScheme"] = "IrelandNationalCodingScheme";
  CimCodingSchemeTypeEnum["ItalyNationalCodingScheme"] = "ItalyNationalCodingScheme";
  CimCodingSchemeTypeEnum["KazakhstanNationalCodingScheme"] = "KazakhstanNationalCodingScheme";
  CimCodingSchemeTypeEnum["KyrgyzstanNationalCodingScheme"] = "KyrgyzstanNationalCodingScheme";
  CimCodingSchemeTypeEnum["LatviaNationalCodingScheme"] = "LatviaNationalCodingScheme";
  CimCodingSchemeTypeEnum["LiechtensteinNationalCodingScheme"] = "LiechtensteinNationalCodingScheme";
  CimCodingSchemeTypeEnum["lithuaniaNationalCodingScheme"] = "lithuaniaNationalCodingScheme";
  CimCodingSchemeTypeEnum["LuxembourgNationalCodingScheme"] = "LuxembourgNationalCodingScheme";
  CimCodingSchemeTypeEnum["MacedoniaNationalCodingScheme"] = "MacedoniaNationalCodingScheme";
  CimCodingSchemeTypeEnum["MoldaviaNationalCodingScheme"] = "MoldaviaNationalCodingScheme";
  CimCodingSchemeTypeEnum["MoroccoNationalCodingScheme"] = "MoroccoNationalCodingScheme";
  CimCodingSchemeTypeEnum["NetherlandsNationalCodingScheme"] = "NetherlandsNationalCodingScheme";
  CimCodingSchemeTypeEnum["NorwayNationalCodingScheme"] = "NorwayNationalCodingScheme";
  CimCodingSchemeTypeEnum["PolandNationalCodingScheme"] = "PolandNationalCodingScheme";
  CimCodingSchemeTypeEnum["PortugalNationalCodingScheme"] = "PortugalNationalCodingScheme";
  CimCodingSchemeTypeEnum["RomaniaNationalCodingScheme"] = "RomaniaNationalCodingScheme";
  CimCodingSchemeTypeEnum["RussianFederationNationalCodingScheme"] = "RussianFederationNationalCodingScheme";
  CimCodingSchemeTypeEnum["SerbiaAndMontenegroNationalCodingScheme"] = "SerbiaAndMontenegroNationalCodingScheme";
  CimCodingSchemeTypeEnum["SlovakiaNationalCodingScheme"] = "SlovakiaNationalCodingScheme";
  CimCodingSchemeTypeEnum["SloveniaNationalCodingScheme"] = "SloveniaNationalCodingScheme";
  CimCodingSchemeTypeEnum["SpainNationalCodingScheme"] = "SpainNationalCodingScheme";
  CimCodingSchemeTypeEnum["SwedenNationalCodingScheme"] = "SwedenNationalCodingScheme";
  CimCodingSchemeTypeEnum["SwitzerlandNationalCodingScheme"] = "SwitzerlandNationalCodingScheme";
  CimCodingSchemeTypeEnum["TurkeyNationalCodingScheme"] = "TurkeyNationalCodingScheme";
  CimCodingSchemeTypeEnum["UkraineNationalCodingScheme"] = "UkraineNationalCodingScheme";
  CimCodingSchemeTypeEnum["UnitedKingdomNationalCodingScheme"] = "UnitedKingdomNationalCodingScheme";
  CimCodingSchemeTypeEnum["NordicRegionalCodingScheme"] = "NordicRegionalCodingScheme";
})(CimCodingSchemeTypeEnum = exports.CimCodingSchemeTypeEnum || (exports.CimCodingSchemeTypeEnum = {}));
var CimContractTypeEnum;
(function (CimContractTypeEnum) {
  CimContractTypeEnum["Daily"] = "Daily";
  CimContractTypeEnum["Weekly"] = "Weekly";
  CimContractTypeEnum["Monthly"] = "Monthly";
  CimContractTypeEnum["Yearly"] = "Yearly";
  CimContractTypeEnum["Total"] = "Total";
  CimContractTypeEnum["LongTermContract"] = "LongTermContract";
  CimContractTypeEnum["IntradayContract"] = "IntradayContract";
  CimContractTypeEnum["QuarterYearly"] = "QuarterYearly";
  CimContractTypeEnum["Semestrial"] = "Semestrial";
  CimContractTypeEnum["MultipleYear"] = "MultipleYear";
  CimContractTypeEnum["IntradayBalancingMechanism"] = "IntradayBalancingMechanism";
  CimContractTypeEnum["HistoricalContract"] = "HistoricalContract";
  CimContractTypeEnum["Hourly"] = "Hourly";
})(CimContractTypeEnum = exports.CimContractTypeEnum || (exports.CimContractTypeEnum = {}));
var CimCurrencyTypeEnum;
(function (CimCurrencyTypeEnum) {
  CimCurrencyTypeEnum["NULL"] = "NULL";
  CimCurrencyTypeEnum["Bosnian_Convertible_Marka"] = "Bosnian_Convertible_Marka";
  CimCurrencyTypeEnum["Bulgarian_Lev"] = "Bulgarian_Lev";
  CimCurrencyTypeEnum["Swiss_Franc"] = "Swiss_Franc";
  CimCurrencyTypeEnum["Czech_Koruna"] = "Czech_Koruna";
  CimCurrencyTypeEnum["Danish_Kroner"] = "Danish_Kroner";
  CimCurrencyTypeEnum["EURO"] = "EURO";
  CimCurrencyTypeEnum["Pound_Sterling"] = "Pound_Sterling";
  CimCurrencyTypeEnum["Croatian_Kuna"] = "Croatian_Kuna";
  CimCurrencyTypeEnum["Hungarian_Forint"] = "Hungarian_Forint";
  CimCurrencyTypeEnum["Icelandic_Krona"] = "Icelandic_Krona";
  CimCurrencyTypeEnum["Albanian_Lek"] = "Albanian_Lek";
  CimCurrencyTypeEnum["Lithuanian_Litas"] = "Lithuanian_Litas";
  CimCurrencyTypeEnum["Macedonian_Denar"] = "Macedonian_Denar";
  CimCurrencyTypeEnum["Norwegian_Kroner"] = "Norwegian_Kroner";
  CimCurrencyTypeEnum["Polish_Zloty"] = "Polish_Zloty";
  CimCurrencyTypeEnum["Romanian_Leu"] = "Romanian_Leu";
  CimCurrencyTypeEnum["Serbian_Dinar"] = "Serbian_Dinar";
  CimCurrencyTypeEnum["Saudi_Arabian_Riyal"] = "Saudi_Arabian_Riyal";
  CimCurrencyTypeEnum["Swedish_Kroner"] = "Swedish_Kroner";
  CimCurrencyTypeEnum["Slovak_Koruna"] = "Slovak_Koruna";
  CimCurrencyTypeEnum["New_Turkish_Lira"] = "New_Turkish_Lira";
  CimCurrencyTypeEnum["Ukrainian_Hryvnia"] = "Ukrainian_Hryvnia";
  CimCurrencyTypeEnum["US_Dollar"] = "US_Dollar";
})(CimCurrencyTypeEnum = exports.CimCurrencyTypeEnum || (exports.CimCurrencyTypeEnum = {}));
var CimDirectionTypeEnum;
(function (CimDirectionTypeEnum) {
  CimDirectionTypeEnum["Up"] = "Up";
  CimDirectionTypeEnum["Down"] = "Down";
  CimDirectionTypeEnum["UpAndDown"] = "UpAndDown";
  CimDirectionTypeEnum["Stable"] = "Stable";
})(CimDirectionTypeEnum = exports.CimDirectionTypeEnum || (exports.CimDirectionTypeEnum = {}));
var CimDocumentTypeEnum;
(function (CimDocumentTypeEnum) {
  CimDocumentTypeEnum["BalanceResponsibleSchedule"] = "BalanceResponsibleSchedule";
  CimDocumentTypeEnum["AllocatedCapacitySchedule"] = "AllocatedCapacitySchedule";
  CimDocumentTypeEnum["BalanceAreaSchedule"] = "BalanceAreaSchedule";
  CimDocumentTypeEnum["SystemOperatorAreaSchedule"] = "SystemOperatorAreaSchedule";
  CimDocumentTypeEnum["ControlBlockAreaSchedule"] = "ControlBlockAreaSchedule";
  CimDocumentTypeEnum["CoordinationCenterAreaSchedule"] = "CoordinationCenterAreaSchedule";
  CimDocumentTypeEnum["IntermediateConfirmationReport"] = "IntermediateConfirmationReport";
  CimDocumentTypeEnum["FinalConfirmationReport"] = "FinalConfirmationReport";
  CimDocumentTypeEnum["FinalisedSchedule"] = "FinalisedSchedule";
  CimDocumentTypeEnum["RegulationDataReport"] = "RegulationDataReport";
  CimDocumentTypeEnum["AggregatedEnergyDataReport"] = "AggregatedEnergyDataReport";
  CimDocumentTypeEnum["ImbalanceReport"] = "ImbalanceReport";
  CimDocumentTypeEnum["InterconnectionCapacity"] = "InterconnectionCapacity";
  CimDocumentTypeEnum["ResourceProviderResourceSchedule"] = "ResourceProviderResourceSchedule";
  CimDocumentTypeEnum["AcquiringSystemOperatorReserveSchedule"] = "AcquiringSystemOperatorReserveSchedule";
  CimDocumentTypeEnum["AnomalyReport"] = "AnomalyReport";
  CimDocumentTypeEnum["AcknowledgementDocument"] = "AcknowledgementDocument";
  CimDocumentTypeEnum["ConfirmationReport"] = "ConfirmationReport";
  CimDocumentTypeEnum["CapacityForResale"] = "CapacityForResale";
  CimDocumentTypeEnum["ApprovedCapacityTransfer"] = "ApprovedCapacityTransfer";
  CimDocumentTypeEnum["CapacityTransferNotification"] = "CapacityTransferNotification";
  CimDocumentTypeEnum["TransmissionRightsPortfolio"] = "TransmissionRightsPortfolio";
  CimDocumentTypeEnum["Allocations"] = "Allocations";
  CimDocumentTypeEnum["BidDocument"] = "BidDocument";
  CimDocumentTypeEnum["AllocationResultDocument"] = "AllocationResultDocument";
  CimDocumentTypeEnum["CapacityDocument"] = "CapacityDocument";
  CimDocumentTypeEnum["RightsDocument"] = "RightsDocument";
  CimDocumentTypeEnum["GenerationAvailabilitySchedule"] = "GenerationAvailabilitySchedule";
  CimDocumentTypeEnum["CrossBorderSchedule"] = "CrossBorderSchedule";
  CimDocumentTypeEnum["AgreedCapacity"] = "AgreedCapacity";
  CimDocumentTypeEnum["ProposedCapacity"] = "ProposedCapacity";
  CimDocumentTypeEnum["SystemVerticalLoad"] = "SystemVerticalLoad";
  CimDocumentTypeEnum["EscalationDocument"] = "EscalationDocument";
  CimDocumentTypeEnum["TroubleShootingDocument"] = "TroubleShootingDocument";
  CimDocumentTypeEnum["DeactivationDocument"] = "DeactivationDocument";
  CimDocumentTypeEnum["ReserveTenderDocument"] = "ReserveTenderDocument";
  CimDocumentTypeEnum["ReserveAllocationResultDocument"] = "ReserveAllocationResultDocument";
  CimDocumentTypeEnum["SATCRActivation"] = "SATCRActivation";
  CimDocumentTypeEnum["DATCRActivation"] = "DATCRActivation";
  CimDocumentTypeEnum["ActivationResponse"] = "ActivationResponse";
  CimDocumentTypeEnum["TenderReduction"] = "TenderReduction";
  CimDocumentTypeEnum["MOLDocument"] = "MOLDocument";
  CimDocumentTypeEnum["PriceDocument"] = "PriceDocument";
  CimDocumentTypeEnum["MeasurementValueDocument"] = "MeasurementValueDocument";
  CimDocumentTypeEnum["SOAMDocument"] = "SOAMDocument";
  CimDocumentTypeEnum["SOVADocument"] = "SOVADocument";
  CimDocumentTypeEnum["CCVADocument"] = "CCVADocument";
  CimDocumentTypeEnum["DailySettlementDocument"] = "DailySettlementDocument";
  CimDocumentTypeEnum["WeeklySettlementDocument"] = "WeeklySettlementDocument";
  CimDocumentTypeEnum["CapacityAuctionSpecificationDocument"] = "CapacityAuctionSpecificationDocument";
  CimDocumentTypeEnum["MarketCouplingResultsDocument"] = "MarketCouplingResultsDocument";
  CimDocumentTypeEnum["OutagePublicationDocument"] = "OutagePublicationDocument";
  CimDocumentTypeEnum["ForcedGenerationOutageDocument"] = "ForcedGenerationOutageDocument";
  CimDocumentTypeEnum["SummarisedMarketSchedule"] = "SummarisedMarketSchedule";
  CimDocumentTypeEnum["CompensationProgramSchedule"] = "CompensationProgramSchedule";
  CimDocumentTypeEnum["LoadFrequencyControlProgramSchedule"] = "LoadFrequencyControlProgramSchedule";
  CimDocumentTypeEnum["TimeframeIndependentSchedule"] = "TimeframeIndependentSchedule";
  CimDocumentTypeEnum["StatusRequestForAStatusWithinAProcess"] = "StatusRequestForAStatusWithinAProcess";
  CimDocumentTypeEnum["StatusRequestForAPositionIndependentlyFromASpecificProcess"] = "StatusRequestForAPositionIndependentlyFromASpecificProcess";
  CimDocumentTypeEnum["EstimatedNetTransferCapacity"] = "EstimatedNetTransferCapacity";
  CimDocumentTypeEnum["CompensationRights"] = "CompensationRights";
  CimDocumentTypeEnum["RedispatchNotice"] = "RedispatchNotice";
  CimDocumentTypeEnum["TenderReductionResponse"] = "TenderReductionResponse";
  CimDocumentTypeEnum["SystemTotalLoad"] = "SystemTotalLoad";
  CimDocumentTypeEnum["FinalMOL"] = "FinalMOL";
  CimDocumentTypeEnum["ResourceProviderScheduleForProductionOrConsumption"] = "ResourceProviderScheduleForProductionOrConsumption";
})(CimDocumentTypeEnum = exports.CimDocumentTypeEnum || (exports.CimDocumentTypeEnum = {}));
var CimPowerUnitTypeEnum;
(function (CimPowerUnitTypeEnum) {
  CimPowerUnitTypeEnum["MegaWattHours"] = "MegaWattHours";
  CimPowerUnitTypeEnum["MegaWatt"] = "MegaWatt";
  CimPowerUnitTypeEnum["MegaVoltAmpereReactiveHours"] = "MegaVoltAmpereReactiveHours";
  CimPowerUnitTypeEnum["MegaVoltAmpereReactive"] = "MegaVoltAmpereReactive";
  CimPowerUnitTypeEnum["KiloWatt"] = "KiloWatt";
  CimPowerUnitTypeEnum["KiloWattHour"] = "KiloWattHour";
  CimPowerUnitTypeEnum["Percent"] = "Percent";
  CimPowerUnitTypeEnum["CubicMetre"] = "CubicMetre";
  CimPowerUnitTypeEnum["CubicMetresPerSecond"] = "CubicMetresPerSecond";
  CimPowerUnitTypeEnum["Metre"] = "Metre";
  CimPowerUnitTypeEnum["CubicHectometres"] = "CubicHectometres";
})(CimPowerUnitTypeEnum = exports.CimPowerUnitTypeEnum || (exports.CimPowerUnitTypeEnum = {}));
var CimProcessTypeStatnettEnum;
(function (CimProcessTypeStatnettEnum) {
  CimProcessTypeStatnettEnum["DayAhead"] = "DayAhead";
  CimProcessTypeStatnettEnum["IntraDayIncremental"] = "IntraDayIncremental";
  CimProcessTypeStatnettEnum["InterAreaTransit"] = "InterAreaTransit";
  CimProcessTypeStatnettEnum["SystemOperationClosure"] = "SystemOperationClosure";
  CimProcessTypeStatnettEnum["MeteredDataAggregation"] = "MeteredDataAggregation";
  CimProcessTypeStatnettEnum["ImbalanceSettlement"] = "ImbalanceSettlement";
  CimProcessTypeStatnettEnum["CapacityAllocation"] = "CapacityAllocation";
  CimProcessTypeStatnettEnum["CentralReconciliation"] = "CentralReconciliation";
  CimProcessTypeStatnettEnum["ReleasedCapacityAllocation"] = "ReleasedCapacityAllocation";
  CimProcessTypeStatnettEnum["ProposedCapacityAllocation"] = "ProposedCapacityAllocation";
  CimProcessTypeStatnettEnum["AgreedCapacityAllocation"] = "AgreedCapacityAllocation";
  CimProcessTypeStatnettEnum["LongTerm"] = "LongTerm";
  CimProcessTypeStatnettEnum["PostSchedulingAdjustment"] = "PostSchedulingAdjustment";
  CimProcessTypeStatnettEnum["Forecast"] = "Forecast";
  CimProcessTypeStatnettEnum["CapacityDetermination"] = "CapacityDetermination";
  CimProcessTypeStatnettEnum["Realised"] = "Realised";
  CimProcessTypeStatnettEnum["ScheduleDay"] = "ScheduleDay";
  CimProcessTypeStatnettEnum["IntraDayTotal"] = "IntraDayTotal";
  CimProcessTypeStatnettEnum["IntraDayAccumulated"] = "IntraDayAccumulated";
  CimProcessTypeStatnettEnum["SOMAProcess"] = "SOMAProcess";
  CimProcessTypeStatnettEnum["SOVMProcess"] = "SOVMProcess";
  CimProcessTypeStatnettEnum["RGCEAccountingProcess"] = "RGCEAccountingProcess";
  CimProcessTypeStatnettEnum["CCSRRGCESettlement"] = "CCSRRGCESettlement";
  CimProcessTypeStatnettEnum["CBSRSettlement"] = "CBSRSettlement";
  CimProcessTypeStatnettEnum["CASRSettlement"] = "CASRSettlement";
  CimProcessTypeStatnettEnum["OutageInformation"] = "OutageInformation";
  CimProcessTypeStatnettEnum["ReserveResourceProcess"] = "ReserveResourceProcess";
  CimProcessTypeStatnettEnum["PrimaryReserveProcess"] = "PrimaryReserveProcess";
  CimProcessTypeStatnettEnum["SecondaryReserveProcess"] = "SecondaryReserveProcess";
  CimProcessTypeStatnettEnum["TertiaryReserveProcess"] = "TertiaryReserveProcess";
})(CimProcessTypeStatnettEnum = exports.CimProcessTypeStatnettEnum || (exports.CimProcessTypeStatnettEnum = {}));
var CimProcessTypeSvkEnum;
(function (CimProcessTypeSvkEnum) {
  CimProcessTypeSvkEnum["Day_Ahead"] = "Day_Ahead";
  CimProcessTypeSvkEnum["Intra_Day_Incremental"] = "Intra_Day_Incremental";
  CimProcessTypeSvkEnum["InterArea_Transit"] = "InterArea_Transit";
  CimProcessTypeSvkEnum["System_Operation_Closure"] = "System_Operation_Closure";
  CimProcessTypeSvkEnum["Metered_Data_Aggregation"] = "Metered_Data_Aggregation";
  CimProcessTypeSvkEnum["Imbalance_Settlement"] = "Imbalance_Settlement";
  CimProcessTypeSvkEnum["Capacity_Allocation"] = "Capacity_Allocation";
  CimProcessTypeSvkEnum["Central_Reconciliation"] = "Central_Reconciliation";
  CimProcessTypeSvkEnum["Released_Capacity_Allocation"] = "Released_Capacity_Allocation";
  CimProcessTypeSvkEnum["Proposed_Capacity_Allocation"] = "Proposed_Capacity_Allocation";
  CimProcessTypeSvkEnum["Agreed_Capacity_Allocation"] = "Agreed_Capacity_Allocation";
  CimProcessTypeSvkEnum["Long_Term"] = "Long_Term";
  CimProcessTypeSvkEnum["Post_Scheduling_Adjustment"] = "Post_Scheduling_Adjustment";
  CimProcessTypeSvkEnum["Forecast"] = "Forecast";
  CimProcessTypeSvkEnum["Capacity_Determination"] = "Capacity_Determination";
  CimProcessTypeSvkEnum["Realised"] = "Realised";
  CimProcessTypeSvkEnum["Schedule_Day"] = "Schedule_Day";
  CimProcessTypeSvkEnum["Intraday_Total"] = "Intraday_Total";
  CimProcessTypeSvkEnum["Intraday_Accumulated"] = "Intraday_Accumulated";
  CimProcessTypeSvkEnum["SOMA_Process"] = "SOMA_Process";
  CimProcessTypeSvkEnum["SOVM_Process"] = "SOVM_Process";
  CimProcessTypeSvkEnum["RGCE_Accounting_Process"] = "RGCE_Accounting_Process";
  CimProcessTypeSvkEnum["CCSR_RGCE_Settlement"] = "CCSR_RGCE_Settlement";
  CimProcessTypeSvkEnum["CBSR_Settlement"] = "CBSR_Settlement";
  CimProcessTypeSvkEnum["CASR_Settlement"] = "CASR_Settlement";
  CimProcessTypeSvkEnum["Outage_Information"] = "Outage_Information";
  CimProcessTypeSvkEnum["Reserve_Resource_Process"] = "Reserve_Resource_Process";
  CimProcessTypeSvkEnum["Primary_Reserve_Process"] = "Primary_Reserve_Process";
  CimProcessTypeSvkEnum["Secondary_Reserve_Process"] = "Secondary_Reserve_Process";
  CimProcessTypeSvkEnum["Tertiary_Reserve_Process"] = "Tertiary_Reserve_Process";
  CimProcessTypeSvkEnum["Week_Ahead"] = "Week_Ahead";
  CimProcessTypeSvkEnum["Month_Ahead"] = "Month_Ahead";
  CimProcessTypeSvkEnum["Year_Ahead"] = "Year_Ahead";
  CimProcessTypeSvkEnum["Contracted"] = "Contracted";
  CimProcessTypeSvkEnum["Network_Information"] = "Network_Information";
  CimProcessTypeSvkEnum["Creation"] = "Creation";
  CimProcessTypeSvkEnum["Modification"] = "Modification";
  CimProcessTypeSvkEnum["Deactivation_Process"] = "Deactivation_Process";
  CimProcessTypeSvkEnum["Synchronisation_Process"] = "Synchronisation_Process";
  CimProcessTypeSvkEnum["Intraday_Process"] = "Intraday_Process";
  CimProcessTypeSvkEnum["Redispatch_Process"] = "Redispatch_Process";
  CimProcessTypeSvkEnum["Activation_History_Process"] = "Activation_History_Process";
  CimProcessTypeSvkEnum["Flow_Based_Domain_Constraint_DayAhead"] = "Flow_Based_Domain_Constraint_DayAhead";
  CimProcessTypeSvkEnum["Flow_Based_Domain_Constraint_Intraday"] = "Flow_Based_Domain_Constraint_Intraday";
  CimProcessTypeSvkEnum["Two_Days_Ahead"] = "Two_Days_Ahead";
  CimProcessTypeSvkEnum["Replacement_Reserve"] = "Replacement_Reserve";
  CimProcessTypeSvkEnum["Manual_Frequency_Restoration_Reserve"] = "Manual_Frequency_Restoration_Reserve";
  CimProcessTypeSvkEnum["DayAhead_Capacity_Determination"] = "DayAhead_Capacity_Determination";
  CimProcessTypeSvkEnum["Intraday_Capacity_Determination"] = "Intraday_Capacity_Determination";
  CimProcessTypeSvkEnum["Long_Term_Capacity_Determination"] = "Long_Term_Capacity_Determination";
  CimProcessTypeSvkEnum["Automatic_Frequency_Restoration_Reserve"] = "Automatic_Frequency_Restoration_Reserve";
  CimProcessTypeSvkEnum["Frequency_Containment_Reserve"] = "Frequency_Containment_Reserve";
  CimProcessTypeSvkEnum["Common_Grid_Model_Merging_Process"] = "Common_Grid_Model_Merging_Process";
  CimProcessTypeSvkEnum["Coordinated_Operational_Security_Analysis"] = "Coordinated_Operational_Security_Analysis";
  CimProcessTypeSvkEnum["Exchange_Of_Master_Data"] = "Exchange_Of_Master_Data";
  CimProcessTypeSvkEnum["Frequency_Restoration_Reserve"] = "Frequency_Restoration_Reserve";
  CimProcessTypeSvkEnum["FSKAR_Settlement"] = "FSKAR_Settlement";
  CimProcessTypeSvkEnum["Reserve_Option_Market"] = "Reserve_Option_Market";
  CimProcessTypeSvkEnum["Internal_Trade_Reporting"] = "Internal_Trade_Reporting";
  CimProcessTypeSvkEnum["Scheduled_Activation_MFRR"] = "Scheduled_Activation_MFRR";
  CimProcessTypeSvkEnum["Direct_Activation_MFRR"] = "Direct_Activation_MFRR";
  CimProcessTypeSvkEnum["Registration"] = "Registration";
  CimProcessTypeSvkEnum["Imbalance_Netting"] = "Imbalance_Netting";
  CimProcessTypeSvkEnum["Criteria_Application_For_Instantaneous_Frequency"] = "Criteria_Application_For_Instantaneous_Frequency";
  CimProcessTypeSvkEnum["Criteria_Application_For_Frequency_Restoration"] = "Criteria_Application_For_Frequency_Restoration";
})(CimProcessTypeSvkEnum = exports.CimProcessTypeSvkEnum || (exports.CimProcessTypeSvkEnum = {}));
var CimProductTypeEnum;
(function (CimProductTypeEnum) {
  CimProductTypeEnum["Standard_Balancing_Product"] = "Standard_Balancing_Product";
  CimProductTypeEnum["Specific_Balancing_Product"] = "Specific_Balancing_Product";
  CimProductTypeEnum["Product_From_Integrated_Scheduling_Process"] = "Product_From_Integrated_Scheduling_Process";
  CimProductTypeEnum["Local_Balancing_Product"] = "Local_Balancing_Product";
  CimProductTypeEnum["Standard_MFRR_Product_Eligible_For_Scheduled_Activation"] = "Standard_MFRR_Product_Eligible_For_Scheduled_Activation";
  CimProductTypeEnum["Standard_MFRR_Product_Eligible_For_Direct_Activation"] = "Standard_MFRR_Product_Eligible_For_Direct_Activation";
  CimProductTypeEnum["Standard_MFRR_Product_Eligible_For_Direct_And_Scheduled_Activation"] = "Standard_MFRR_Product_Eligible_For_Direct_And_Scheduled_Activation";
  CimProductTypeEnum["Market_Wide_Resource_Capacity_Mechanism"] = "Market_Wide_Resource_Capacity_Mechanism";
  CimProductTypeEnum["Strategic_Reserve_Resource_Capacity_Mechanism"] = "Strategic_Reserve_Resource_Capacity_Mechanism";
  CimProductTypeEnum["Other_Resource_Capacity_Mechanism"] = "Other_Resource_Capacity_Mechanism";
})(CimProductTypeEnum = exports.CimProductTypeEnum || (exports.CimProductTypeEnum = {}));
var CimReasonTypeEnum;
(function (CimReasonTypeEnum) {
  CimReasonTypeEnum["ErrorsNotSpecificallyIdentified"] = "ErrorsNotSpecificallyIdentified";
  CimReasonTypeEnum["MessageFullyAccepted"] = "MessageFullyAccepted";
  CimReasonTypeEnum["MessageFullyRejected"] = "MessageFullyRejected";
  CimReasonTypeEnum["MessageContainsErrorsAtTheTimeSeriesLevel"] = "MessageContainsErrorsAtTheTimeSeriesLevel";
  CimReasonTypeEnum["TimeIntervalIncorrect"] = "TimeIntervalIncorrect";
  CimReasonTypeEnum["SenderWithoutValidContract"] = "SenderWithoutValidContract";
  CimReasonTypeEnum["ScheduleAccepted"] = "ScheduleAccepted";
  CimReasonTypeEnum["SchedulePartiallyAccepted"] = "SchedulePartiallyAccepted";
  CimReasonTypeEnum["ScheduleRejected"] = "ScheduleRejected";
  CimReasonTypeEnum["TimeSeriesNotMatching"] = "TimeSeriesNotMatching";
  CimReasonTypeEnum["CreditLimitExceeded"] = "CreditLimitExceeded";
  CimReasonTypeEnum["TimeSeriesFullyRejected"] = "TimeSeriesFullyRejected";
  CimReasonTypeEnum["TimeSeriesAcceptedWithSpecificTimeIntervalErrors"] = "TimeSeriesAcceptedWithSpecificTimeIntervalErrors";
  CimReasonTypeEnum["InPartyOrOutPartyInvalid"] = "InPartyOrOutPartyInvalid";
  CimReasonTypeEnum["AreaInvalid"] = "AreaInvalid";
  CimReasonTypeEnum["A24NotApplicable"] = "A24NotApplicable";
  CimReasonTypeEnum["A25NotApplicable"] = "A25NotApplicable";
  CimReasonTypeEnum["DefaultTimeSeriesApplied"] = "DefaultTimeSeriesApplied";
  CimReasonTypeEnum["CrossBorderCapacityExceeded"] = "CrossBorderCapacityExceeded";
  CimReasonTypeEnum["CounterpartTimeSeriesMissing"] = "CounterpartTimeSeriesMissing";
  CimReasonTypeEnum["CounterpartTimeSeriesQuantityDifferences"] = "CounterpartTimeSeriesQuantityDifferences";
  CimReasonTypeEnum["ImposedTimeSeriesFromNominatedPartysTimeSeries"] = "ImposedTimeSeriesFromNominatedPartysTimeSeries";
  CimReasonTypeEnum["ResolutionInconsistency"] = "ResolutionInconsistency";
  CimReasonTypeEnum["QuantityInconsistency"] = "QuantityInconsistency";
  CimReasonTypeEnum["QuantityIncreased"] = "QuantityIncreased";
  CimReasonTypeEnum["QuantityDecreased"] = "QuantityDecreased";
  CimReasonTypeEnum["DefaultQuantityApplied"] = "DefaultQuantityApplied";
  CimReasonTypeEnum["QuantitiesMustNotBeSignedValues"] = "QuantitiesMustNotBeSignedValues";
  CimReasonTypeEnum["A47NotApplicable"] = "A47NotApplicable";
  CimReasonTypeEnum["ModificationReason"] = "ModificationReason";
  CimReasonTypeEnum["PositionInconsistency"] = "PositionInconsistency";
  CimReasonTypeEnum["SendersTimeSeriesVersionConflict"] = "SendersTimeSeriesVersionConflict";
  CimReasonTypeEnum["MessageIdentificationOrVersionConflict"] = "MessageIdentificationOrVersionConflict";
  CimReasonTypeEnum["TimeSeriesMissingFromNewVersionOfMessage"] = "TimeSeriesMissingFromNewVersionOfMessage";
  CimReasonTypeEnum["ReceivingPartyIncorrect"] = "ReceivingPartyIncorrect";
  CimReasonTypeEnum["GlobalPositionNotInBalance"] = "GlobalPositionNotInBalance";
  CimReasonTypeEnum["TimeSeriesIdentificationConflict"] = "TimeSeriesIdentificationConflict";
  CimReasonTypeEnum["CorrespondingTimeSeriesNotNetted"] = "CorrespondingTimeSeriesNotNetted";
  CimReasonTypeEnum["DeadlineLimitExceededOrGateNotOpen"] = "DeadlineLimitExceededOrGateNotOpen";
  CimReasonTypeEnum["OneToOneNominationInconsistency"] = "OneToOneNominationInconsistency";
  CimReasonTypeEnum["NotCompliantToLocalMarketRules"] = "NotCompliantToLocalMarketRules";
  CimReasonTypeEnum["InterAreaTransitScheduleExceedsNominatedSchedule"] = "InterAreaTransitScheduleExceedsNominatedSchedule";
  CimReasonTypeEnum["CurrencyInvalid"] = "CurrencyInvalid";
  CimReasonTypeEnum["InvalidBusinessType"] = "InvalidBusinessType";
  CimReasonTypeEnum["TimeSeriesModified"] = "TimeSeriesModified";
  CimReasonTypeEnum["ResourceObjectInvalid"] = "ResourceObjectInvalid";
  CimReasonTypeEnum["ReserveObjectTechnicalLimitsExceeded"] = "ReserveObjectTechnicalLimitsExceeded";
  CimReasonTypeEnum["PlannedReservesDoNotCorrespondWithContractualData"] = "PlannedReservesDoNotCorrespondWithContractualData";
  CimReasonTypeEnum["LimitDataIsNotAvailable"] = "LimitDataIsNotAvailable";
  CimReasonTypeEnum["ReserveObjectNotQualifiedForReserveType"] = "ReserveObjectNotQualifiedForReserveType";
  CimReasonTypeEnum["MandatoryAttributesMissing"] = "MandatoryAttributesMissing";
  CimReasonTypeEnum["Curtailment"] = "Curtailment";
  CimReasonTypeEnum["LinkedBidRejectedDueToAssociatedBidUnsuccessful"] = "LinkedBidRejectedDueToAssociatedBidUnsuccessful";
  CimReasonTypeEnum["OriginalBidDividedToPermitAcceptance"] = "OriginalBidDividedToPermitAcceptance";
  CimReasonTypeEnum["BidAccepted"] = "BidAccepted";
  CimReasonTypeEnum["AuctionStatus"] = "AuctionStatus";
  CimReasonTypeEnum["RightStatusInformation"] = "RightStatusInformation";
  CimReasonTypeEnum["AgreementIdentificationInconsistency"] = "AgreementIdentificationInconsistency";
  CimReasonTypeEnum["DependencyMatrixNotRespected"] = "DependencyMatrixNotRespected";
  CimReasonTypeEnum["SenderIdentificationAndOrorRoleInvalid"] = "SenderIdentificationAndOrorRoleInvalid";
  CimReasonTypeEnum["ProcessTypeInvalid"] = "ProcessTypeInvalid";
  CimReasonTypeEnum["DomainInvalid"] = "DomainInvalid";
  CimReasonTypeEnum["MatchingPeriodInvalid"] = "MatchingPeriodInvalid";
  CimReasonTypeEnum["InOrOutAreaInconsistentWithDomain"] = "InOrOutAreaInconsistentWithDomain";
  CimReasonTypeEnum["DisagreeWithMatchingResults"] = "DisagreeWithMatchingResults";
  CimReasonTypeEnum["ConfirmationIgnoredDueToHigherVersionAlreadyReceived"] = "ConfirmationIgnoredDueToHigherVersionAlreadyReceived";
  CimReasonTypeEnum["ConfirmationWithoutAdjustment"] = "ConfirmationWithoutAdjustment";
  CimReasonTypeEnum["ConfirmationWithAdjustment"] = "ConfirmationWithAdjustment";
  CimReasonTypeEnum["ForAction"] = "ForAction";
  CimReasonTypeEnum["TimeSeriesMatched"] = "TimeSeriesMatched";
  CimReasonTypeEnum["TimeSeriesIgnored"] = "TimeSeriesIgnored";
  CimReasonTypeEnum["ModificationProposal"] = "ModificationProposal";
  CimReasonTypeEnum["ExpectedDocumentNotReceived"] = "ExpectedDocumentNotReceived";
  CimReasonTypeEnum["NotPossibleToSendDocumentOnTimeButEstimatedDeliveryTimeIsProvided"] = "NotPossibleToSendDocumentOnTimeButEstimatedDeliveryTimeIsProvided";
  CimReasonTypeEnum["NotPossibleToSendDocumentOnTimeAndFurthermoreNoExpectedTimeOfReturnToNormalSituation"] = "NotPossibleToSendDocumentOnTimeAndFurthermoreNoExpectedTimeOfReturnToNormalSituation";
  CimReasonTypeEnum["DocumentCannotBeProcessedByReceivingSystem"] = "DocumentCannotBeProcessedByReceivingSystem";
  CimReasonTypeEnum["ComplementaryInformation"] = "ComplementaryInformation";
  CimReasonTypeEnum["TechnicalConstraint"] = "TechnicalConstraint";
  CimReasonTypeEnum["ForceMajeureCurtailment"] = "ForceMajeureCurtailment";
  CimReasonTypeEnum["NetworkSecurityCurtailment"] = "NetworkSecurityCurtailment";
  CimReasonTypeEnum["AuctionCancelled"] = "AuctionCancelled";
  CimReasonTypeEnum["IncompleteDocument"] = "IncompleteDocument";
  CimReasonTypeEnum["AccountingPointTimeSeriesMissing"] = "AccountingPointTimeSeriesMissing";
  CimReasonTypeEnum["MeterDataTimeSeriesMissing"] = "MeterDataTimeSeriesMissing";
  CimReasonTypeEnum["EstimatedValuesNotAllowedInFirstTransmission"] = "EstimatedValuesNotAllowedInFirstTransmission";
  CimReasonTypeEnum["NoQuantityValuesAllowedForAQualityThatIsNotAvailable"] = "NoQuantityValuesAllowedForAQualityThatIsNotAvailable";
  CimReasonTypeEnum["TimeSeriesAccepted"] = "TimeSeriesAccepted";
  CimReasonTypeEnum["AuctionWithoutBidsBeingEntered"] = "AuctionWithoutBidsBeingEntered";
  CimReasonTypeEnum["DataNotYetAvailable"] = "DataNotYetAvailable";
  CimReasonTypeEnum["BidNotAccepted"] = "BidNotAccepted";
  CimReasonTypeEnum["InitiatorAreaProblem"] = "InitiatorAreaProblem";
  CimReasonTypeEnum["CooperatingAreaProblem"] = "CooperatingAreaProblem";
  CimReasonTypeEnum["CommunicationStatusCurrentlyActive"] = "CommunicationStatusCurrentlyActive";
  CimReasonTypeEnum["CommunicationStatusCurrentlyInactive"] = "CommunicationStatusCurrentlyInactive";
  CimReasonTypeEnum["CommunicationStatusCurrentlyRestricted"] = "CommunicationStatusCurrentlyRestricted";
  CimReasonTypeEnum["ProblemAssociatedWithBothAreas"] = "ProblemAssociatedWithBothAreas";
  CimReasonTypeEnum["TenderUnavailableInMOLList"] = "TenderUnavailableInMOLList";
  CimReasonTypeEnum["PriceBasedOnPreliminaryExchangeRate"] = "PriceBasedOnPreliminaryExchangeRate";
  CimReasonTypeEnum["Failure"] = "Failure";
  CimReasonTypeEnum["ForeseenMaintenance"] = "ForeseenMaintenance";
  CimReasonTypeEnum["Shutdown"] = "Shutdown";
  CimReasonTypeEnum["OfficialExchangeRateApproved"] = "OfficialExchangeRateApproved";
  CimReasonTypeEnum["SystemRegulation"] = "SystemRegulation";
  CimReasonTypeEnum["FrequencyRegulation"] = "FrequencyRegulation";
  CimReasonTypeEnum["LoadFlowOverload"] = "LoadFlowOverload";
  CimReasonTypeEnum["VoltageLevelAdjustment"] = "VoltageLevelAdjustment";
  CimReasonTypeEnum["EmergencySituationCurtailment"] = "EmergencySituationCurtailment";
  CimReasonTypeEnum["CalculationProcessFailed"] = "CalculationProcessFailed";
  CimReasonTypeEnum["NoCapacityConstraintImpactOnTheMarket"] = "NoCapacityConstraintImpactOnTheMarket";
  CimReasonTypeEnum["SpecialCondition"] = "SpecialCondition";
  CimReasonTypeEnum["Unverified"] = "Unverified";
  CimReasonTypeEnum["Verified"] = "Verified";
  CimReasonTypeEnum["CGMInconsistency"] = "CGMInconsistency";
  CimReasonTypeEnum["NetworkDictionaryInconsistency"] = "NetworkDictionaryInconsistency";
  CimReasonTypeEnum["CapacityReducedByTSO"] = "CapacityReducedByTSO";
  CimReasonTypeEnum["Overload"] = "Overload";
  CimReasonTypeEnum["GLSKLimitation"] = "GLSKLimitation";
  CimReasonTypeEnum["VoltageConstraint"] = "VoltageConstraint";
  CimReasonTypeEnum["AngleConstraint"] = "AngleConstraint";
  CimReasonTypeEnum["Stability"] = "Stability";
  CimReasonTypeEnum["LoadflowDivergence"] = "LoadflowDivergence";
  CimReasonTypeEnum["ExclusionForSoSReasons"] = "ExclusionForSoSReasons";
  CimReasonTypeEnum["ConstraintByTheMarket"] = "ConstraintByTheMarket";
  CimReasonTypeEnum["Ordinary"] = "Ordinary";
  CimReasonTypeEnum["Exceptional"] = "Exceptional";
  CimReasonTypeEnum["OutOfRange"] = "OutOfRange";
  CimReasonTypeEnum["InternalCongestion"] = "InternalCongestion";
  CimReasonTypeEnum["OperationalSecurityConstraints"] = "OperationalSecurityConstraints";
  CimReasonTypeEnum["EstimatedValue"] = "EstimatedValue";
  CimReasonTypeEnum["Balancing"] = "Balancing";
  CimReasonTypeEnum["ValuesShared"] = "ValuesShared";
  CimReasonTypeEnum["OutsidePriceLimits"] = "OutsidePriceLimits";
  CimReasonTypeEnum["PreviousTimeframeData"] = "PreviousTimeframeData";
  CimReasonTypeEnum["MOLMergingSuccesful"] = "MOLMergingSuccesful";
  CimReasonTypeEnum["MOLMergingFailed"] = "MOLMergingFailed";
  CimReasonTypeEnum["BecauseOfRedispatching"] = "BecauseOfRedispatching";
  CimReasonTypeEnum["BecauseOfCountertrading"] = "BecauseOfCountertrading";
  CimReasonTypeEnum["BecauseOfOtherRemedialAction"] = "BecauseOfOtherRemedialAction";
  CimReasonTypeEnum["InsufficiencyOfReserves"] = "InsufficiencyOfReserves";
  CimReasonTypeEnum["UnavailabilityOfReserveProvidingUnit"] = "UnavailabilityOfReserveProvidingUnit";
  CimReasonTypeEnum["UnavailabilityOfAutomaticProtectionSystems"] = "UnavailabilityOfAutomaticProtectionSystems";
  CimReasonTypeEnum["PhysicalCableOrConverterRestrictions"] = "PhysicalCableOrConverterRestrictions";
  CimReasonTypeEnum["ConstraintsInControllerSystems"] = "ConstraintsInControllerSystems";
  CimReasonTypeEnum["AdjustedBecauseOfExpectedViolationOfOperationalSecurity"] = "AdjustedBecauseOfExpectedViolationOfOperationalSecurity";
  CimReasonTypeEnum["AdjustedBecauseAlreadyConsideredRemedialActionsAreAssessedAsNotSufficient"] = "AdjustedBecauseAlreadyConsideredRemedialActionsAreAssessedAsNotSufficient";
  CimReasonTypeEnum["TimeSeriesPartiallyAccepted"] = "TimeSeriesPartiallyAccepted";
})(CimReasonTypeEnum = exports.CimReasonTypeEnum || (exports.CimReasonTypeEnum = {}));
var CimRoleTypeStatnettEnum;
(function (CimRoleTypeStatnettEnum) {
  CimRoleTypeStatnettEnum["TradeResponsibleParty"] = "TradeResponsibleParty";
  CimRoleTypeStatnettEnum["ConsumptionResponsibleParty"] = "ConsumptionResponsibleParty";
  CimRoleTypeStatnettEnum["CombinedPowerExchange"] = "CombinedPowerExchange";
  CimRoleTypeStatnettEnum["SystemOperator"] = "SystemOperator";
  CimRoleTypeStatnettEnum["ImbalanceSettlementResponsible"] = "ImbalanceSettlementResponsible";
  CimRoleTypeStatnettEnum["ProductionResponsibleParty"] = "ProductionResponsibleParty";
  CimRoleTypeStatnettEnum["TransmissionCapacityAllocator"] = "TransmissionCapacityAllocator";
  CimRoleTypeStatnettEnum["BalanceResponsibleParty"] = "BalanceResponsibleParty";
  CimRoleTypeStatnettEnum["MeteredDataAggregator"] = "MeteredDataAggregator";
  CimRoleTypeStatnettEnum["BillingAgent"] = "BillingAgent";
  CimRoleTypeStatnettEnum["MarketOperator"] = "MarketOperator";
  CimRoleTypeStatnettEnum["BalanceSupplier"] = "BalanceSupplier";
  CimRoleTypeStatnettEnum["Consumer"] = "Consumer";
  CimRoleTypeStatnettEnum["ControlAreaOperator"] = "ControlAreaOperator";
  CimRoleTypeStatnettEnum["ControlBlockOperator"] = "ControlBlockOperator";
  CimRoleTypeStatnettEnum["CoordinationCenterOperator"] = "CoordinationCenterOperator";
  CimRoleTypeStatnettEnum["GridAccessProvider"] = "GridAccessProvider";
  CimRoleTypeStatnettEnum["GridOperator"] = "GridOperator";
  CimRoleTypeStatnettEnum["MeterAdministrator"] = "MeterAdministrator";
  CimRoleTypeStatnettEnum["PartyConnectedToGrid"] = "PartyConnectedToGrid";
  CimRoleTypeStatnettEnum["Producer"] = "Producer";
  CimRoleTypeStatnettEnum["ProfileMaintenanceParty"] = "ProfileMaintenanceParty";
  CimRoleTypeStatnettEnum["MeterOperator"] = "MeterOperator";
  CimRoleTypeStatnettEnum["MeteredDataCollector"] = "MeteredDataCollector";
  CimRoleTypeStatnettEnum["MeteredDataResponsible"] = "MeteredDataResponsible";
  CimRoleTypeStatnettEnum["MeteringPointAdministrator"] = "MeteringPointAdministrator";
  CimRoleTypeStatnettEnum["ResourceProvider"] = "ResourceProvider";
  CimRoleTypeStatnettEnum["SchedulingCoordinator"] = "SchedulingCoordinator";
  CimRoleTypeStatnettEnum["CapacityTrader"] = "CapacityTrader";
  CimRoleTypeStatnettEnum["InterconnectionTradeResponsible"] = "InterconnectionTradeResponsible";
  CimRoleTypeStatnettEnum["NominationValidator"] = "NominationValidator";
  CimRoleTypeStatnettEnum["MarketInformationAggregator"] = "MarketInformationAggregator";
  CimRoleTypeStatnettEnum["InformationReceiver"] = "InformationReceiver";
  CimRoleTypeStatnettEnum["ReserveAllocator"] = "ReserveAllocator";
  CimRoleTypeStatnettEnum["MOLResponsible"] = "MOLResponsible";
  CimRoleTypeStatnettEnum["CapacityCoordinator"] = "CapacityCoordinator";
  CimRoleTypeStatnettEnum["ReconciliationAccountable"] = "ReconciliationAccountable";
  CimRoleTypeStatnettEnum["ReconciliationResponsible"] = "ReconciliationResponsible";
})(CimRoleTypeStatnettEnum = exports.CimRoleTypeStatnettEnum || (exports.CimRoleTypeStatnettEnum = {}));
var CimRoleTypeSvkEnum;
(function (CimRoleTypeSvkEnum) {
  CimRoleTypeSvkEnum["Trade_Responsible_Party"] = "Trade_Responsible_Party";
  CimRoleTypeSvkEnum["Consumption_Responsible_Party"] = "Consumption_Responsible_Party";
  CimRoleTypeSvkEnum["Combined_Power_Exchange"] = "Combined_Power_Exchange";
  CimRoleTypeSvkEnum["System_Operator"] = "System_Operator";
  CimRoleTypeSvkEnum["Imbalance_Settlement_Responsible"] = "Imbalance_Settlement_Responsible";
  CimRoleTypeSvkEnum["Production_Responsible_Party"] = "Production_Responsible_Party";
  CimRoleTypeSvkEnum["Transmission_Capacity_Allocator"] = "Transmission_Capacity_Allocator";
  CimRoleTypeSvkEnum["Balance_Responsible_Party"] = "Balance_Responsible_Party";
  CimRoleTypeSvkEnum["Metered_Data_Aggregator"] = "Metered_Data_Aggregator";
  CimRoleTypeSvkEnum["Billing_Agent"] = "Billing_Agent";
  CimRoleTypeSvkEnum["Market_Operator"] = "Market_Operator";
  CimRoleTypeSvkEnum["Balance_Supplier"] = "Balance_Supplier";
  CimRoleTypeSvkEnum["Consumer"] = "Consumer";
  CimRoleTypeSvkEnum["Control_Area_Operator"] = "Control_Area_Operator";
  CimRoleTypeSvkEnum["Control_Block_Operator"] = "Control_Block_Operator";
  CimRoleTypeSvkEnum["Coordination_Centre_Operator"] = "Coordination_Centre_Operator";
  CimRoleTypeSvkEnum["Grid_Access_Provider"] = "Grid_Access_Provider";
  CimRoleTypeSvkEnum["Grid_Operator"] = "Grid_Operator";
  CimRoleTypeSvkEnum["Meter_Administrator"] = "Meter_Administrator";
  CimRoleTypeSvkEnum["Party_Connected_To_Grid"] = "Party_Connected_To_Grid";
  CimRoleTypeSvkEnum["Producer"] = "Producer";
  CimRoleTypeSvkEnum["Profile_Maintenance_Party"] = "Profile_Maintenance_Party";
  CimRoleTypeSvkEnum["Meter_Operator"] = "Meter_Operator";
  CimRoleTypeSvkEnum["Metered_Data_Collector"] = "Metered_Data_Collector";
  CimRoleTypeSvkEnum["Metered_Data_Responsible"] = "Metered_Data_Responsible";
  CimRoleTypeSvkEnum["Metering_Point_Administrator"] = "Metering_Point_Administrator";
  CimRoleTypeSvkEnum["Resource_Provider"] = "Resource_Provider";
  CimRoleTypeSvkEnum["Scheduling_Coordinator"] = "Scheduling_Coordinator";
  CimRoleTypeSvkEnum["Capacity_Trader"] = "Capacity_Trader";
  CimRoleTypeSvkEnum["Interconnection_Trade_Responsible"] = "Interconnection_Trade_Responsible";
  CimRoleTypeSvkEnum["Nomination_Validator"] = "Nomination_Validator";
  CimRoleTypeSvkEnum["Market_Information_Aggregator"] = "Market_Information_Aggregator";
  CimRoleTypeSvkEnum["Information_Receiver"] = "Information_Receiver";
  CimRoleTypeSvkEnum["Reserve_Allocator"] = "Reserve_Allocator";
  CimRoleTypeSvkEnum["MOL_Responsible"] = "MOL_Responsible";
  CimRoleTypeSvkEnum["Capacity_Coordinator"] = "Capacity_Coordinator";
  CimRoleTypeSvkEnum["Reconciliation_Accountable"] = "Reconciliation_Accountable";
  CimRoleTypeSvkEnum["Reconciliation_Responsible"] = "Reconciliation_Responsible";
  CimRoleTypeSvkEnum["Data_Provider"] = "Data_Provider";
  CimRoleTypeSvkEnum["Local_Issuing_Office"] = "Local_Issuing_Office";
  CimRoleTypeSvkEnum["Central_Issuing_Office"] = "Central_Issuing_Office";
  CimRoleTypeSvkEnum["EIC_Participant"] = "EIC_Participant";
  CimRoleTypeSvkEnum["Weather_Analyser"] = "Weather_Analyser";
  CimRoleTypeSvkEnum["Regional_Security_Coordinator"] = "Regional_Security_Coordinator";
  CimRoleTypeSvkEnum["Energy_Service_Company"] = "Energy_Service_Company";
  CimRoleTypeSvkEnum["Balancing_Service_Provider"] = "Balancing_Service_Provider";
  CimRoleTypeSvkEnum["Energy_Trader"] = "Energy_Trader";
  CimRoleTypeSvkEnum["LFC_Operator"] = "LFC_Operator";
  CimRoleTypeSvkEnum["Transmission_System_Operator"] = "Transmission_System_Operator";
  CimRoleTypeSvkEnum["Distribution_System_Operator"] = "Distribution_System_Operator";
  CimRoleTypeSvkEnum["Resource_Capacity_Mechanism_Operator"] = "Resource_Capacity_Mechanism_Operator";
})(CimRoleTypeSvkEnum = exports.CimRoleTypeSvkEnum || (exports.CimRoleTypeSvkEnum = {}));
var CimStatusTypeStatnettEnum;
(function (CimStatusTypeStatnettEnum) {
  CimStatusTypeStatnettEnum["Intermediate"] = "Intermediate";
  CimStatusTypeStatnettEnum["Final"] = "Final";
  CimStatusTypeStatnettEnum["Deactivated"] = "Deactivated";
  CimStatusTypeStatnettEnum["Reactivated"] = "Reactivated";
  CimStatusTypeStatnettEnum["Active"] = "Active";
  CimStatusTypeStatnettEnum["Available"] = "Available";
  CimStatusTypeStatnettEnum["Activated"] = "Activated";
  CimStatusTypeStatnettEnum["InProcess"] = "InProcess";
  CimStatusTypeStatnettEnum["Cancelled"] = "Cancelled";
  CimStatusTypeStatnettEnum["Ordered"] = "Ordered";
  CimStatusTypeStatnettEnum["NoLongerAvailable"] = "NoLongerAvailable";
  CimStatusTypeStatnettEnum["RGCEAgreed"] = "RGCEAgreed";
  CimStatusTypeStatnettEnum["Modified"] = "Modified";
})(CimStatusTypeStatnettEnum = exports.CimStatusTypeStatnettEnum || (exports.CimStatusTypeStatnettEnum = {}));
var CimStatusTypeSvkEnum;
(function (CimStatusTypeSvkEnum) {
  CimStatusTypeSvkEnum["Intermediate"] = "Intermediate";
  CimStatusTypeSvkEnum["Final"] = "Final";
  CimStatusTypeSvkEnum["Deactivated"] = "Deactivated";
  CimStatusTypeSvkEnum["Reactivated"] = "Reactivated";
  CimStatusTypeSvkEnum["Active"] = "Active";
  CimStatusTypeSvkEnum["Available"] = "Available";
  CimStatusTypeSvkEnum["Activated"] = "Activated";
  CimStatusTypeSvkEnum["In_Process"] = "In_Process";
  CimStatusTypeSvkEnum["Cancelled"] = "Cancelled";
  CimStatusTypeSvkEnum["Ordered"] = "Ordered";
  CimStatusTypeSvkEnum["Unavailable"] = "Unavailable";
  CimStatusTypeSvkEnum["RGCE_Agreed"] = "RGCE_Agreed";
  CimStatusTypeSvkEnum["Withdrawn"] = "Withdrawn";
  CimStatusTypeSvkEnum["Creation"] = "Creation";
  CimStatusTypeSvkEnum["Update"] = "Update";
  CimStatusTypeSvkEnum["Deactivation"] = "Deactivation";
  CimStatusTypeSvkEnum["Reactivation"] = "Reactivation";
  CimStatusTypeSvkEnum["Preventive"] = "Preventive";
  CimStatusTypeSvkEnum["Curative"] = "Curative";
  CimStatusTypeSvkEnum["Automatic"] = "Automatic";
  CimStatusTypeSvkEnum["Open"] = "Open";
  CimStatusTypeSvkEnum["Close"] = "Close";
  CimStatusTypeSvkEnum["Stop"] = "Stop";
  CimStatusTypeSvkEnum["Start"] = "Start";
  CimStatusTypeSvkEnum["Relative"] = "Relative";
  CimStatusTypeSvkEnum["Absolute"] = "Absolute";
  CimStatusTypeSvkEnum["Curative_Or_Preventive"] = "Curative_Or_Preventive";
  CimStatusTypeSvkEnum["Unshared_Bid"] = "Unshared_Bid";
  CimStatusTypeSvkEnum["Pre_Processed"] = "Pre_Processed";
  CimStatusTypeSvkEnum["Substituted"] = "Substituted";
  CimStatusTypeSvkEnum["Modified"] = "Modified";
  CimStatusTypeSvkEnum["Result"] = "Result";
  CimStatusTypeSvkEnum["Not_Satisfied"] = "Not_Satisfied";
  CimStatusTypeSvkEnum["Rejected"] = "Rejected";
  CimStatusTypeSvkEnum["Preliminary"] = "Preliminary";
  CimStatusTypeSvkEnum["Planned"] = "Planned";
  CimStatusTypeSvkEnum["Confirmed"] = "Confirmed";
  CimStatusTypeSvkEnum["Shall_Be_Used"] = "Shall_Be_Used";
  CimStatusTypeSvkEnum["Could_Be_Used"] = "Could_Be_Used";
  CimStatusTypeSvkEnum["Proposed"] = "Proposed";
  CimStatusTypeSvkEnum["Individual_Network_Data"] = "Individual_Network_Data";
  CimStatusTypeSvkEnum["Common_Network_Data"] = "Common_Network_Data";
  CimStatusTypeSvkEnum["Setpoint_Schedule"] = "Setpoint_Schedule";
  CimStatusTypeSvkEnum["Proportional_External_Signal"] = "Proportional_External_Signal";
  CimStatusTypeSvkEnum["AC_Emulation"] = "AC_Emulation";
  CimStatusTypeSvkEnum["Importing_Element"] = "Importing_Element";
  CimStatusTypeSvkEnum["Exporting_Element"] = "Exporting_Element";
  CimStatusTypeSvkEnum["To_Be_Optimized"] = "To_Be_Optimized";
  CimStatusTypeSvkEnum["To_Be_Monitored"] = "To_Be_Monitored";
  CimStatusTypeSvkEnum["To_Be_Included_In_Capacity_Calculation"] = "To_Be_Included_In_Capacity_Calculation";
  CimStatusTypeSvkEnum["Relative_To_Previous_Point_In_Time"] = "Relative_To_Previous_Point_In_Time";
  CimStatusTypeSvkEnum["For_Flow_Optimization"] = "For_Flow_Optimization";
  CimStatusTypeSvkEnum["For_Voltage_Optimization"] = "For_Voltage_Optimization";
  CimStatusTypeSvkEnum["Presolved"] = "Presolved";
  CimStatusTypeSvkEnum["Not_Available_If_Linked_Bid_Activated"] = "Not_Available_If_Linked_Bid_Activated";
  CimStatusTypeSvkEnum["Not_Available_If_Linked_Bid_Rejected"] = "Not_Available_If_Linked_Bid_Rejected";
  CimStatusTypeSvkEnum["Not_Available_For_DA_If_Linked_Bid_Subject_To_DA"] = "Not_Available_For_DA_If_Linked_Bid_Subject_To_DA";
  CimStatusTypeSvkEnum["Not_Available_For_DA_If_Linked_Bid_Subject_To_SA"] = "Not_Available_For_DA_If_Linked_Bid_Subject_To_SA";
  CimStatusTypeSvkEnum["Not_Available_If_Linked_Bid_Subject_To_SA"] = "Not_Available_If_Linked_Bid_Subject_To_SA";
  CimStatusTypeSvkEnum["Not_Available_If_Linked_Bid_Subject_To_DA"] = "Not_Available_If_Linked_Bid_Subject_To_DA";
  CimStatusTypeSvkEnum["Primary_Market"] = "Primary_Market";
  CimStatusTypeSvkEnum["Secondary_Market"] = "Secondary_Market";
  CimStatusTypeSvkEnum["Interesting"] = "Interesting";
  CimStatusTypeSvkEnum["Relevant"] = "Relevant";
  CimStatusTypeSvkEnum["Conditionally_Available"] = "Conditionally_Available";
  CimStatusTypeSvkEnum["Conditionally_Unavailable"] = "Conditionally_Unavailable";
  CimStatusTypeSvkEnum["Available_If_Linked_Bid_Activated"] = "Available_If_Linked_Bid_Activated";
  CimStatusTypeSvkEnum["Available_If_Linked_Bid_Rejected"] = "Available_If_Linked_Bid_Rejected";
  CimStatusTypeSvkEnum["Available_If_Linked_Bid_Subject_To_SA"] = "Available_If_Linked_Bid_Subject_To_SA";
  CimStatusTypeSvkEnum["Available_If_Linked_Bid_Subject_To_DA"] = "Available_If_Linked_Bid_Subject_To_DA";
  CimStatusTypeSvkEnum["Available_For_DA_If_Linked_Bid_Subject_To_DA"] = "Available_For_DA_If_Linked_Bid_Subject_To_DA";
  CimStatusTypeSvkEnum["Available_For_DA_If_Linked_Bid_Subject_To_SA"] = "Available_For_DA_If_Linked_Bid_Subject_To_SA";
})(CimStatusTypeSvkEnum = exports.CimStatusTypeSvkEnum || (exports.CimStatusTypeSvkEnum = {}));
var CimTimeSeriesCurveTypeEnum;
(function (CimTimeSeriesCurveTypeEnum) {
  CimTimeSeriesCurveTypeEnum["SequentialFixedSizeBlock"] = "SequentialFixedSizeBlock";
  CimTimeSeriesCurveTypeEnum["Point"] = "Point";
  CimTimeSeriesCurveTypeEnum["VariableSizedBlock"] = "VariableSizedBlock";
  CimTimeSeriesCurveTypeEnum["OverlappingBreakpoint"] = "OverlappingBreakpoint";
  CimTimeSeriesCurveTypeEnum["NonOverlappingBreakpoint"] = "NonOverlappingBreakpoint";
})(CimTimeSeriesCurveTypeEnum = exports.CimTimeSeriesCurveTypeEnum || (exports.CimTimeSeriesCurveTypeEnum = {}));
var FeatureFlagsEnum;
(function (FeatureFlagsEnum) {
  FeatureFlagsEnum["EnableEon"] = "EnableEon";
  FeatureFlagsEnum["EnableSvkMffr"] = "EnableSvkMffr";
  FeatureFlagsEnum["CheckForTradesWhenImportingBaselines"] = "CheckForTradesWhenImportingBaselines";
  FeatureFlagsEnum["SaveReceivedOrdersBeforeForwarding"] = "SaveReceivedOrdersBeforeForwarding";
  FeatureFlagsEnum["AllowUseEmbeddingSearch"] = "AllowUseEmbeddingSearch";
  FeatureFlagsEnum["ScheduleSettlementCalculationOnKafka"] = "ScheduleSettlementCalculationOnKafka";
  FeatureFlagsEnum["ScheduleLongflexOrderGenerationOnKafka"] = "ScheduleLongflexOrderGenerationOnKafka";
  FeatureFlagsEnum["AllowMarketOwnersToTriggerAuctions"] = "AllowMarketOwnersToTriggerAuctions";
})(FeatureFlagsEnum = exports.FeatureFlagsEnum || (exports.FeatureFlagsEnum = {}));
var FlexibilityTypeEnum;
(function (FlexibilityTypeEnum) {
  FlexibilityTypeEnum["ContractedLongflex"] = "ContractedLongflex";
  FlexibilityTypeEnum["AvailableShortflex"] = "AvailableShortflex";
  FlexibilityTypeEnum["TradedShortflex"] = "TradedShortflex";
  FlexibilityTypeEnum["ShortflexPrognosis"] = "ShortflexPrognosis";
  FlexibilityTypeEnum["ActualLoad"] = "ActualLoad";
  FlexibilityTypeEnum["LoadPrognosis"] = "LoadPrognosis";
  FlexibilityTypeEnum["Baseline"] = "Baseline";
})(FlexibilityTypeEnum = exports.FlexibilityTypeEnum || (exports.FlexibilityTypeEnum = {}));
var AllowedToBuyEnum;
(function (AllowedToBuyEnum) {
  AllowedToBuyEnum["All"] = "All";
  AllowedToBuyEnum["DsoAndTso"] = "DsoAndTso";
  AllowedToBuyEnum["OnlyPermitted"] = "OnlyPermitted";
})(AllowedToBuyEnum = exports.AllowedToBuyEnum || (exports.AllowedToBuyEnum = {}));
var AllowedToSellEnum;
(function (AllowedToSellEnum) {
  AllowedToSellEnum["All"] = "All";
  AllowedToSellEnum["OnlyPermitted"] = "OnlyPermitted";
})(AllowedToSellEnum = exports.AllowedToSellEnum || (exports.AllowedToSellEnum = {}));
var BaselineProviderEnum;
(function (BaselineProviderEnum) {
  BaselineProviderEnum["AssetHub"] = "AssetHub";
  BaselineProviderEnum["Nodes"] = "Nodes";
  BaselineProviderEnum["NodesTradeCorrected"] = "NodesTradeCorrected";
  BaselineProviderEnum["NodesMeterBefore"] = "NodesMeterBefore";
  BaselineProviderEnum["NodesMeterBeforeAfter"] = "NodesMeterBeforeAfter";
  BaselineProviderEnum["ManualImport"] = "ManualImport";
  BaselineProviderEnum["FlexHub"] = "FlexHub";
  BaselineProviderEnum["Kiwi"] = "Kiwi";
  BaselineProviderEnum["Ena"] = "Ena";
})(BaselineProviderEnum = exports.BaselineProviderEnum || (exports.BaselineProviderEnum = {}));
var BillingPolicyEnum;
(function (BillingPolicyEnum) {
  BillingPolicyEnum["NODES"] = "NODES";
  BillingPolicyEnum["Direct"] = "Direct";
})(BillingPolicyEnum = exports.BillingPolicyEnum || (exports.BillingPolicyEnum = {}));
var ColumnDataTypeEnum;
(function (ColumnDataTypeEnum) {
  ColumnDataTypeEnum["Timestamp"] = "Timestamp";
  ColumnDataTypeEnum["Percentage"] = "Percentage";
  ColumnDataTypeEnum["Amount"] = "Amount";
  ColumnDataTypeEnum["MegaWatt"] = "MegaWatt";
  ColumnDataTypeEnum["Count"] = "Count";
  ColumnDataTypeEnum["CountOfEntries"] = "CountOfEntries";
  ColumnDataTypeEnum["Seconds"] = "Seconds";
  ColumnDataTypeEnum["Text"] = "Text";
  ColumnDataTypeEnum["LinkArray"] = "LinkArray";
})(ColumnDataTypeEnum = exports.ColumnDataTypeEnum || (exports.ColumnDataTypeEnum = {}));
var ContractCalculationRuleEnum;
(function (ContractCalculationRuleEnum) {
  ContractCalculationRuleEnum["Rule1"] = "Rule1";
  ContractCalculationRuleEnum["Rule2"] = "Rule2";
  ContractCalculationRuleEnum["Rule3"] = "Rule3";
  ContractCalculationRuleEnum["Rule4"] = "Rule4";
  ContractCalculationRuleEnum["Rule5"] = "Rule5";
  ContractCalculationRuleEnum["Rule6"] = "Rule6";
  ContractCalculationRuleEnum["MaxUsage1"] = "MaxUsage1";
})(ContractCalculationRuleEnum = exports.ContractCalculationRuleEnum || (exports.ContractCalculationRuleEnum = {}));
var ContractTypeEnum;
(function (ContractTypeEnum) {
  ContractTypeEnum["LongFlex"] = "LongFlex";
  ContractTypeEnum["MaxUsage"] = "MaxUsage";
})(ContractTypeEnum = exports.ContractTypeEnum || (exports.ContractTypeEnum = {}));
var CounterOrderPolicyEnum;
(function (CounterOrderPolicyEnum) {
  CounterOrderPolicyEnum["Default"] = "Default";
  CounterOrderPolicyEnum["ActivateWhenMatched"] = "ActivateWhenMatched";
})(CounterOrderPolicyEnum = exports.CounterOrderPolicyEnum || (exports.CounterOrderPolicyEnum = {}));
var DateCalculationBaseEnum;
(function (DateCalculationBaseEnum) {
  DateCalculationBaseEnum["PeriodFrom"] = "PeriodFrom";
  DateCalculationBaseEnum["PeriodTo"] = "PeriodTo";
})(DateCalculationBaseEnum = exports.DateCalculationBaseEnum || (exports.DateCalculationBaseEnum = {}));
var EventTypeEnum;
(function (EventTypeEnum) {
  EventTypeEnum["TradeCreated"] = "TradeCreated";
  EventTypeEnum["IspGateClosed"] = "IspGateClosed";
  EventTypeEnum["MarketMessagePosted"] = "MarketMessagePosted";
  EventTypeEnum["AssetGridAssignmentsPendingApproval"] = "AssetGridAssignmentsPendingApproval";
  EventTypeEnum["AssetGridAssignmentsUpdated"] = "AssetGridAssignmentsUpdated";
  EventTypeEnum["ContractResponseSubmitted"] = "ContractResponseSubmitted";
  EventTypeEnum["ContractResponseApproved"] = "ContractResponseApproved";
  EventTypeEnum["ContractResponseRejected"] = "ContractResponseRejected";
  EventTypeEnum["DomainObjectCreated"] = "DomainObjectCreated";
  EventTypeEnum["DomainObjectUpdated"] = "DomainObjectUpdated";
})(EventTypeEnum = exports.EventTypeEnum || (exports.EventTypeEnum = {}));
var FillTypeEnum;
(function (FillTypeEnum) {
  FillTypeEnum["Normal"] = "Normal";
  FillTypeEnum["FillAndKill"] = "FillAndKill";
  FillTypeEnum["FillOrKill"] = "FillOrKill";
})(FillTypeEnum = exports.FillTypeEnum || (exports.FillTypeEnum = {}));
var GridNodePolygonVisibilityEnum;
(function (GridNodePolygonVisibilityEnum) {
  GridNodePolygonVisibilityEnum["Private"] = "Private";
  GridNodePolygonVisibilityEnum["Public"] = "Public";
  GridNodePolygonVisibilityEnum["PublicIfTender"] = "PublicIfTender";
  GridNodePolygonVisibilityEnum["PublicIfFlexZone"] = "PublicIfFlexZone";
  GridNodePolygonVisibilityEnum["PublicIfTenderOrFlexZone"] = "PublicIfTenderOrFlexZone";
})(GridNodePolygonVisibilityEnum = exports.GridNodePolygonVisibilityEnum || (exports.GridNodePolygonVisibilityEnum = {}));
var InvoiceChannelEnum;
(function (InvoiceChannelEnum) {
  InvoiceChannelEnum["Email"] = "Email";
  InvoiceChannelEnum["Ehf"] = "Ehf";
})(InvoiceChannelEnum = exports.InvoiceChannelEnum || (exports.InvoiceChannelEnum = {}));
var InvoiceFileTypeEnum;
(function (InvoiceFileTypeEnum) {
  InvoiceFileTypeEnum["InvoicePdf"] = "InvoicePdf";
  InvoiceFileTypeEnum["InvoiceJson"] = "InvoiceJson";
  InvoiceFileTypeEnum["InvoiceAttachment"] = "InvoiceAttachment";
  InvoiceFileTypeEnum["SettlementNotePdf"] = "SettlementNotePdf";
  InvoiceFileTypeEnum["SettlementNoteJson"] = "SettlementNoteJson";
  InvoiceFileTypeEnum["SettlementNoteAttachment"] = "SettlementNoteAttachment";
  InvoiceFileTypeEnum["CreditNotePdf"] = "CreditNotePdf";
  InvoiceFileTypeEnum["CreditNoteJson"] = "CreditNoteJson";
  InvoiceFileTypeEnum["CreditNoteAttachment"] = "CreditNoteAttachment";
})(InvoiceFileTypeEnum = exports.InvoiceFileTypeEnum || (exports.InvoiceFileTypeEnum = {}));
var IspGateClosedPolicyEnum;
(function (IspGateClosedPolicyEnum) {
  IspGateClosedPolicyEnum["AggregateToTSO"] = "AggregateToTSO";
})(IspGateClosedPolicyEnum = exports.IspGateClosedPolicyEnum || (exports.IspGateClosedPolicyEnum = {}));
var MarketPermissionTypeEnum;
(function (MarketPermissionTypeEnum) {
  MarketPermissionTypeEnum["PlaceBuyOrder"] = "PlaceBuyOrder";
  MarketPermissionTypeEnum["PlaceSellOrder"] = "PlaceSellOrder";
})(MarketPermissionTypeEnum = exports.MarketPermissionTypeEnum || (exports.MarketPermissionTypeEnum = {}));
var MarketStatisticTypeEnum;
(function (MarketStatisticTypeEnum) {
  MarketStatisticTypeEnum["Shortflex"] = "Shortflex";
  MarketStatisticTypeEnum["MaxUsage"] = "MaxUsage";
  MarketStatisticTypeEnum["Longflex"] = "Longflex";
})(MarketStatisticTypeEnum = exports.MarketStatisticTypeEnum || (exports.MarketStatisticTypeEnum = {}));
var MaxUsageLimitTypeEnum;
(function (MaxUsageLimitTypeEnum) {
  MaxUsageLimitTypeEnum["Volume"] = "Volume";
  MaxUsageLimitTypeEnum["Percentage"] = "Percentage";
})(MaxUsageLimitTypeEnum = exports.MaxUsageLimitTypeEnum || (exports.MaxUsageLimitTypeEnum = {}));
var MeterReadingProviderEnum;
(function (MeterReadingProviderEnum) {
  MeterReadingProviderEnum["AssetHub"] = "AssetHub";
  MeterReadingProviderEnum["MMS"] = "MMS";
  MeterReadingProviderEnum["FlexHub"] = "FlexHub";
  MeterReadingProviderEnum["Kiwi"] = "Kiwi";
})(MeterReadingProviderEnum = exports.MeterReadingProviderEnum || (exports.MeterReadingProviderEnum = {}));
var MeterReadingsAggregationLevelEnum;
(function (MeterReadingsAggregationLevelEnum) {
  MeterReadingsAggregationLevelEnum["AssetPortfolio"] = "AssetPortfolio";
  MeterReadingsAggregationLevelEnum["Asset"] = "Asset";
  MeterReadingsAggregationLevelEnum["MPID"] = "MPID";
})(MeterReadingsAggregationLevelEnum = exports.MeterReadingsAggregationLevelEnum || (exports.MeterReadingsAggregationLevelEnum = {}));
var MfrrAckStatusTypeEnum;
(function (MfrrAckStatusTypeEnum) {
  MfrrAckStatusTypeEnum["Acknowledged"] = "Acknowledged";
  MfrrAckStatusTypeEnum["Rejected"] = "Rejected";
})(MfrrAckStatusTypeEnum = exports.MfrrAckStatusTypeEnum || (exports.MfrrAckStatusTypeEnum = {}));
var MfrrEndpointTypeEnum;
(function (MfrrEndpointTypeEnum) {
  MfrrEndpointTypeEnum["Statnett"] = "Statnett";
  MfrrEndpointTypeEnum["Svk"] = "Svk";
})(MfrrEndpointTypeEnum = exports.MfrrEndpointTypeEnum || (exports.MfrrEndpointTypeEnum = {}));
var MfrrMessageTypeEnum;
(function (MfrrMessageTypeEnum) {
  MfrrMessageTypeEnum["Quote"] = "Quote";
  MfrrMessageTypeEnum["QuoteAck"] = "QuoteAck";
  MfrrMessageTypeEnum["ActivationRequest"] = "ActivationRequest";
  MfrrMessageTypeEnum["ActivationRequestAck"] = "ActivationRequestAck";
  MfrrMessageTypeEnum["ActivationApproval"] = "ActivationApproval";
  MfrrMessageTypeEnum["ActivationApprovalAck"] = "ActivationApprovalAck";
  MfrrMessageTypeEnum["BidWithdrawal"] = "BidWithdrawal";
  MfrrMessageTypeEnum["BidWithdrawalAck"] = "BidWithdrawalAck";
  MfrrMessageTypeEnum["ActivationCancellationRequest"] = "ActivationCancellationRequest";
  MfrrMessageTypeEnum["ActivationCancellationRequestAck"] = "ActivationCancellationRequestAck";
  MfrrMessageTypeEnum["ActivationCancellationApproval"] = "ActivationCancellationApproval";
  MfrrMessageTypeEnum["ActivationCancellationApprovalAck"] = "ActivationCancellationApprovalAck";
  MfrrMessageTypeEnum["ActivationUpdateRequest"] = "ActivationUpdateRequest";
  MfrrMessageTypeEnum["ActivationUpdateRequestAck"] = "ActivationUpdateRequestAck";
  MfrrMessageTypeEnum["ActivationUpdateApproval"] = "ActivationUpdateApproval";
  MfrrMessageTypeEnum["ActivationUpdateApprovalAck"] = "ActivationUpdateApprovalAck";
  MfrrMessageTypeEnum["RejectionAck"] = "RejectionAck";
})(MfrrMessageTypeEnum = exports.MfrrMessageTypeEnum || (exports.MfrrMessageTypeEnum = {}));
var NotificationTypeEnum;
(function (NotificationTypeEnum) {
  NotificationTypeEnum["Sms"] = "Sms";
  NotificationTypeEnum["Email"] = "Email";
  NotificationTypeEnum["HttpGet"] = "HttpGet";
  NotificationTypeEnum["HttpPost"] = "HttpPost";
  NotificationTypeEnum["MfrrStatnett"] = "MfrrStatnett";
  NotificationTypeEnum["MfrrSvk"] = "MfrrSvk";
  NotificationTypeEnum["Kafka"] = "Kafka";
})(NotificationTypeEnum = exports.NotificationTypeEnum || (exports.NotificationTypeEnum = {}));
var OrderCompletionTypeEnum;
(function (OrderCompletionTypeEnum) {
  OrderCompletionTypeEnum["Filled"] = "Filled";
  OrderCompletionTypeEnum["Killed"] = "Killed";
  OrderCompletionTypeEnum["Cancelled"] = "Cancelled";
  OrderCompletionTypeEnum["Expired"] = "Expired";
  OrderCompletionTypeEnum["Rejected"] = "Rejected";
  OrderCompletionTypeEnum["Blocked"] = "Blocked";
})(OrderCompletionTypeEnum = exports.OrderCompletionTypeEnum || (exports.OrderCompletionTypeEnum = {}));
var OrderSideEnum;
(function (OrderSideEnum) {
  OrderSideEnum["Buy"] = "Buy";
  OrderSideEnum["Sell"] = "Sell";
})(OrderSideEnum = exports.OrderSideEnum || (exports.OrderSideEnum = {}));
var OrderVisibilityEnum;
(function (OrderVisibilityEnum) {
  OrderVisibilityEnum["Public"] = "Public";
  OrderVisibilityEnum["Private"] = "Private";
  OrderVisibilityEnum["DsoAndTso"] = "DsoAndTso";
})(OrderVisibilityEnum = exports.OrderVisibilityEnum || (exports.OrderVisibilityEnum = {}));
var PaymentRuleShortFlexEnum;
(function (PaymentRuleShortFlexEnum) {
  PaymentRuleShortFlexEnum["Rule1"] = "Rule1";
  PaymentRuleShortFlexEnum["Rule2"] = "Rule2";
  PaymentRuleShortFlexEnum["Rule3"] = "Rule3";
  PaymentRuleShortFlexEnum["Rule4"] = "Rule4";
  PaymentRuleShortFlexEnum["Rule5"] = "Rule5";
  PaymentRuleShortFlexEnum["Rule6"] = "Rule6";
  PaymentRuleShortFlexEnum["Rule7"] = "Rule7";
})(PaymentRuleShortFlexEnum = exports.PaymentRuleShortFlexEnum || (exports.PaymentRuleShortFlexEnum = {}));
var PermissionEnum;
(function (PermissionEnum) {
  PermissionEnum["PermissionAssignment"] = "PermissionAssignment";
  PermissionEnum["MeterReadingExport"] = "MeterReadingExport";
  PermissionEnum["TimeSeriesAccess"] = "TimeSeriesAccess";
  PermissionEnum["SettlementExecution"] = "SettlementExecution";
  PermissionEnum["DatabaseMigration"] = "DatabaseMigration";
  PermissionEnum["SystemOperation"] = "SystemOperation";
  PermissionEnum["VatRatesManagement"] = "VatRatesManagement";
  PermissionEnum["ManageInvoicingInfo"] = "ManageInvoicingInfo";
  PermissionEnum["ManageBankInfo"] = "ManageBankInfo";
  PermissionEnum["ManageInvoices"] = "ManageInvoices";
  PermissionEnum["Onboarding"] = "Onboarding";
  PermissionEnum["BaselineOverride"] = "BaselineOverride";
  PermissionEnum["MarketStatisticManagement"] = "MarketStatisticManagement";
  PermissionEnum["UserManagement"] = "UserManagement";
  PermissionEnum["OrganizationManagement"] = "OrganizationManagement";
  PermissionEnum["Trading"] = "Trading";
  PermissionEnum["AssetManagement"] = "AssetManagement";
  PermissionEnum["BaselineManagement"] = "BaselineManagement";
  PermissionEnum["MeterReadingManagement"] = "MeterReadingManagement";
  PermissionEnum["ViewMeterReadingOnPortfolioLevel"] = "ViewMeterReadingOnPortfolioLevel";
  PermissionEnum["GridManagement"] = "GridManagement";
  PermissionEnum["AssetApproval"] = "AssetApproval";
  PermissionEnum["ManageMarketMessages"] = "ManageMarketMessages";
  PermissionEnum["LongFlexContractManagement"] = "LongFlexContractManagement";
  PermissionEnum["BaselineReadAccess"] = "BaselineReadAccess";
  PermissionEnum["MarketManagement"] = "MarketManagement";
  PermissionEnum["PortfolioManagement"] = "PortfolioManagement";
  PermissionEnum["OrganizationInvoicingInformationManagement"] = "OrganizationInvoicingInformationManagement";
  PermissionEnum["ShortFlexSell"] = "ShortFlexSell";
  PermissionEnum["ShortFlexBuy"] = "ShortFlexBuy";
  PermissionEnum["LongFlexSell"] = "LongFlexSell";
  PermissionEnum["LongFlexBuy"] = "LongFlexBuy";
  PermissionEnum["MaxUsageSell"] = "MaxUsageSell";
  PermissionEnum["MaxUsageBuy"] = "MaxUsageBuy";
  PermissionEnum["ShortFlexReadNonMercantile"] = "ShortFlexReadNonMercantile";
  PermissionEnum["ShortFlexRead"] = "ShortFlexRead";
  PermissionEnum["LongFlexReadNonMercantile"] = "LongFlexReadNonMercantile";
  PermissionEnum["LongFlexRead"] = "LongFlexRead";
  PermissionEnum["MaxUsageRead"] = "MaxUsageRead";
  PermissionEnum["ConstraintRead"] = "ConstraintRead";
  PermissionEnum["TradingThresholdRead"] = "TradingThresholdRead";
  PermissionEnum["AssetRead"] = "AssetRead";
  PermissionEnum["AssetPortfolioRead"] = "AssetPortfolioRead";
  PermissionEnum["RunBrpRetailerBalanceReport"] = "RunBrpRetailerBalanceReport";
  PermissionEnum["MarketParticipationPreQualificationManagement"] = "MarketParticipationPreQualificationManagement";
  PermissionEnum["MarketParticipationRead"] = "MarketParticipationRead";
  PermissionEnum["MarketParticipationReview"] = "MarketParticipationReview";
  PermissionEnum["MarketParticipantApplicationRead"] = "MarketParticipantApplicationRead";
  PermissionEnum["MarketParticipationApply"] = "MarketParticipationApply";
  PermissionEnum["ReadAll"] = "ReadAll";
})(PermissionEnum = exports.PermissionEnum || (exports.PermissionEnum = {}));
var PermissionSetTypeEnum;
(function (PermissionSetTypeEnum) {
  PermissionSetTypeEnum["UserMembership"] = "UserMembership";
  PermissionSetTypeEnum["B2BMembership"] = "B2BMembership";
  PermissionSetTypeEnum["MarketParticipation"] = "MarketParticipation";
})(PermissionSetTypeEnum = exports.PermissionSetTypeEnum || (exports.PermissionSetTypeEnum = {}));
var PermissionTypeEnum;
(function (PermissionTypeEnum) {
  PermissionTypeEnum["User"] = "User";
  PermissionTypeEnum["Membership"] = "Membership";
})(PermissionTypeEnum = exports.PermissionTypeEnum || (exports.PermissionTypeEnum = {}));
var PreQualificationResponseTypeEnum;
(function (PreQualificationResponseTypeEnum) {
  PreQualificationResponseTypeEnum["Boolean"] = "Boolean";
  PreQualificationResponseTypeEnum["Attachment"] = "Attachment";
  PreQualificationResponseTypeEnum["SubmissionLink"] = "SubmissionLink";
})(PreQualificationResponseTypeEnum = exports.PreQualificationResponseTypeEnum || (exports.PreQualificationResponseTypeEnum = {}));
var PriceTypeEnum;
(function (PriceTypeEnum) {
  PriceTypeEnum["Limit"] = "Limit";
  PriceTypeEnum["Market"] = "Market";
  PriceTypeEnum["PayAsCleared"] = "PayAsCleared";
})(PriceTypeEnum = exports.PriceTypeEnum || (exports.PriceTypeEnum = {}));
var QuantityTypeEnum;
(function (QuantityTypeEnum) {
  QuantityTypeEnum["Power"] = "Power";
  QuantityTypeEnum["Energy"] = "Energy";
  QuantityTypeEnum["Capacity"] = "Capacity";
  QuantityTypeEnum["ReactivePower"] = "ReactivePower";
})(QuantityTypeEnum = exports.QuantityTypeEnum || (exports.QuantityTypeEnum = {}));
var QueryReportParamTypeEnum;
(function (QueryReportParamTypeEnum) {
  QueryReportParamTypeEnum["NotSet"] = "NotSet";
  QueryReportParamTypeEnum["Date"] = "Date";
  QueryReportParamTypeEnum["Status"] = "Status";
  QueryReportParamTypeEnum["OrganizationId"] = "OrganizationId";
  QueryReportParamTypeEnum["UserId"] = "UserId";
  QueryReportParamTypeEnum["GridNodeId"] = "GridNodeId";
  QueryReportParamTypeEnum["MarketId"] = "MarketId";
})(QueryReportParamTypeEnum = exports.QueryReportParamTypeEnum || (exports.QueryReportParamTypeEnum = {}));
var RegulationTypeEnum;
(function (RegulationTypeEnum) {
  RegulationTypeEnum["Up"] = "Up";
  RegulationTypeEnum["Down"] = "Down";
})(RegulationTypeEnum = exports.RegulationTypeEnum || (exports.RegulationTypeEnum = {}));
var RenewableTypeEnum;
(function (RenewableTypeEnum) {
  RenewableTypeEnum["Renewable"] = "Renewable";
  RenewableTypeEnum["NonRenewable"] = "NonRenewable";
  RenewableTypeEnum["Mixed"] = "Mixed";
})(RenewableTypeEnum = exports.RenewableTypeEnum || (exports.RenewableTypeEnum = {}));
var StatusEnum;
(function (StatusEnum) {
  StatusEnum["Draft"] = "Draft";
  StatusEnum["Received"] = "Received";
  StatusEnum["Pending"] = "Pending";
  StatusEnum["Rejected"] = "Rejected";
  StatusEnum["Active"] = "Active";
  StatusEnum["Inactive"] = "Inactive";
  StatusEnum["Completed"] = "Completed";
  StatusEnum["Deleted"] = "Deleted";
})(StatusEnum = exports.StatusEnum || (exports.StatusEnum = {}));
var SubscriptionTypeEnum;
(function (SubscriptionTypeEnum) {
  SubscriptionTypeEnum["NodesOperator"] = "NodesOperator";
  SubscriptionTypeEnum["TSO"] = "TSO";
  SubscriptionTypeEnum["DSO"] = "DSO";
  SubscriptionTypeEnum["FSP"] = "FSP";
  SubscriptionTypeEnum["BRP"] = "BRP";
  SubscriptionTypeEnum["Agent"] = "Agent";
  SubscriptionTypeEnum["Coordinator"] = "Coordinator";
  SubscriptionTypeEnum["Retailer"] = "Retailer";
})(SubscriptionTypeEnum = exports.SubscriptionTypeEnum || (exports.SubscriptionTypeEnum = {}));
var TradeVisibilityEnum;
(function (TradeVisibilityEnum) {
  TradeVisibilityEnum["BasicCounterpartInfo"] = "BasicCounterpartInfo";
  TradeVisibilityEnum["Anonymous"] = "Anonymous";
})(TradeVisibilityEnum = exports.TradeVisibilityEnum || (exports.TradeVisibilityEnum = {}));
var UserTypeEnum;
(function (UserTypeEnum) {
  UserTypeEnum["Human"] = "Human";
  UserTypeEnum["Application"] = "Application";
})(UserTypeEnum = exports.UserTypeEnum || (exports.UserTypeEnum = {}));
var VisibilityPolicyEnum;
(function (VisibilityPolicyEnum) {
  VisibilityPolicyEnum["DefaultVisibility"] = "DefaultVisibility";
  VisibilityPolicyEnum["PublicByDefault"] = "PublicByDefault";
  VisibilityPolicyEnum["PrivateByDefault"] = "PrivateByDefault";
})(VisibilityPolicyEnum = exports.VisibilityPolicyEnum || (exports.VisibilityPolicyEnum = {}));
var RelationsEnum;
(function (RelationsEnum) {
  RelationsEnum["links"] = "links";
  RelationsEnum["configuration"] = "configuration";
  RelationsEnum["statistics"] = "statistics";
  RelationsEnum["dataset"] = "dataset";
  RelationsEnum["user"] = "user";
  RelationsEnum["operator"] = "operator";
  RelationsEnum["retailer"] = "retailer";
  RelationsEnum["manager"] = "manager";
  RelationsEnum["supplier"] = "supplier";
  RelationsEnum["organization"] = "organization";
  RelationsEnum["preferences"] = "preferences";
  RelationsEnum["membership"] = "membership";
  RelationsEnum["subscription"] = "subscription";
  RelationsEnum["current"] = "current";
  RelationsEnum["order"] = "order";
  RelationsEnum["order_info"] = "order-info";
  RelationsEnum["public_orders"] = "public-orders";
  RelationsEnum["order_group"] = "order-group";
  RelationsEnum["permissionset"] = "permissionset";
  RelationsEnum["permissionassignment"] = "permissionassignment";
  RelationsEnum["invitation"] = "invitation";
  RelationsEnum["order_aggregates"] = "order-aggregates";
  RelationsEnum["trade_aggregates"] = "trade-aggregates";
  RelationsEnum["expired_order_aggregates"] = "expired-order-aggregates";
  RelationsEnum["gridnode"] = "gridnode";
  RelationsEnum["privategridnodedata"] = "privategridnodedata";
  RelationsEnum["assetgridassignment"] = "assetgridassignment";
  RelationsEnum["gridnodemarketassignment"] = "gridnodemarketassignment";
  RelationsEnum["gridlocation"] = "gridlocation";
  RelationsEnum["gridnodelink"] = "gridnodelink";
  RelationsEnum["mappolygon"] = "mappolygon";
  RelationsEnum["market"] = "market";
  RelationsEnum["marketparticipation"] = "marketparticipation";
  RelationsEnum["marketparticipationrequirement"] = "marketparticipationrequirement";
  RelationsEnum["prequalificationrequirement"] = "prequalificationrequirement";
  RelationsEnum["prequalificationsubmission"] = "prequalificationsubmission";
  RelationsEnum["dayaheadauctionsettings"] = "dayaheadauctionsettings";
  RelationsEnum["marketpermission"] = "marketpermission";
  RelationsEnum["longflexcontract"] = "longflexcontract";
  RelationsEnum["recommendationtemplate"] = "recommendationtemplate";
  RelationsEnum["scheduled_order_templates"] = "scheduled-order-templates";
  RelationsEnum["maxusagetender"] = "maxusagetender";
  RelationsEnum["maxusagecontract"] = "maxusagecontract";
  RelationsEnum["buyer"] = "buyer";
  RelationsEnum["seller"] = "seller";
  RelationsEnum["trade"] = "trade";
  RelationsEnum["deal"] = "deal";
  RelationsEnum["gridarea"] = "gridarea";
  RelationsEnum["gridgroup"] = "gridgroup";
  RelationsEnum["gridgroupassignment"] = "gridgroupassignment";
  RelationsEnum["pricearea"] = "pricearea";
  RelationsEnum["assettype"] = "assettype";
  RelationsEnum["settlement"] = "settlement";
  RelationsEnum["marketsettlementconfig"] = "marketsettlementconfig";
  RelationsEnum["asset"] = "asset";
  RelationsEnum["assetportfolio"] = "assetportfolio";
  RelationsEnum["assetportfolioassignment"] = "assetportfolioassignment";
  RelationsEnum["baselineinterval"] = "baselineinterval";
  RelationsEnum["emailmessage"] = "emailmessage";
  RelationsEnum["smsmessage"] = "smsmessage";
  RelationsEnum["dispatchconfiguration"] = "dispatchconfiguration";
  RelationsEnum["applicationusermapping"] = "applicationusermapping";
  RelationsEnum["meterreading"] = "meterreading";
  RelationsEnum["counterpart"] = "counterpart";
  RelationsEnum["counter_orders"] = "counter-orders";
  RelationsEnum["original_of_counter_order"] = "original-of-counter-order";
  RelationsEnum["marketmessage"] = "marketmessage";
  RelationsEnum["assetportfolioaggregation"] = "assetportfolioaggregation";
  RelationsEnum["vatrate"] = "vatrate";
  RelationsEnum["invoicinginfo"] = "invoicinginfo";
  RelationsEnum["invoiceline"] = "invoiceline";
  RelationsEnum["invoicefile"] = "invoicefile";
  RelationsEnum["bankinfo"] = "bankinfo";
  RelationsEnum["invoice"] = "invoice";
  RelationsEnum["mfrrinterchangeconfiguration"] = "mfrrinterchangeconfiguration";
  RelationsEnum["trading_threshold"] = "trading-threshold";
  RelationsEnum["source"] = "source";
  RelationsEnum["target"] = "target";
  RelationsEnum["tree"] = "tree";
  RelationsEnum["top"] = "top";
  RelationsEnum["enumerations"] = "enumerations";
  RelationsEnum["currency"] = "currency";
  RelationsEnum["country"] = "country";
  RelationsEnum["timezone"] = "timezone";
  RelationsEnum["parent"] = "parent";
  RelationsEnum["updater"] = "updater";
  RelationsEnum["creator"] = "creator";
  RelationsEnum["owner"] = "owner";
  RelationsEnum["children"] = "children";
  RelationsEnum["self"] = "self";
  RelationsEnum["form"] = "form";
  RelationsEnum["previous"] = "previous";
  RelationsEnum["next"] = "next";
  RelationsEnum["version"] = "version";
  RelationsEnum["search"] = "search";
  RelationsEnum["features"] = "features";
  RelationsEnum["surveillance"] = "surveillance";
  RelationsEnum["digestsubscription"] = "digestsubscription";
  RelationsEnum["__infer_from_type__"] = "--infer-from-type--";
})(RelationsEnum = exports.RelationsEnum || (exports.RelationsEnum = {}));
class BlockTemplate {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new BlockTemplate();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.quantity = _data['quantity'];
    this.unitPrice = _data['unitPrice'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.quantity = this.quantity;
    data.unitPrice = this.unitPrice;
    return data;
  }
}
exports.BlockTemplate = BlockTemplate;
class WeekTemplate {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new WeekTemplate();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.weekDays = _data['weekDays'];
    this.deviations = _data['deviations'];
    this.validFrom = _data['validFrom'] ? new Date(_data['validFrom'].toString()) : undefined;
    this.validTo = _data['validTo'] ? new Date(_data['validTo'].toString()) : undefined;
    this.quantity = _data['quantity'];
    this.unitPrice = _data['unitPrice'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.weekDays = this.weekDays;
    data.deviations = this.deviations;
    data['validFrom'] = this.validFrom ? this.validFrom.toISOString() : undefined;
    data['validTo'] = this.validTo ? this.validTo.toISOString() : undefined;
    data.quantity = this.quantity;
    data.unitPrice = this.unitPrice;
    return data;
  }
}
exports.WeekTemplate = WeekTemplate;
class ContractSchedule {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new ContractSchedule();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.blockSizeInSeconds = _data['blockSizeInSeconds'];
    this.quantity = _data['quantity'];
    this.unitPrice = _data['unitPrice'];
    this.schemaVersion = _data['schemaVersion'];
    this.description = _data['description'];
    if (Array.isArray(_data['weekTemplates'])) {
      this.weekTemplates = [];
      for (let item of _data['weekTemplates']) this.weekTemplates.push(WeekTemplate.fromJS(item));
    }
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.blockSizeInSeconds = this.blockSizeInSeconds;
    data.quantity = this.quantity;
    data.unitPrice = this.unitPrice;
    data.schemaVersion = this.schemaVersion;
    data.description = this.description;
    if (Array.isArray(this.weekTemplates)) {
      data['weekTemplates'] = [];
      for (let item of this.weekTemplates) data['weekTemplates'].push(item.toJSON());
    }
    return data;
  }
}
exports.ContractSchedule = ContractSchedule;
class OrderAggregate {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new OrderAggregate();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.hasMultiBlockOrders = _data['hasMultiBlockOrders'];
    this.periodFrom = _data['periodFrom'] ? new Date(_data['periodFrom'].toString()) : undefined;
    this.periodTo = _data['periodTo'] ? new Date(_data['periodTo'].toString()) : undefined;
    this.orderAggregateSearch = _data['orderAggregateSearch'];
    if (Array.isArray(_data['sellItems'])) {
      this.sellItems = [];
      for (let item of _data['sellItems']) this.sellItems.push(PriceAggregate.fromJS(item));
    }
    if (Array.isArray(_data['buyItems'])) {
      this.buyItems = [];
      for (let item of _data['buyItems']) this.buyItems.push(PriceAggregate.fromJS(item));
    }
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.hasMultiBlockOrders = this.hasMultiBlockOrders;
    data['periodFrom'] = this.periodFrom ? this.periodFrom.toISOString() : undefined;
    data['periodTo'] = this.periodTo ? this.periodTo.toISOString() : undefined;
    data.orderAggregateSearch = this.orderAggregateSearch;
    if (Array.isArray(this.sellItems)) {
      data['sellItems'] = [];
      for (let item of this.sellItems) data['sellItems'].push(item.toJSON());
    }
    if (Array.isArray(this.buyItems)) {
      data['buyItems'] = [];
      for (let item of this.buyItems) data['buyItems'].push(item.toJSON());
    }
    return data;
  }
}
exports.OrderAggregate = OrderAggregate;
class TradeAggregate {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new TradeAggregate();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.periodStart = _data['periodStart'] ? new Date(_data['periodStart'].toString()) : undefined;
    this.periodEnd = _data['periodEnd'] ? new Date(_data['periodEnd'].toString()) : undefined;
    this.aggregatedTradeQuantity = _data['aggregatedTradeQuantity'];
    this.numberOfTrades = _data['numberOfTrades'];
    this.side = _data['side'];
    this.aggregationPeriod = _data['aggregationPeriod'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data['periodStart'] = this.periodStart ? this.periodStart.toISOString() : undefined;
    data['periodEnd'] = this.periodEnd ? this.periodEnd.toISOString() : undefined;
    data.aggregatedTradeQuantity = this.aggregatedTradeQuantity;
    data.numberOfTrades = this.numberOfTrades;
    data.side = this.side;
    data.aggregationPeriod = this.aggregationPeriod;
    return data;
  }
}
exports.TradeAggregate = TradeAggregate;
class TradeAggregateInfo {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new TradeAggregateInfo();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.marketId = _data['marketId'];
    if (Array.isArray(_data['tradeAggregates'])) {
      this.tradeAggregates = [];
      for (let item of _data['tradeAggregates']) this.tradeAggregates.push(TradeAggregate.fromJS(item));
    }
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.marketId = this.marketId;
    if (Array.isArray(this.tradeAggregates)) {
      data['tradeAggregates'] = [];
      for (let item of this.tradeAggregates) data['tradeAggregates'].push(item.toJSON());
    }
    return data;
  }
}
exports.TradeAggregateInfo = TradeAggregateInfo;
class TradeAggregateQuery {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new TradeAggregateQuery();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.includeSellTradesFromDescendants = _data['includeSellTradesFromDescendants'];
    this.includeBuyTradesFromAscendants = _data['includeBuyTradesFromAscendants'];
    this.periodFrom = _data['periodFrom'] ? new Date(_data['periodFrom'].toString()) : undefined;
    this.periodTo = _data['periodTo'] ? new Date(_data['periodTo'].toString()) : undefined;
    this.side = _data['side'];
    this.regulationType = _data['regulationType'];
    this.marketId = _data['marketId'];
    this.gridNodeId = _data['gridNodeId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.includeSellTradesFromDescendants = this.includeSellTradesFromDescendants;
    data.includeBuyTradesFromAscendants = this.includeBuyTradesFromAscendants;
    data['periodFrom'] = this.periodFrom ? this.periodFrom.toISOString() : undefined;
    data['periodTo'] = this.periodTo ? this.periodTo.toISOString() : undefined;
    data.side = this.side;
    data.regulationType = this.regulationType;
    data.marketId = this.marketId;
    data.gridNodeId = this.gridNodeId;
    return data;
  }
}
exports.TradeAggregateQuery = TradeAggregateQuery;
class PriceAggregate {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new PriceAggregate();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.hasMultiBlockOrders = _data['hasMultiBlockOrders'];
    if (Array.isArray(_data['discriminators'])) {
      this.discriminators = [];
      for (let item of _data['discriminators']) this.discriminators.push(Discriminator.fromJS(item));
    }
    this.quantity = _data['quantity'];
    this.unitPrice = _data['unitPrice'];
    this.numberOfOrders = _data['numberOfOrders'];
    this.myQuantity = _data['myQuantity'];
    if (Array.isArray(_data['restrictions'])) {
      this.restrictions = [];
      for (let item of _data['restrictions']) this.restrictions.push(item);
    }
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.hasMultiBlockOrders = this.hasMultiBlockOrders;
    if (Array.isArray(this.discriminators)) {
      data['discriminators'] = [];
      for (let item of this.discriminators) data['discriminators'].push(item.toJSON());
    }
    data.quantity = this.quantity;
    data.unitPrice = this.unitPrice;
    data.numberOfOrders = this.numberOfOrders;
    data.myQuantity = this.myQuantity;
    if (Array.isArray(this.restrictions)) {
      data['restrictions'] = [];
      for (let item of this.restrictions) data['restrictions'].push(item);
    }
    return data;
  }
}
exports.PriceAggregate = PriceAggregate;
class OrderAggregateSearch {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new OrderAggregateSearch();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.periodFrom = _data['periodFrom'] ? new Date(_data['periodFrom'].toString()) : undefined;
    this.periodTo = _data['periodTo'] ? new Date(_data['periodTo'].toString()) : undefined;
    this.validToMinimum = _data['validToMinimum'] ? new Date(_data['validToMinimum'].toString()) : undefined;
    this.priceResolution = _data['priceResolution'];
    this.minimumQuantity = _data['minimumQuantity'];
    this.orderSide = _data['orderSide'];
    this.regulationType = _data['regulationType'];
    if (Array.isArray(_data['renewableTypes'])) {
      this.renewableTypes = [];
      for (let item of _data['renewableTypes']) this.renewableTypes.push(item);
    }
    this.marketId = _data['marketId'];
    this.gridNodeId = _data['gridNodeId'];
    this.gridGroupId = _data['gridGroupId'];
    this.groupBy = _data['groupBy'];
    this.periodResolution = _data['periodResolution'];
    if (Array.isArray(_data['assetTypeIds'])) {
      this.assetTypeIds = [];
      for (let item of _data['assetTypeIds']) this.assetTypeIds.push(item);
    }
    if (Array.isArray(_data['assetPortfolioIds'])) {
      this.assetPortfolioIds = [];
      for (let item of _data['assetPortfolioIds']) this.assetPortfolioIds.push(item);
    }
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data['periodFrom'] = this.periodFrom ? this.periodFrom.toISOString() : undefined;
    data['periodTo'] = this.periodTo ? this.periodTo.toISOString() : undefined;
    data['validToMinimum'] = this.validToMinimum ? this.validToMinimum.toISOString() : undefined;
    data.priceResolution = this.priceResolution;
    data.minimumQuantity = this.minimumQuantity;
    data.orderSide = this.orderSide;
    data.regulationType = this.regulationType;
    if (Array.isArray(this.renewableTypes)) {
      data['renewableTypes'] = [];
      for (let item of this.renewableTypes) data['renewableTypes'].push(item);
    }
    data.marketId = this.marketId;
    data.gridNodeId = this.gridNodeId;
    data.gridGroupId = this.gridGroupId;
    data.groupBy = this.groupBy;
    data.periodResolution = this.periodResolution;
    if (Array.isArray(this.assetTypeIds)) {
      data['assetTypeIds'] = [];
      for (let item of this.assetTypeIds) data['assetTypeIds'].push(item);
    }
    if (Array.isArray(this.assetPortfolioIds)) {
      data['assetPortfolioIds'] = [];
      for (let item of this.assetPortfolioIds) data['assetPortfolioIds'].push(item);
    }
    return data;
  }
}
exports.OrderAggregateSearch = OrderAggregateSearch;
class OrderBlockInfo {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new OrderBlockInfo();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.periodFrom = _data['periodFrom'] ? new Date(_data['periodFrom'].toString()) : undefined;
    this.periodTo = _data['periodTo'] ? new Date(_data['periodTo'].toString()) : undefined;
    this.remainingQuantity = _data['remainingQuantity'];
    this.minimumQuantity = _data['minimumQuantity'];
    this.unitPrice = _data['unitPrice'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data['periodFrom'] = this.periodFrom ? this.periodFrom.toISOString() : undefined;
    data['periodTo'] = this.periodTo ? this.periodTo.toISOString() : undefined;
    data.remainingQuantity = this.remainingQuantity;
    data.minimumQuantity = this.minimumQuantity;
    data.unitPrice = this.unitPrice;
    return data;
  }
}
exports.OrderBlockInfo = OrderBlockInfo;
class Discriminator {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new Discriminator();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.displayValue = _data['displayValue'];
    this.type = _data['type'];
    this.value = _data['value'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.displayValue = this.displayValue;
    data.type = this.type;
    data.value = this.value;
    return data;
  }
}
exports.Discriminator = Discriminator;
class HistoricalFilter {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new HistoricalFilter();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    return data;
  }
}
exports.HistoricalFilter = HistoricalFilter;
class SearchOptions {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new SearchOptions();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.excludeStatusDeleted = _data['excludeStatusDeleted'];
    this.historical = _data['historical'];
    this.take = _data['take'];
    this.skip = _data['skip'];
    if (Array.isArray(_data['orderBy'])) {
      this.orderBy = [];
      for (let item of _data['orderBy']) this.orderBy.push(item);
    }
    if (Array.isArray(_data['embeddings'])) {
      this.embeddings = [];
      for (let item of _data['embeddings']) this.embeddings.push(item);
    }
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.excludeStatusDeleted = this.excludeStatusDeleted;
    data.historical = this.historical;
    data.take = this.take;
    data.skip = this.skip;
    if (Array.isArray(this.orderBy)) {
      data['orderBy'] = [];
      for (let item of this.orderBy) data['orderBy'].push(item);
    }
    if (Array.isArray(this.embeddings)) {
      data['embeddings'] = [];
      for (let item of this.embeddings) data['embeddings'].push(item);
    }
    return data;
  }
}
exports.SearchOptions = SearchOptions;
class PublicOrderSearch {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new PublicOrderSearch();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.periodFrom = _data['periodFrom'] ? new Date(_data['periodFrom'].toString()) : undefined;
    this.periodTo = _data['periodTo'] ? new Date(_data['periodTo'].toString()) : undefined;
    this.completionType = _data['completionType'];
    this.orderSide = _data['orderSide'];
    this.regulationType = _data['regulationType'];
    if (Array.isArray(_data['renewableTypes'])) {
      this.renewableTypes = [];
      for (let item of _data['renewableTypes']) this.renewableTypes.push(item);
    }
    this.status = _data['status'];
    this.marketId = _data['marketId'];
    this.gridNodeId = _data['gridNodeId'];
    if (Array.isArray(_data['assetTypeIds'])) {
      this.assetTypeIds = [];
      for (let item of _data['assetTypeIds']) this.assetTypeIds.push(item);
    }
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data['periodFrom'] = this.periodFrom ? this.periodFrom.toISOString() : undefined;
    data['periodTo'] = this.periodTo ? this.periodTo.toISOString() : undefined;
    data.completionType = this.completionType;
    data.orderSide = this.orderSide;
    data.regulationType = this.regulationType;
    if (Array.isArray(this.renewableTypes)) {
      data['renewableTypes'] = [];
      for (let item of this.renewableTypes) data['renewableTypes'].push(item);
    }
    data.status = this.status;
    data.marketId = this.marketId;
    data.gridNodeId = this.gridNodeId;
    if (Array.isArray(this.assetTypeIds)) {
      data['assetTypeIds'] = [];
      for (let item of this.assetTypeIds) data['assetTypeIds'].push(item);
    }
    return data;
  }
}
exports.PublicOrderSearch = PublicOrderSearch;
class PublicOrderSearchResult {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new PublicOrderSearchResult();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    if (Array.isArray(_data['embedded'])) {
      this.embedded = [];
      for (let item of _data['embedded']) this.embedded.push(IHasLinks.fromJS(item));
    }
    if (Array.isArray(_data['links'])) {
      this.links = [];
      for (let item of _data['links']) this.links.push(NodesLink.fromJS(item));
    }
    this.numberOfHits = _data['numberOfHits'];
    if (Array.isArray(_data['relatedOrders'])) {
      this.relatedOrders = [];
      for (let item of _data['relatedOrders']) this.relatedOrders.push(PublicOrder.fromJS(item));
    }
    if (Array.isArray(_data['items'])) {
      this.items = [];
      for (let item of _data['items']) this.items.push(PublicOrder.fromJS(item));
    }
    this.options = _data['options'];
    this.id = _data['id'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.embedded)) {
      data['embedded'] = [];
      for (let item of this.embedded) data['embedded'].push(item.toJSON());
    }
    if (Array.isArray(this.links)) {
      data['links'] = [];
      for (let item of this.links) data['links'].push(item.toJSON());
    }
    data.numberOfHits = this.numberOfHits;
    if (Array.isArray(this.relatedOrders)) {
      data['relatedOrders'] = [];
      for (let item of this.relatedOrders) data['relatedOrders'].push(item.toJSON());
    }
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data.options = this.options;
    data.id = this.id;
    return data;
  }
}
exports.PublicOrderSearchResult = PublicOrderSearchResult;
class DateTimeRange {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new DateTimeRange();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.startOnOrAfter = _data['startOnOrAfter'] ? new Date(_data['startOnOrAfter'].toString()) : undefined;
    this.endBefore = _data['endBefore'] ? new Date(_data['endBefore'].toString()) : undefined;
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data['startOnOrAfter'] = this.startOnOrAfter ? this.startOnOrAfter.toISOString() : undefined;
    data['endBefore'] = this.endBefore ? this.endBefore.toISOString() : undefined;
    return data;
  }
}
exports.DateTimeRange = DateTimeRange;
class Coordinate {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new Coordinate();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.longitude = _data['longitude'];
    this.latitude = _data['latitude'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.longitude = this.longitude;
    data.latitude = this.latitude;
    return data;
  }
}
exports.Coordinate = Coordinate;
class NodesLink {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new NodesLink();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.rel = _data['rel'];
    this.title = _data['title'];
    this.href = _data['href'];
    this.method = _data['method'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.rel = this.rel;
    data.title = this.title;
    data.href = this.href;
    data.method = this.method;
    return data;
  }
}
exports.NodesLink = NodesLink;
class LoginConfiguration {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new LoginConfiguration();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.name = _data['name'];
    this.clientId = _data['clientId'];
    this.authority = _data['authority'];
    this.b2CExtensionName = _data['b2CExtensionName'];
    if (Array.isArray(_data['scopes'])) {
      this.scopes = [];
      for (let item of _data['scopes']) this.scopes.push(item);
    }
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.name = this.name;
    data.clientId = this.clientId;
    data.authority = this.authority;
    data.b2CExtensionName = this.b2CExtensionName;
    if (Array.isArray(this.scopes)) {
      data['scopes'] = [];
      for (let item of this.scopes) data['scopes'].push(item);
    }
    return data;
  }
}
exports.LoginConfiguration = LoginConfiguration;
class DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new DTOBase();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.created = _data['created'] ? new Date(_data['created'].toString()) : undefined;
    this.lastModified = _data['lastModified'] ? new Date(_data['lastModified'].toString()) : undefined;
    if (Array.isArray(_data['links'])) {
      this.links = [];
      for (let item of _data['links']) this.links.push(NodesLink.fromJS(item));
    }
    this.status = _data['status'];
    this.id = _data['id'];
    this.createdByUserId = _data['createdByUserId'];
    this.lastModifiedByUserId = _data['lastModifiedByUserId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data['created'] = this.created ? this.created.toISOString() : undefined;
    data['lastModified'] = this.lastModified ? this.lastModified.toISOString() : undefined;
    if (Array.isArray(this.links)) {
      data['links'] = [];
      for (let item of this.links) data['links'].push(item.toJSON());
    }
    data.status = this.status;
    data.id = this.id;
    data.createdByUserId = this.createdByUserId;
    data.lastModifiedByUserId = this.lastModifiedByUserId;
    return data;
  }
}
exports.DTOBase = DTOBase;
class IHasLinks {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new IHasLinks();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    if (Array.isArray(_data['links'])) {
      this.links = [];
      for (let item of _data['links']) this.links.push(NodesLink.fromJS(item));
    }
    this.id = _data['id'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.links)) {
      data['links'] = [];
      for (let item of this.links) data['links'].push(item.toJSON());
    }
    data.id = this.id;
    return data;
  }
}
exports.IHasLinks = IHasLinks;
class UserInfo {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new UserInfo();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    if (Array.isArray(_data['memberships'])) {
      this.memberships = [];
      for (let item of _data['memberships']) this.memberships.push(Membership.fromJS(item));
    }
    if (Array.isArray(_data['b2BMemberships'])) {
      this.b2BMemberships = [];
      for (let item of _data['b2BMemberships']) this.b2BMemberships.push(Membership.fromJS(item));
    }
    if (Array.isArray(_data['organizations'])) {
      this.organizations = [];
      for (let item of _data['organizations']) this.organizations.push(Organization.fromJS(item));
    }
    if (Array.isArray(_data['permissionSets'])) {
      this.permissionSets = [];
      for (let item of _data['permissionSets']) this.permissionSets.push(PermissionSet.fromJS(item));
    }
    if (Array.isArray(_data['permissionAssignments'])) {
      this.permissionAssignments = [];
      for (let item of _data['permissionAssignments']) this.permissionAssignments.push(item);
    }
    if (Array.isArray(_data['subscriptions'])) {
      this.subscriptions = [];
      for (let item of _data['subscriptions']) this.subscriptions.push(Subscription.fromJS(item));
    }
    this.user = _data['user'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.memberships)) {
      data['memberships'] = [];
      for (let item of this.memberships) data['memberships'].push(item.toJSON());
    }
    if (Array.isArray(this.b2BMemberships)) {
      data['b2BMemberships'] = [];
      for (let item of this.b2BMemberships) data['b2BMemberships'].push(item.toJSON());
    }
    if (Array.isArray(this.organizations)) {
      data['organizations'] = [];
      for (let item of this.organizations) data['organizations'].push(item.toJSON());
    }
    if (Array.isArray(this.permissionSets)) {
      data['permissionSets'] = [];
      for (let item of this.permissionSets) data['permissionSets'].push(item.toJSON());
    }
    if (Array.isArray(this.permissionAssignments)) {
      data['permissionAssignments'] = [];
      for (let item of this.permissionAssignments) data['permissionAssignments'].push(item);
    }
    if (Array.isArray(this.subscriptions)) {
      data['subscriptions'] = [];
      for (let item of this.subscriptions) data['subscriptions'].push(item.toJSON());
    }
    data.user = this.user;
    return data;
  }
}
exports.UserInfo = UserInfo;
class ClientCredentialsLogin {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new ClientCredentialsLogin();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.startDate = _data['startDate'] ? new Date(_data['startDate'].toString()) : undefined;
    this.endDate = _data['endDate'] ? new Date(_data['endDate'].toString()) : undefined;
    this.clientSecret = _data['clientSecret'];
    this.clientSecretId = _data['clientSecretId'];
    this.clientId = _data['clientId'];
    this.scope = _data['scope'];
    this.tokenEndpoint = _data['tokenEndpoint'];
    this.openIdConfiguration = _data['openIdConfiguration'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data['startDate'] = this.startDate ? this.startDate.toISOString() : undefined;
    data['endDate'] = this.endDate ? this.endDate.toISOString() : undefined;
    data.clientSecret = this.clientSecret;
    data.clientSecretId = this.clientSecretId;
    data.clientId = this.clientId;
    data.scope = this.scope;
    data.tokenEndpoint = this.tokenEndpoint;
    data.openIdConfiguration = this.openIdConfiguration;
    return data;
  }
}
exports.ClientCredentialsLogin = ClientCredentialsLogin;
class Counterpart {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new Counterpart();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    if (Array.isArray(_data['links'])) {
      this.links = [];
      for (let item of _data['links']) this.links.push(NodesLink.fromJS(item));
    }
    this.assetPortfolioRampUpRate = _data['assetPortfolioRampUpRate'];
    this.assetPortfolioRampDownRate = _data['assetPortfolioRampDownRate'];
    this.mainTradeId = _data['mainTradeId'];
    this.dealId = _data['dealId'];
    this.assetPortfolioId = _data['assetPortfolioId'];
    this.assetPortfolioName = _data['assetPortfolioName'];
    this.counterPartOrganizationId = _data['counterPartOrganizationId'];
    this.counterPartOrganizationName = _data['counterPartOrganizationName'];
    this.supplierOrganizationId = _data['supplierOrganizationId'];
    this.supplierOrganizationName = _data['supplierOrganizationName'];
    this.retailerOrganizationId = _data['retailerOrganizationId'];
    this.retailerOrganizationName = _data['retailerOrganizationName'];
    this.id = _data['id'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.links)) {
      data['links'] = [];
      for (let item of this.links) data['links'].push(item.toJSON());
    }
    data.assetPortfolioRampUpRate = this.assetPortfolioRampUpRate;
    data.assetPortfolioRampDownRate = this.assetPortfolioRampDownRate;
    data.mainTradeId = this.mainTradeId;
    data.dealId = this.dealId;
    data.assetPortfolioId = this.assetPortfolioId;
    data.assetPortfolioName = this.assetPortfolioName;
    data.counterPartOrganizationId = this.counterPartOrganizationId;
    data.counterPartOrganizationName = this.counterPartOrganizationName;
    data.supplierOrganizationId = this.supplierOrganizationId;
    data.supplierOrganizationName = this.supplierOrganizationName;
    data.retailerOrganizationId = this.retailerOrganizationId;
    data.retailerOrganizationName = this.retailerOrganizationName;
    data.id = this.id;
    return data;
  }
}
exports.Counterpart = Counterpart;
class DryRunRequest {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new DryRunRequest();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.matchConfig = _data['matchConfig'];
    if (Array.isArray(_data['orders'])) {
      this.orders = [];
      for (let item of _data['orders']) this.orders.push(Order.fromJS(item));
    }
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.matchConfig = this.matchConfig;
    if (Array.isArray(this.orders)) {
      data['orders'] = [];
      for (let item of this.orders) data['orders'].push(item.toJSON());
    }
    return data;
  }
}
exports.DryRunRequest = DryRunRequest;
class DryRunResponse {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new DryRunResponse();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.matchConfig = _data['matchConfig'];
    this.timings = _data['timings'];
    if (Array.isArray(_data['ordersAffected'])) {
      this.ordersAffected = [];
      for (let item of _data['ordersAffected']) this.ordersAffected.push(Order.fromJS(item));
    }
    if (Array.isArray(_data['tradesCreated'])) {
      this.tradesCreated = [];
      for (let item of _data['tradesCreated']) this.tradesCreated.push(Trade.fromJS(item));
    }
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.matchConfig = this.matchConfig;
    data.timings = this.timings;
    if (Array.isArray(this.ordersAffected)) {
      data['ordersAffected'] = [];
      for (let item of this.ordersAffected) data['ordersAffected'].push(item.toJSON());
    }
    if (Array.isArray(this.tradesCreated)) {
      data['tradesCreated'] = [];
      for (let item of this.tradesCreated) data['tradesCreated'].push(item.toJSON());
    }
    return data;
  }
}
exports.DryRunResponse = DryRunResponse;
class ValidationError {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new ValidationError();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.lineNumber = _data['lineNumber'];
    this.errorCode = _data['errorCode'];
    this.description = _data['description'];
    this.propertyName = _data['propertyName'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.lineNumber = this.lineNumber;
    data.errorCode = this.errorCode;
    data.description = this.description;
    data.propertyName = this.propertyName;
    return data;
  }
}
exports.ValidationError = ValidationError;
class Batch {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new Batch();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.successCount = _data['successCount'];
    this.failedCount = _data['failedCount'];
    if (Array.isArray(_data['operations'])) {
      this.operations = [];
      for (let item of _data['operations']) this.operations.push(Operation.fromJS(item));
    }
    this.idempotencyKey = _data['idempotencyKey'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.successCount = this.successCount;
    data.failedCount = this.failedCount;
    if (Array.isArray(this.operations)) {
      data['operations'] = [];
      for (let item of this.operations) data['operations'].push(item.toJSON());
    }
    data.idempotencyKey = this.idempotencyKey;
    return data;
  }
}
exports.Batch = Batch;
class Operation {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new Operation();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.item = _data['item'];
    this.method = _data['method'];
    if (Array.isArray(_data['errors'])) {
      this.errors = [];
      for (let item of _data['errors']) this.errors.push(ValidationError.fromJS(item));
    }
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.item = this.item;
    data.method = this.method;
    if (Array.isArray(this.errors)) {
      data['errors'] = [];
      for (let item of this.errors) data['errors'].push(item.toJSON());
    }
    return data;
  }
}
exports.Operation = Operation;
class TimeZoneInfo {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new TimeZoneInfo();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.ianaId = _data['ianaId'];
    this.displayName = _data['displayName'];
    this.baseUtcOffset = _data['baseUtcOffset'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.ianaId = this.ianaId;
    data.displayName = this.displayName;
    data.baseUtcOffset = this.baseUtcOffset;
    return data;
  }
}
exports.TimeZoneInfo = TimeZoneInfo;
class Property {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new Property();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.isRequired = _data['isRequired'];
    this.isEditable = _data['isEditable'];
    this.name = _data['name'];
    this.label = _data['label'];
    this.description = _data['description'];
    this.type = _data['type'];
    this.defaultValue = _data['defaultValue'];
    this.regularExpression = _data['regularExpression'];
    if (Array.isArray(_data['enumValues'])) {
      this.enumValues = [];
      for (let item of _data['enumValues']) this.enumValues.push(item);
    }
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.isRequired = this.isRequired;
    data.isEditable = this.isEditable;
    data.name = this.name;
    data.label = this.label;
    data.description = this.description;
    data.type = this.type;
    data.defaultValue = this.defaultValue;
    data.regularExpression = this.regularExpression;
    if (Array.isArray(this.enumValues)) {
      data['enumValues'] = [];
      for (let item of this.enumValues) data['enumValues'].push(item);
    }
    return data;
  }
}
exports.Property = Property;
class MarketSurveillanceLine {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new MarketSurveillanceLine();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.periodFrom = _data['periodFrom'] ? new Date(_data['periodFrom'].toString()) : undefined;
    this.periodTo = _data['periodTo'] ? new Date(_data['periodTo'].toString()) : undefined;
    this.baselineSumMwhh = _data['baselineSumMwhh'];
    this.baselineAvgMw = _data['baselineAvgMw'];
    this.meterReadingSumMwhh = _data['meterReadingSumMwhh'];
    this.meterReadingAvgMw = _data['meterReadingAvgMw'];
    this.deviationAbsoluteSumMwhh = _data['deviationAbsoluteSumMwhh'];
    this.deviationAbsoluteAvgMw = _data['deviationAbsoluteAvgMw'];
    this.deviationUpSumMwhh = _data['deviationUpSumMwhh'];
    this.deviationUpAvgMw = _data['deviationUpAvgMw'];
    this.deviationDownSumMwhh = _data['deviationDownSumMwhh'];
    this.deviationDownAvgMw = _data['deviationDownAvgMw'];
    this.accuracyPercentage = _data['accuracyPercentage'];
    this.tradedVolumeSumMwhh = _data['tradedVolumeSumMwhh'];
    this.tradedVolumeAvgMw = _data['tradedVolumeAvgMw'];
    this.deviationAbsoluteSumMwhhTradeCorrected = _data['deviationAbsoluteSumMwhhTradeCorrected'];
    this.deviationAbsoluteAvgMwTradeCorrected = _data['deviationAbsoluteAvgMwTradeCorrected'];
    this.deviationUpSumMwhhTradeCorrected = _data['deviationUpSumMwhhTradeCorrected'];
    this.deviationUpAvgMwTradeCorrected = _data['deviationUpAvgMwTradeCorrected'];
    this.deviationDownSumMwhhTradeCorrected = _data['deviationDownSumMwhhTradeCorrected'];
    this.deviationDownAvgMwTradeCorrected = _data['deviationDownAvgMwTradeCorrected'];
    this.accuracyPercentageTradeCorrected = _data['accuracyPercentageTradeCorrected'];
    this.totalBaselinesExpected = _data['totalBaselinesExpected'];
    this.totalBaselinesFound = _data['totalBaselinesFound'];
    this.totalMeterReadingsExpected = _data['totalMeterReadingsExpected'];
    this.totalMeterReadingsFound = _data['totalMeterReadingsFound'];
    this.marketId = _data['marketId'];
    this.fspId = _data['fspId'];
    this.fspName = _data['fspName'];
    this.assetPortfolioId = _data['assetPortfolioId'];
    this.assetPortfolioName = _data['assetPortfolioName'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data['periodFrom'] = this.periodFrom ? this.periodFrom.toISOString() : undefined;
    data['periodTo'] = this.periodTo ? this.periodTo.toISOString() : undefined;
    data.baselineSumMwhh = this.baselineSumMwhh;
    data.baselineAvgMw = this.baselineAvgMw;
    data.meterReadingSumMwhh = this.meterReadingSumMwhh;
    data.meterReadingAvgMw = this.meterReadingAvgMw;
    data.deviationAbsoluteSumMwhh = this.deviationAbsoluteSumMwhh;
    data.deviationAbsoluteAvgMw = this.deviationAbsoluteAvgMw;
    data.deviationUpSumMwhh = this.deviationUpSumMwhh;
    data.deviationUpAvgMw = this.deviationUpAvgMw;
    data.deviationDownSumMwhh = this.deviationDownSumMwhh;
    data.deviationDownAvgMw = this.deviationDownAvgMw;
    data.accuracyPercentage = this.accuracyPercentage;
    data.tradedVolumeSumMwhh = this.tradedVolumeSumMwhh;
    data.tradedVolumeAvgMw = this.tradedVolumeAvgMw;
    data.deviationAbsoluteSumMwhhTradeCorrected = this.deviationAbsoluteSumMwhhTradeCorrected;
    data.deviationAbsoluteAvgMwTradeCorrected = this.deviationAbsoluteAvgMwTradeCorrected;
    data.deviationUpSumMwhhTradeCorrected = this.deviationUpSumMwhhTradeCorrected;
    data.deviationUpAvgMwTradeCorrected = this.deviationUpAvgMwTradeCorrected;
    data.deviationDownSumMwhhTradeCorrected = this.deviationDownSumMwhhTradeCorrected;
    data.deviationDownAvgMwTradeCorrected = this.deviationDownAvgMwTradeCorrected;
    data.accuracyPercentageTradeCorrected = this.accuracyPercentageTradeCorrected;
    data.totalBaselinesExpected = this.totalBaselinesExpected;
    data.totalBaselinesFound = this.totalBaselinesFound;
    data.totalMeterReadingsExpected = this.totalMeterReadingsExpected;
    data.totalMeterReadingsFound = this.totalMeterReadingsFound;
    data.marketId = this.marketId;
    data.fspId = this.fspId;
    data.fspName = this.fspName;
    data.assetPortfolioId = this.assetPortfolioId;
    data.assetPortfolioName = this.assetPortfolioName;
    return data;
  }
}
exports.MarketSurveillanceLine = MarketSurveillanceLine;
class QueryReportParameter {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new QueryReportParameter();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.optional = _data['optional'];
    this.multiSelect = _data['multiSelect'];
    this.defaultValue = _data['defaultValue'];
    this.type = _data['type'];
    this.name = _data['name'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.optional = this.optional;
    data.multiSelect = this.multiSelect;
    data.defaultValue = this.defaultValue;
    data.type = this.type;
    data.name = this.name;
    return data;
  }
}
exports.QueryReportParameter = QueryReportParameter;
class QueryReport {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new QueryReport();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    if (Array.isArray(_data['parameters'])) {
      this.parameters = [];
      for (let item of _data['parameters']) this.parameters.push(QueryReportParameter.fromJS(item));
    }
    this.id = _data['id'];
    this.name = _data['name'];
    this.description = _data['description'];
    this.query = _data['query'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.parameters)) {
      data['parameters'] = [];
      for (let item of this.parameters) data['parameters'].push(item.toJSON());
    }
    data.id = this.id;
    data.name = this.name;
    data.description = this.description;
    data.query = this.query;
    return data;
  }
}
exports.QueryReport = QueryReport;
class ColumnDescription {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new ColumnDescription();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.dataType = _data['dataType'];
    this.name = _data['name'];
    this.displayName = _data['displayName'];
    this.description = _data['description'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.dataType = this.dataType;
    data.name = this.name;
    data.displayName = this.displayName;
    data.description = this.description;
    return data;
  }
}
exports.ColumnDescription = ColumnDescription;
class NodesMessage {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new NodesMessage();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.success = _data['success'];
    this.payload = _data['payload'];
    this.messageType = _data['messageType'];
    this.errorCode = _data['errorCode'];
    this.errorMessage = _data['errorMessage'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.success = this.success;
    data.payload = this.payload;
    data.messageType = this.messageType;
    data.errorCode = this.errorCode;
    data.errorMessage = this.errorMessage;
    return data;
  }
}
exports.NodesMessage = NodesMessage;
class Job {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new Job();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    if (Array.isArray(_data['subJobs'])) {
      this.subJobs = [];
      for (let item of _data['subJobs']) this.subJobs.push(Job.fromJS(item));
    }
    this.jobId = _data['jobId'];
    this.status = _data['status'];
    this.message = _data['message'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.subJobs)) {
      data['subJobs'] = [];
      for (let item of this.subJobs) data['subJobs'].push(item.toJSON());
    }
    data.jobId = this.jobId;
    data.status = this.status;
    data.message = this.message;
    return data;
  }
}
exports.Job = Job;
class OrderChangeCommand {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new OrderChangeCommand();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.before = _data['before'];
    this.patch = _data['patch'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.before = this.before;
    data.patch = this.patch;
    return data;
  }
}
exports.OrderChangeCommand = OrderChangeCommand;
class OrderChangeEvent {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new OrderChangeEvent();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.patch = _data['patch'];
    this.after = _data['after'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.patch = this.patch;
    data.after = this.after;
    return data;
  }
}
exports.OrderChangeEvent = OrderChangeEvent;
class RecommendationScoreCard {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new RecommendationScoreCard();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.recommended = _data['recommended'];
    this.isRecommendable = _data['isRecommendable'];
    this.sumWeightedScoreRounded = _data['sumWeightedScoreRounded'];
    this.sumWeightedScore = _data['sumWeightedScore'];
    if (Array.isArray(_data['scores'])) {
      this.scores = [];
      for (let item of _data['scores']) this.scores.push(RecommendationWeightedScore.fromJS(item));
    }
    this.contractId = _data['contractId'];
    this.recommendationDetails = _data['recommendationDetails'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.recommended = this.recommended;
    data.isRecommendable = this.isRecommendable;
    data.sumWeightedScoreRounded = this.sumWeightedScoreRounded;
    data.sumWeightedScore = this.sumWeightedScore;
    if (Array.isArray(this.scores)) {
      data['scores'] = [];
      for (let item of this.scores) data['scores'].push(item.toJSON());
    }
    data.contractId = this.contractId;
    data.recommendationDetails = this.recommendationDetails;
    return data;
  }
}
exports.RecommendationScoreCard = RecommendationScoreCard;
class RecommendationScore {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new RecommendationScore();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.score = _data['score'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.score = this.score;
    return data;
  }
}
exports.RecommendationScore = RecommendationScore;
class RecommendationWeightedScore {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new RecommendationWeightedScore();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.scoreRounded = _data['scoreRounded'];
    this.weightedScoreRounded = _data['weightedScoreRounded'];
    this.weightedScore = _data['weightedScore'];
    this.recommendationScore = _data['recommendationScore'];
    this.recommendationWeightedParameter = _data['recommendationWeightedParameter'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.scoreRounded = this.scoreRounded;
    data.weightedScoreRounded = this.weightedScoreRounded;
    data.weightedScore = this.weightedScore;
    data.recommendationScore = this.recommendationScore;
    data.recommendationWeightedParameter = this.recommendationWeightedParameter;
    return data;
  }
}
exports.RecommendationWeightedScore = RecommendationWeightedScore;
class RecommendationWeightedParameter {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new RecommendationWeightedParameter();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.weightPercentage = _data['weightPercentage'];
    this.parameterName = _data['parameterName'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.weightPercentage = this.weightPercentage;
    data.parameterName = this.parameterName;
    return data;
  }
}
exports.RecommendationWeightedParameter = RecommendationWeightedParameter;
class Polygon {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new Polygon();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.exterior = _data['exterior'];
    if (Array.isArray(_data['holes'])) {
      this.holes = [];
      for (let item of _data['holes']) this.holes.push(SimplePolygon.fromJS(item));
    }
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.exterior = this.exterior;
    if (Array.isArray(this.holes)) {
      data['holes'] = [];
      for (let item of this.holes) data['holes'].push(item.toJSON());
    }
    return data;
  }
}
exports.Polygon = Polygon;
class SimplePolygon {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new SimplePolygon();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.item = _data['item'];
    this.capacity = _data['capacity'];
    this.count = _data['count'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.item = this.item;
    data.capacity = this.capacity;
    data.count = this.count;
    return data;
  }
}
exports.SimplePolygon = SimplePolygon;
class DigestProviderInfo {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new DigestProviderInfo();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.usesMarketId = _data['usesMarketId'];
    this.usesGridAreaId = _data['usesGridAreaId'];
    this.code = _data['code'];
    this.name = _data['name'];
    this.description = _data['description'];
    this.groupName = _data['groupName'];
    if (Array.isArray(_data['subscriptionTypes'])) {
      this.subscriptionTypes = [];
      for (let item of _data['subscriptionTypes']) this.subscriptionTypes.push(item);
    }
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.usesMarketId = this.usesMarketId;
    data.usesGridAreaId = this.usesGridAreaId;
    data.code = this.code;
    data.name = this.name;
    data.description = this.description;
    data.groupName = this.groupName;
    if (Array.isArray(this.subscriptionTypes)) {
      data['subscriptionTypes'] = [];
      for (let item of this.subscriptionTypes) data['subscriptionTypes'].push(item);
    }
    return data;
  }
}
exports.DigestProviderInfo = DigestProviderInfo;
class BaseLineDeletionQuery {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new BaseLineDeletionQuery();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.periodFrom = _data['periodFrom'] ? new Date(_data['periodFrom'].toString()) : undefined;
    this.periodTo = _data['periodTo'] ? new Date(_data['periodTo'].toString()) : undefined;
    this.quantityType = _data['quantityType'];
    this.assetPortfolioId = _data['assetPortfolioId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data['periodFrom'] = this.periodFrom ? this.periodFrom.toISOString() : undefined;
    data['periodTo'] = this.periodTo ? this.periodTo.toISOString() : undefined;
    data.quantityType = this.quantityType;
    data.assetPortfolioId = this.assetPortfolioId;
    return data;
  }
}
exports.BaseLineDeletionQuery = BaseLineDeletionQuery;
class BalanceReportRow {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new BalanceReportRow();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.periodFrom = _data['periodFrom'] ? new Date(_data['periodFrom'].toString()) : undefined;
    this.periodTo = _data['periodTo'] ? new Date(_data['periodTo'].toString()) : undefined;
    if (Array.isArray(_data['links'])) {
      this.links = [];
      for (let item of _data['links']) this.links.push(NodesLink.fromJS(item));
    }
    this.totalVolume = _data['totalVolume'];
    this.baseVolume = _data['baseVolume'];
    this.extraVolume = _data['extraVolume'];
    this.retailerOrganizationId = _data['retailerOrganizationId'];
    this.retailerOrganizationName = _data['retailerOrganizationName'];
    this.supplierOrganizationId = _data['supplierOrganizationId'];
    this.supplierOrganizationName = _data['supplierOrganizationName'];
    this.id = _data['id'];
    if (Array.isArray(_data['buyerOrganizationIds'])) {
      this.buyerOrganizationIds = [];
      for (let item of _data['buyerOrganizationIds']) this.buyerOrganizationIds.push(item);
    }
    if (Array.isArray(_data['buyerOrganizationNames'])) {
      this.buyerOrganizationNames = [];
      for (let item of _data['buyerOrganizationNames']) this.buyerOrganizationNames.push(item);
    }
    if (Array.isArray(_data['assetPortfolioIds'])) {
      this.assetPortfolioIds = [];
      for (let item of _data['assetPortfolioIds']) this.assetPortfolioIds.push(item);
    }
    if (Array.isArray(_data['assetPortfolioNames'])) {
      this.assetPortfolioNames = [];
      for (let item of _data['assetPortfolioNames']) this.assetPortfolioNames.push(item);
    }
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data['periodFrom'] = this.periodFrom ? this.periodFrom.toISOString() : undefined;
    data['periodTo'] = this.periodTo ? this.periodTo.toISOString() : undefined;
    if (Array.isArray(this.links)) {
      data['links'] = [];
      for (let item of this.links) data['links'].push(item.toJSON());
    }
    data.totalVolume = this.totalVolume;
    data.baseVolume = this.baseVolume;
    data.extraVolume = this.extraVolume;
    data.retailerOrganizationId = this.retailerOrganizationId;
    data.retailerOrganizationName = this.retailerOrganizationName;
    data.supplierOrganizationId = this.supplierOrganizationId;
    data.supplierOrganizationName = this.supplierOrganizationName;
    data.id = this.id;
    if (Array.isArray(this.buyerOrganizationIds)) {
      data['buyerOrganizationIds'] = [];
      for (let item of this.buyerOrganizationIds) data['buyerOrganizationIds'].push(item);
    }
    if (Array.isArray(this.buyerOrganizationNames)) {
      data['buyerOrganizationNames'] = [];
      for (let item of this.buyerOrganizationNames) data['buyerOrganizationNames'].push(item);
    }
    if (Array.isArray(this.assetPortfolioIds)) {
      data['assetPortfolioIds'] = [];
      for (let item of this.assetPortfolioIds) data['assetPortfolioIds'].push(item);
    }
    if (Array.isArray(this.assetPortfolioNames)) {
      data['assetPortfolioNames'] = [];
      for (let item of this.assetPortfolioNames) data['assetPortfolioNames'].push(item);
    }
    return data;
  }
}
exports.BalanceReportRow = BalanceReportRow;
class BalanceReportQuery {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new BalanceReportQuery();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    this.periodFrom = _data['periodFrom'] ? new Date(_data['periodFrom'].toString()) : undefined;
    this.periodTo = _data['periodTo'] ? new Date(_data['periodTo'].toString()) : undefined;
    this.reportBlockSizeInMinutes = _data['reportBlockSizeInMinutes'];
    this.marketId = _data['marketId'];
    this.buyerOrganizationId = _data['buyerOrganizationId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data['periodFrom'] = this.periodFrom ? this.periodFrom.toISOString() : undefined;
    data['periodTo'] = this.periodTo ? this.periodTo.toISOString() : undefined;
    data.reportBlockSizeInMinutes = this.reportBlockSizeInMinutes;
    data.marketId = this.marketId;
    data.buyerOrganizationId = this.buyerOrganizationId;
    return data;
  }
}
exports.BalanceReportQuery = BalanceReportQuery;
class ApplicationUserMapping extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new ApplicationUserMapping();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.name = _data['name'];
    this.userId = _data['userId'];
    this.b2CApplicationId = _data['b2CApplicationId'];
    this.b2CObjectId = _data['b2CObjectId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.name = this.name;
    data.userId = this.userId;
    data.b2CApplicationId = this.b2CApplicationId;
    data.b2CObjectId = this.b2CObjectId;
    super.toJSON(data);
    return data;
  }
}
exports.ApplicationUserMapping = ApplicationUserMapping;
class Asset extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new Asset();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.customProperties = _data['customProperties'];
    this.rampUpRate = _data['rampUpRate'];
    this.rampDownRate = _data['rampDownRate'];
    this.installedCapacity = _data['installedCapacity'];
    this.name = _data['name'];
    this.comments = _data['comments'];
    this.assetTypeId = _data['assetTypeId'];
    this.operatedByOrganizationId = _data['operatedByOrganizationId'];
    this.externalReference = _data['externalReference'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.customProperties = this.customProperties;
    data.rampUpRate = this.rampUpRate;
    data.rampDownRate = this.rampDownRate;
    data.installedCapacity = this.installedCapacity;
    data.name = this.name;
    data.comments = this.comments;
    data.assetTypeId = this.assetTypeId;
    data.operatedByOrganizationId = this.operatedByOrganizationId;
    data.externalReference = this.externalReference;
    super.toJSON(data);
    return data;
  }
}
exports.Asset = Asset;
class AssetGridAssignment extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new AssetGridAssignment();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.location = _data['location'];
    this.powerContribution = _data['powerContribution'];
    this.assetId = _data['assetId'];
    this.managedByOrganizationId = _data['managedByOrganizationId'];
    this.mpid = _data['mpid'];
    this.externalReference = _data['externalReference'];
    this.baselineReference = _data['baselineReference'];
    this.meterReadingReference = _data['meterReadingReference'];
    this.gridNodeId = _data['gridNodeId'];
    this.operatedByOrganizationId = _data['operatedByOrganizationId'];
    this.supplierOrganizationId = _data['supplierOrganizationId'];
    this.retailerOrganizationId = _data['retailerOrganizationId'];
    this.subMeterId = _data['subMeterId'];
    this.comments = _data['comments'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.location = this.location;
    data.powerContribution = this.powerContribution;
    data.assetId = this.assetId;
    data.managedByOrganizationId = this.managedByOrganizationId;
    data.mpid = this.mpid;
    data.externalReference = this.externalReference;
    data.baselineReference = this.baselineReference;
    data.meterReadingReference = this.meterReadingReference;
    data.gridNodeId = this.gridNodeId;
    data.operatedByOrganizationId = this.operatedByOrganizationId;
    data.supplierOrganizationId = this.supplierOrganizationId;
    data.retailerOrganizationId = this.retailerOrganizationId;
    data.subMeterId = this.subMeterId;
    data.comments = this.comments;
    super.toJSON(data);
    return data;
  }
}
exports.AssetGridAssignment = AssetGridAssignment;
class AssetPortfolio extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new AssetPortfolio();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.customProperties = _data['customProperties'];
    this.baselineProvider = _data['baselineProvider'];
    this.aggregateBaselinesFromAssets = _data['aggregateBaselinesFromAssets'];
    this.aggregateMeterReadingsFromAssets = _data['aggregateMeterReadingsFromAssets'];
    this.meterReadingProvider = _data['meterReadingProvider'];
    this.meterReadingsAggregationLevel = _data['meterReadingsAggregationLevel'];
    this.rampUpRate = _data['rampUpRate'];
    this.rampDownRate = _data['rampDownRate'];
    this.minRampUpRate = _data['minRampUpRate'];
    this.maxRampUpRate = _data['maxRampUpRate'];
    this.minRampDownRate = _data['minRampDownRate'];
    this.maxRampDownRate = _data['maxRampDownRate'];
    this.renewableType = _data['renewableType'];
    this.managedByOrganizationId = _data['managedByOrganizationId'];
    this.supplierOrganizationId = _data['supplierOrganizationId'];
    this.retailerOrganizationId = _data['retailerOrganizationId'];
    this.marketId = _data['marketId'];
    this.name = _data['name'];
    this.baselineReference = _data['baselineReference'];
    this.meterReadingReference = _data['meterReadingReference'];
    this.externalReference = _data['externalReference'];
    this.comments = _data['comments'];
    this.assetTypeId = _data['assetTypeId'];
    this.gridNodeId = _data['gridNodeId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.customProperties = this.customProperties;
    data.baselineProvider = this.baselineProvider;
    data.aggregateBaselinesFromAssets = this.aggregateBaselinesFromAssets;
    data.aggregateMeterReadingsFromAssets = this.aggregateMeterReadingsFromAssets;
    data.meterReadingProvider = this.meterReadingProvider;
    data.meterReadingsAggregationLevel = this.meterReadingsAggregationLevel;
    data.rampUpRate = this.rampUpRate;
    data.rampDownRate = this.rampDownRate;
    data.minRampUpRate = this.minRampUpRate;
    data.maxRampUpRate = this.maxRampUpRate;
    data.minRampDownRate = this.minRampDownRate;
    data.maxRampDownRate = this.maxRampDownRate;
    data.renewableType = this.renewableType;
    data.managedByOrganizationId = this.managedByOrganizationId;
    data.supplierOrganizationId = this.supplierOrganizationId;
    data.retailerOrganizationId = this.retailerOrganizationId;
    data.marketId = this.marketId;
    data.name = this.name;
    data.baselineReference = this.baselineReference;
    data.meterReadingReference = this.meterReadingReference;
    data.externalReference = this.externalReference;
    data.comments = this.comments;
    data.assetTypeId = this.assetTypeId;
    data.gridNodeId = this.gridNodeId;
    super.toJSON(data);
    return data;
  }
}
exports.AssetPortfolio = AssetPortfolio;
class AssetPortfolioAggregation extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new AssetPortfolioAggregation();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.marketId = _data['marketId'];
    this.assetPortfolioId = _data['assetPortfolioId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.marketId = this.marketId;
    data.assetPortfolioId = this.assetPortfolioId;
    super.toJSON(data);
    return data;
  }
}
exports.AssetPortfolioAggregation = AssetPortfolioAggregation;
class AssetPortfolioAssignment extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new AssetPortfolioAssignment();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.sysStartTime = _data['sysStartTime'] ? new Date(_data['sysStartTime'].toString()) : undefined;
    this.sysEndTime = _data['sysEndTime'] ? new Date(_data['sysEndTime'].toString()) : undefined;
    this.assetGridAssignmentId = _data['assetGridAssignmentId'];
    this.assetPortfolioId = _data['assetPortfolioId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data['sysStartTime'] = this.sysStartTime ? this.sysStartTime.toISOString() : undefined;
    data['sysEndTime'] = this.sysEndTime ? this.sysEndTime.toISOString() : undefined;
    data.assetGridAssignmentId = this.assetGridAssignmentId;
    data.assetPortfolioId = this.assetPortfolioId;
    super.toJSON(data);
    return data;
  }
}
exports.AssetPortfolioAssignment = AssetPortfolioAssignment;
class AssetType extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new AssetType();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.isRenewable = _data['isRenewable'];
    this.canConsume = _data['canConsume'];
    this.canProduce = _data['canProduce'];
    this.name = _data['name'];
    this.description = _data['description'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.isRenewable = this.isRenewable;
    data.canConsume = this.canConsume;
    data.canProduce = this.canProduce;
    data.name = this.name;
    data.description = this.description;
    super.toJSON(data);
    return data;
  }
}
exports.AssetType = AssetType;
class BankInfo extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new BankInfo();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.organizationId = _data['organizationId'];
    this.marketId = _data['marketId'];
    this.countryId = _data['countryId'];
    this.bankAccountName = _data['bankAccountName'];
    this.bankAccountNumber = _data['bankAccountNumber'];
    this.iban = _data['iban'];
    this.swift = _data['swift'];
    this.bic = _data['bic'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.organizationId = this.organizationId;
    data.marketId = this.marketId;
    data.countryId = this.countryId;
    data.bankAccountName = this.bankAccountName;
    data.bankAccountNumber = this.bankAccountNumber;
    data.iban = this.iban;
    data.swift = this.swift;
    data.bic = this.bic;
    super.toJSON(data);
    return data;
  }
}
exports.BankInfo = BankInfo;
class BaseLineInterval extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new BaseLineInterval();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.provider = _data['provider'];
    this.periodFrom = _data['periodFrom'] ? new Date(_data['periodFrom'].toString()) : undefined;
    this.periodTo = _data['periodTo'] ? new Date(_data['periodTo'].toString()) : undefined;
    this.quantity = _data['quantity'];
    this.quantityType = _data['quantityType'];
    this.assetPortfolioId = _data['assetPortfolioId'];
    this.batchReference = _data['batchReference'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.provider = this.provider;
    data['periodFrom'] = this.periodFrom ? this.periodFrom.toISOString() : undefined;
    data['periodTo'] = this.periodTo ? this.periodTo.toISOString() : undefined;
    data.quantity = this.quantity;
    data.quantityType = this.quantityType;
    data.assetPortfolioId = this.assetPortfolioId;
    data.batchReference = this.batchReference;
    super.toJSON(data);
    return data;
  }
}
exports.BaseLineInterval = BaseLineInterval;
class BaseLinePrognosisSettings extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new BaseLinePrognosisSettings();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.meterReadingProvider = _data['meterReadingProvider'];
    this.prognosisHourCount = _data['prognosisHourCount'];
    this.compensationFactor = _data['compensationFactor'];
    this.historyHourCount = _data['historyHourCount'];
    this.quantityType = _data['quantityType'];
    this.assetPortfolioId = _data['assetPortfolioId'];
    this.compensationSource = _data['compensationSource'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.meterReadingProvider = this.meterReadingProvider;
    data.prognosisHourCount = this.prognosisHourCount;
    data.compensationFactor = this.compensationFactor;
    data.historyHourCount = this.historyHourCount;
    data.quantityType = this.quantityType;
    data.assetPortfolioId = this.assetPortfolioId;
    data.compensationSource = this.compensationSource;
    super.toJSON(data);
    return data;
  }
}
exports.BaseLinePrognosisSettings = BaseLinePrognosisSettings;
class Country extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new Country();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.numeric = _data['numeric'];
    this.name = _data['name'];
    this.alpha2 = _data['alpha2'];
    this.alpha3 = _data['alpha3'];
    this.currencyCode = _data['currencyCode'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.numeric = this.numeric;
    data.name = this.name;
    data.alpha2 = this.alpha2;
    data.alpha3 = this.alpha3;
    data.currencyCode = this.currencyCode;
    super.toJSON(data);
    return data;
  }
}
exports.Country = Country;
class Currency extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new Currency();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.name = _data['name'];
    this.code = _data['code'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.name = this.name;
    data.code = this.code;
    super.toJSON(data);
    return data;
  }
}
exports.Currency = Currency;
class DayAheadAuctionSettings extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new DayAheadAuctionSettings();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.marketId = _data['marketId'];
    this.auctionGateClose = _data['auctionGateClose'];
    this.intradayLeadTime = _data['intradayLeadTime'];
    this.auctionTime = _data['auctionTime'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.marketId = this.marketId;
    data.auctionGateClose = this.auctionGateClose;
    data.intradayLeadTime = this.intradayLeadTime;
    data.auctionTime = this.auctionTime;
    super.toJSON(data);
    return data;
  }
}
exports.DayAheadAuctionSettings = DayAheadAuctionSettings;
class Deal extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new Deal();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.periodFrom = _data['periodFrom'] ? new Date(_data['periodFrom'].toString()) : undefined;
    this.periodTo = _data['periodTo'] ? new Date(_data['periodTo'].toString()) : undefined;
    this.quantity = _data['quantity'];
    this.unitPrice = _data['unitPrice'];
    this.regulationType = _data['regulationType'];
    this.marketId = _data['marketId'];
    this.gridNodeId = _data['gridNodeId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data['periodFrom'] = this.periodFrom ? this.periodFrom.toISOString() : undefined;
    data['periodTo'] = this.periodTo ? this.periodTo.toISOString() : undefined;
    data.quantity = this.quantity;
    data.unitPrice = this.unitPrice;
    data.regulationType = this.regulationType;
    data.marketId = this.marketId;
    data.gridNodeId = this.gridNodeId;
    super.toJSON(data);
    return data;
  }
}
exports.Deal = Deal;
class DigestEvent extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new DigestEvent();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.payload = _data['payload'];
    this.eventTimeStamp = _data['eventTimeStamp'] ? new Date(_data['eventTimeStamp'].toString()) : undefined;
    this.eventType = _data['eventType'];
    this.initiatorUserId = _data['initiatorUserId'];
    this.visibility = _data['visibility'];
    this.marketId = _data['marketId'];
    this.gridAreaId = _data['gridAreaId'];
    this.title = _data['title'];
    this.url = _data['url'];
    if (Array.isArray(_data['visibleToOrganizationIds'])) {
      this.visibleToOrganizationIds = [];
      for (let item of _data['visibleToOrganizationIds']) this.visibleToOrganizationIds.push(item);
    }
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.payload = this.payload;
    data['eventTimeStamp'] = this.eventTimeStamp ? this.eventTimeStamp.toISOString() : undefined;
    data.eventType = this.eventType;
    data.initiatorUserId = this.initiatorUserId;
    data.visibility = this.visibility;
    data.marketId = this.marketId;
    data.gridAreaId = this.gridAreaId;
    data.title = this.title;
    data.url = this.url;
    if (Array.isArray(this.visibleToOrganizationIds)) {
      data['visibleToOrganizationIds'] = [];
      for (let item of this.visibleToOrganizationIds) data['visibleToOrganizationIds'].push(item);
    }
    super.toJSON(data);
    return data;
  }
}
exports.DigestEvent = DigestEvent;
class DigestLog extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new DigestLog();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.processedAt = _data['processedAt'] ? new Date(_data['processedAt'].toString()) : undefined;
    this.digestSubscriptionId = _data['digestSubscriptionId'];
    this.digestLogInfo = _data['digestLogInfo'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data['processedAt'] = this.processedAt ? this.processedAt.toISOString() : undefined;
    data.digestSubscriptionId = this.digestSubscriptionId;
    data.digestLogInfo = this.digestLogInfo;
    super.toJSON(data);
    return data;
  }
}
exports.DigestLog = DigestLog;
class DigestSubscription extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new DigestSubscription();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.ownerUserId = _data['ownerUserId'];
    this.periodSpecification = _data['periodSpecification'];
    this.startSpecification = _data['startSpecification'];
    this.email = _data['email'];
    this.digestProvider = _data['digestProvider'];
    this.timeZone = _data['timeZone'];
    this.culture = _data['culture'];
    if (Array.isArray(_data['marketIds'])) {
      this.marketIds = [];
      for (let item of _data['marketIds']) this.marketIds.push(item);
    }
    if (Array.isArray(_data['gridAreaIds'])) {
      this.gridAreaIds = [];
      for (let item of _data['gridAreaIds']) this.gridAreaIds.push(item);
    }
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.ownerUserId = this.ownerUserId;
    data.periodSpecification = this.periodSpecification;
    data.startSpecification = this.startSpecification;
    data.email = this.email;
    data.digestProvider = this.digestProvider;
    data.timeZone = this.timeZone;
    data.culture = this.culture;
    if (Array.isArray(this.marketIds)) {
      data['marketIds'] = [];
      for (let item of this.marketIds) data['marketIds'].push(item);
    }
    if (Array.isArray(this.gridAreaIds)) {
      data['gridAreaIds'] = [];
      for (let item of this.gridAreaIds) data['gridAreaIds'].push(item);
    }
    super.toJSON(data);
    return data;
  }
}
exports.DigestSubscription = DigestSubscription;
class DispatchConfiguration extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new DispatchConfiguration();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.eventType = _data['eventType'];
    this.notificationType = _data['notificationType'];
    this.name = _data['name'];
    this.marketId = _data['marketId'];
    this.assetPortfolioId = _data['assetPortfolioId'];
    this.notificationParameters = _data['notificationParameters'];
    this.schedule = _data['schedule'];
    this.ownerOrganizationId = _data['ownerOrganizationId'];
    this.ownerUserId = _data['ownerUserId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.eventType = this.eventType;
    data.notificationType = this.notificationType;
    data.name = this.name;
    data.marketId = this.marketId;
    data.assetPortfolioId = this.assetPortfolioId;
    data.notificationParameters = this.notificationParameters;
    data.schedule = this.schedule;
    data.ownerOrganizationId = this.ownerOrganizationId;
    data.ownerUserId = this.ownerUserId;
    super.toJSON(data);
    return data;
  }
}
exports.DispatchConfiguration = DispatchConfiguration;
class DispatchNotification extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new DispatchNotification();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.eventType = _data['eventType'];
    this.notificationType = _data['notificationType'];
    this.tradeId = _data['tradeId'];
    this.marketId = _data['marketId'];
    this.emailMessageId = _data['emailMessageId'];
    this.smsMessageId = _data['smsMessageId'];
    this.httpGetInvocationId = _data['httpGetInvocationId'];
    this.httpPostInvocationId = _data['httpPostInvocationId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.eventType = this.eventType;
    data.notificationType = this.notificationType;
    data.tradeId = this.tradeId;
    data.marketId = this.marketId;
    data.emailMessageId = this.emailMessageId;
    data.smsMessageId = this.smsMessageId;
    data.httpGetInvocationId = this.httpGetInvocationId;
    data.httpPostInvocationId = this.httpPostInvocationId;
    super.toJSON(data);
    return data;
  }
}
exports.DispatchNotification = DispatchNotification;
class GridArea extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new GridArea();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.isPubliclyVisible = _data['isPubliclyVisible'];
    this.gridNodePolygonVisibility = _data['gridNodePolygonVisibility'];
    this.name = _data['name'];
    this.description = _data['description'];
    this.countryId = _data['countryId'];
    this.mapPolygonId = _data['mapPolygonId'];
    this.operatedByOrganizationId = _data['operatedByOrganizationId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.isPubliclyVisible = this.isPubliclyVisible;
    data.gridNodePolygonVisibility = this.gridNodePolygonVisibility;
    data.name = this.name;
    data.description = this.description;
    data.countryId = this.countryId;
    data.mapPolygonId = this.mapPolygonId;
    data.operatedByOrganizationId = this.operatedByOrganizationId;
    super.toJSON(data);
    return data;
  }
}
exports.GridArea = GridArea;
class GridGroup extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new GridGroup();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.name = _data['name'];
    this.description = _data['description'];
    this.ownerOrganizationId = _data['ownerOrganizationId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.name = this.name;
    data.description = this.description;
    data.ownerOrganizationId = this.ownerOrganizationId;
    super.toJSON(data);
    return data;
  }
}
exports.GridGroup = GridGroup;
class GridGroupAssignment extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new GridGroupAssignment();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.gridNodeId = _data['gridNodeId'];
    this.gridGroupId = _data['gridGroupId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.gridNodeId = this.gridNodeId;
    data.gridGroupId = this.gridGroupId;
    super.toJSON(data);
    return data;
  }
}
exports.GridGroupAssignment = GridGroupAssignment;
class GridLocation extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new GridLocation();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.isPubliclyVisible = _data['isPubliclyVisible'];
    this.validFrom = _data['validFrom'] ? new Date(_data['validFrom'].toString()) : undefined;
    this.validTo = _data['validTo'] ? new Date(_data['validTo'].toString()) : undefined;
    this.quantity = _data['quantity'];
    this.activationPrice = _data['activationPrice'];
    this.reservationPrice = _data['reservationPrice'];
    this.quantityType = _data['quantityType'];
    this.regulationType = _data['regulationType'];
    this.name = _data['name'];
    this.ownerOrganizationId = _data['ownerOrganizationId'];
    this.marketId = _data['marketId'];
    this.gridNodeId = _data['gridNodeId'];
    this.currencyId = _data['currencyId'];
    this.comments = _data['comments'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.isPubliclyVisible = this.isPubliclyVisible;
    data['validFrom'] = this.validFrom ? this.validFrom.toISOString() : undefined;
    data['validTo'] = this.validTo ? this.validTo.toISOString() : undefined;
    data.quantity = this.quantity;
    data.activationPrice = this.activationPrice;
    data.reservationPrice = this.reservationPrice;
    data.quantityType = this.quantityType;
    data.regulationType = this.regulationType;
    data.name = this.name;
    data.ownerOrganizationId = this.ownerOrganizationId;
    data.marketId = this.marketId;
    data.gridNodeId = this.gridNodeId;
    data.currencyId = this.currencyId;
    data.comments = this.comments;
    super.toJSON(data);
    return data;
  }
}
exports.GridLocation = GridLocation;
class GridNode extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new GridNode();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.customProperties = _data['customProperties'];
    this.portfoliosBlocked = _data['portfoliosBlocked'];
    this.location = _data['location'];
    this.name = _data['name'];
    this.comments = _data['comments'];
    this.operatedByOrganizationId = _data['operatedByOrganizationId'];
    this.priceAreaId = _data['priceAreaId'];
    this.mapPolygonId = _data['mapPolygonId'];
    this.gridAreaId = _data['gridAreaId'];
    this.mpid = _data['mpid'];
    this.gridNodeType = _data['gridNodeType'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.customProperties = this.customProperties;
    data.portfoliosBlocked = this.portfoliosBlocked;
    data.location = this.location;
    data.name = this.name;
    data.comments = this.comments;
    data.operatedByOrganizationId = this.operatedByOrganizationId;
    data.priceAreaId = this.priceAreaId;
    data.mapPolygonId = this.mapPolygonId;
    data.gridAreaId = this.gridAreaId;
    data.mpid = this.mpid;
    data.gridNodeType = this.gridNodeType;
    super.toJSON(data);
    return data;
  }
}
exports.GridNode = GridNode;
class GridNodeLink extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new GridNodeLink();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.capacityIn = _data['capacityIn'];
    this.capacityOut = _data['capacityOut'];
    this.sensitivity = _data['sensitivity'];
    this.sourceGridNodeId = _data['sourceGridNodeId'];
    this.targetGridNodeId = _data['targetGridNodeId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.capacityIn = this.capacityIn;
    data.capacityOut = this.capacityOut;
    data.sensitivity = this.sensitivity;
    data.sourceGridNodeId = this.sourceGridNodeId;
    data.targetGridNodeId = this.targetGridNodeId;
    super.toJSON(data);
    return data;
  }
}
exports.GridNodeLink = GridNodeLink;
class GridNodeMarketAssignment extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new GridNodeMarketAssignment();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.gridNodeId = _data['gridNodeId'];
    this.marketId = _data['marketId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.gridNodeId = this.gridNodeId;
    data.marketId = this.marketId;
    super.toJSON(data);
    return data;
  }
}
exports.GridNodeMarketAssignment = GridNodeMarketAssignment;
class Invitation extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new Invitation();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.sendInvitationEmail = _data['sendInvitationEmail'];
    this.email = _data['email'];
    this.givenName = _data['givenName'];
    this.familyName = _data['familyName'];
    this.organizationId = _data['organizationId'];
    this.permissionSetId = _data['permissionSetId'];
    this.membershipId = _data['membershipId'];
    this.userId = _data['userId'];
    this.emailMessageId = _data['emailMessageId'];
    this.userType = _data['userType'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.sendInvitationEmail = this.sendInvitationEmail;
    data.email = this.email;
    data.givenName = this.givenName;
    data.familyName = this.familyName;
    data.organizationId = this.organizationId;
    data.permissionSetId = this.permissionSetId;
    data.membershipId = this.membershipId;
    data.userId = this.userId;
    data.emailMessageId = this.emailMessageId;
    data.userType = this.userType;
    super.toJSON(data);
    return data;
  }
}
exports.Invitation = Invitation;
class Invoice extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new Invoice();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.paid = _data['paid'];
    this.periodFrom = _data['periodFrom'] ? new Date(_data['periodFrom'].toString()) : undefined;
    this.periodTo = _data['periodTo'] ? new Date(_data['periodTo'].toString()) : undefined;
    this.dueDate = _data['dueDate'] ? new Date(_data['dueDate'].toString()) : undefined;
    this.invoiceDate = _data['invoiceDate'] ? new Date(_data['invoiceDate'].toString()) : undefined;
    this.numberInPeriod = _data['numberInPeriod'];
    this.taxExclusiveAmount = _data['taxExclusiveAmount'];
    this.taxInclusiveAmount = _data['taxInclusiveAmount'];
    this.taxAmount = _data['taxAmount'];
    this.invoiceReference = _data['invoiceReference'];
    this.purchaseReference = _data['purchaseReference'];
    this.buyerReference = _data['buyerReference'];
    this.invoicePeriod = _data['invoicePeriod'];
    this.currencyId = _data['currencyId'];
    this.description = _data['description'];
    this.marketId = _data['marketId'];
    this.buyerOrganizationId = _data['buyerOrganizationId'];
    this.sellerOrganizationId = _data['sellerOrganizationId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.paid = this.paid;
    data['periodFrom'] = this.periodFrom ? this.periodFrom.toISOString() : undefined;
    data['periodTo'] = this.periodTo ? this.periodTo.toISOString() : undefined;
    data['dueDate'] = this.dueDate ? this.dueDate.toISOString() : undefined;
    data['invoiceDate'] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined;
    data.numberInPeriod = this.numberInPeriod;
    data.taxExclusiveAmount = this.taxExclusiveAmount;
    data.taxInclusiveAmount = this.taxInclusiveAmount;
    data.taxAmount = this.taxAmount;
    data.invoiceReference = this.invoiceReference;
    data.purchaseReference = this.purchaseReference;
    data.buyerReference = this.buyerReference;
    data.invoicePeriod = this.invoicePeriod;
    data.currencyId = this.currencyId;
    data.description = this.description;
    data.marketId = this.marketId;
    data.buyerOrganizationId = this.buyerOrganizationId;
    data.sellerOrganizationId = this.sellerOrganizationId;
    super.toJSON(data);
    return data;
  }
}
exports.Invoice = Invoice;
class InvoiceFile extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new InvoiceFile();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.fileType = _data['fileType'];
    this.invoiceId = _data['invoiceId'];
    this.fileName = _data['fileName'];
    this.mimeType = _data['mimeType'];
    this.data = _data['data'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.fileType = this.fileType;
    data.invoiceId = this.invoiceId;
    data.fileName = this.fileName;
    data.mimeType = this.mimeType;
    data.data = this.data;
    super.toJSON(data);
    return data;
  }
}
exports.InvoiceFile = InvoiceFile;
class InvoiceLine extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new InvoiceLine();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.lineQuantity = _data['lineQuantity'];
    this.taxExclusiveLineUnitPrice = _data['taxExclusiveLineUnitPrice'];
    this.taxExclusiveAmount = _data['taxExclusiveAmount'];
    this.taxAmount = _data['taxAmount'];
    this.vatRate = _data['vatRate'];
    this.taxInclusiveAmount = _data['taxInclusiveAmount'];
    this.invoiceId = _data['invoiceId'];
    this.lineId = _data['lineId'];
    this.lineTitle = _data['lineTitle'];
    this.quantityUnit = _data['quantityUnit'];
    this.priceUnit = _data['priceUnit'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.lineQuantity = this.lineQuantity;
    data.taxExclusiveLineUnitPrice = this.taxExclusiveLineUnitPrice;
    data.taxExclusiveAmount = this.taxExclusiveAmount;
    data.taxAmount = this.taxAmount;
    data.vatRate = this.vatRate;
    data.taxInclusiveAmount = this.taxInclusiveAmount;
    data.invoiceId = this.invoiceId;
    data.lineId = this.lineId;
    data.lineTitle = this.lineTitle;
    data.quantityUnit = this.quantityUnit;
    data.priceUnit = this.priceUnit;
    super.toJSON(data);
    return data;
  }
}
exports.InvoiceLine = InvoiceLine;
class InvoicingInfo extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new InvoicingInfo();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.channel = _data['channel'];
    this.organizationId = _data['organizationId'];
    this.marketId = _data['marketId'];
    this.countryId = _data['countryId'];
    this.taxRegister = _data['taxRegister'];
    this.extraTaxInfo = _data['extraTaxInfo'];
    this.companyName = _data['companyName'];
    this.vatNumber = _data['vatNumber'];
    this.registrationNumber = _data['registrationNumber'];
    this.address = _data['address'];
    this.city = _data['city'];
    this.county = _data['county'];
    this.postalCode = _data['postalCode'];
    this.invoiceReference = _data['invoiceReference'];
    this.purchaseReference = _data['purchaseReference'];
    this.buyerReference = _data['buyerReference'];
    this.contactName = _data['contactName'];
    this.contactPhoneNumber = _data['contactPhoneNumber'];
    this.contactEmail = _data['contactEmail'];
    this.recipientEmail = _data['recipientEmail'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.channel = this.channel;
    data.organizationId = this.organizationId;
    data.marketId = this.marketId;
    data.countryId = this.countryId;
    data.taxRegister = this.taxRegister;
    data.extraTaxInfo = this.extraTaxInfo;
    data.companyName = this.companyName;
    data.vatNumber = this.vatNumber;
    data.registrationNumber = this.registrationNumber;
    data.address = this.address;
    data.city = this.city;
    data.county = this.county;
    data.postalCode = this.postalCode;
    data.invoiceReference = this.invoiceReference;
    data.purchaseReference = this.purchaseReference;
    data.buyerReference = this.buyerReference;
    data.contactName = this.contactName;
    data.contactPhoneNumber = this.contactPhoneNumber;
    data.contactEmail = this.contactEmail;
    data.recipientEmail = this.recipientEmail;
    super.toJSON(data);
    return data;
  }
}
exports.InvoicingInfo = InvoicingInfo;
class LongFlexContract extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new LongFlexContract();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.isPubliclyVisible = _data['isPubliclyVisible'];
    this.approvedByBuyer = _data['approvedByBuyer'];
    this.approvedBySeller = _data['approvedBySeller'];
    this.autoCreateOrders = _data['autoCreateOrders'];
    this.contractSchedule = _data['contractSchedule'];
    this.openFrom = _data['openFrom'] ? new Date(_data['openFrom'].toString()) : undefined;
    this.openTo = _data['openTo'] ? new Date(_data['openTo'].toString()) : undefined;
    this.periodFrom = _data['periodFrom'] ? new Date(_data['periodFrom'].toString()) : undefined;
    this.periodTo = _data['periodTo'] ? new Date(_data['periodTo'].toString()) : undefined;
    this.autoCreateExpiryRelativeTo = _data['autoCreateExpiryRelativeTo'];
    this.quantity = _data['quantity'];
    this.unitPrice = _data['unitPrice'];
    this.availabilityPrice = _data['availabilityPrice'];
    this.minAdjacentBlocks = _data['minAdjacentBlocks'];
    this.maxAdjacentBlocks = _data['maxAdjacentBlocks'];
    this.minAdjacentRestBlocks = _data['minAdjacentRestBlocks'];
    this.autoCreateExpiry = _data['autoCreateExpiry'];
    this.dailyMaxValue = _data['dailyMaxValue'];
    this.dailyAverageValue = _data['dailyAverageValue'];
    this.contractPeriodMaxValue = _data['contractPeriodMaxValue'];
    this.contractPeriodAverageValue = _data['contractPeriodAverageValue'];
    this.generateOrdersOfSide = _data['generateOrdersOfSide'];
    this.visibility = _data['visibility'];
    this.quantityType = _data['quantityType'];
    this.regulationType = _data['regulationType'];
    this.baseContractId = _data['baseContractId'];
    this.orderGroupId = _data['orderGroupId'];
    this.name = _data['name'];
    this.comments = _data['comments'];
    this.rejectionComments = _data['rejectionComments'];
    this.marketId = _data['marketId'];
    this.gridNodeId = _data['gridNodeId'];
    this.buyerOrganizationId = _data['buyerOrganizationId'];
    this.sellerOrganizationId = _data['sellerOrganizationId'];
    this.assetPortfolioId = _data['assetPortfolioId'];
    this.crontab = _data['crontab'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.isPubliclyVisible = this.isPubliclyVisible;
    data.approvedByBuyer = this.approvedByBuyer;
    data.approvedBySeller = this.approvedBySeller;
    data.autoCreateOrders = this.autoCreateOrders;
    data.contractSchedule = this.contractSchedule;
    data['openFrom'] = this.openFrom ? this.openFrom.toISOString() : undefined;
    data['openTo'] = this.openTo ? this.openTo.toISOString() : undefined;
    data['periodFrom'] = this.periodFrom ? this.periodFrom.toISOString() : undefined;
    data['periodTo'] = this.periodTo ? this.periodTo.toISOString() : undefined;
    data.autoCreateExpiryRelativeTo = this.autoCreateExpiryRelativeTo;
    data.quantity = this.quantity;
    data.unitPrice = this.unitPrice;
    data.availabilityPrice = this.availabilityPrice;
    data.minAdjacentBlocks = this.minAdjacentBlocks;
    data.maxAdjacentBlocks = this.maxAdjacentBlocks;
    data.minAdjacentRestBlocks = this.minAdjacentRestBlocks;
    data.autoCreateExpiry = this.autoCreateExpiry;
    data.dailyMaxValue = this.dailyMaxValue;
    data.dailyAverageValue = this.dailyAverageValue;
    data.contractPeriodMaxValue = this.contractPeriodMaxValue;
    data.contractPeriodAverageValue = this.contractPeriodAverageValue;
    data.generateOrdersOfSide = this.generateOrdersOfSide;
    data.visibility = this.visibility;
    data.quantityType = this.quantityType;
    data.regulationType = this.regulationType;
    data.baseContractId = this.baseContractId;
    data.orderGroupId = this.orderGroupId;
    data.name = this.name;
    data.comments = this.comments;
    data.rejectionComments = this.rejectionComments;
    data.marketId = this.marketId;
    data.gridNodeId = this.gridNodeId;
    data.buyerOrganizationId = this.buyerOrganizationId;
    data.sellerOrganizationId = this.sellerOrganizationId;
    data.assetPortfolioId = this.assetPortfolioId;
    data.crontab = this.crontab;
    super.toJSON(data);
    return data;
  }
}
exports.LongFlexContract = LongFlexContract;
class MapPolygon extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new MapPolygon();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    if (Array.isArray(_data['coordinates'])) {
      this.coordinates = [];
      for (let item of _data['coordinates']) this.coordinates.push(Coordinate.fromJS(item));
    }
    if (Array.isArray(_data['polygons'])) {
      this.polygons = [];
      for (let item of _data['polygons']) this.polygons.push(Polygon.fromJS(item));
    }
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.coordinates)) {
      data['coordinates'] = [];
      for (let item of this.coordinates) data['coordinates'].push(item.toJSON());
    }
    if (Array.isArray(this.polygons)) {
      data['polygons'] = [];
      for (let item of this.polygons) data['polygons'].push(item.toJSON());
    }
    super.toJSON(data);
    return data;
  }
}
exports.MapPolygon = MapPolygon;
class Market extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new Market();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.allowedToBuy = _data['allowedToBuy'];
    this.allowedToSell = _data['allowedToSell'];
    this.billingPolicy = _data['billingPolicy'];
    this.allowOrderCreationWithoutBaseLine = _data['allowOrderCreationWithoutBaseLine'];
    this.allowEditingBaseLinesInTradedPeriods = _data['allowEditingBaseLinesInTradedPeriods'];
    this.requiresMarketParticipation = _data['requiresMarketParticipation'];
    this.ispGateClosedPolicy = _data['ispGateClosedPolicy'];
    this.minimumBlockSizeInSeconds = _data['minimumBlockSizeInSeconds'];
    this.quantityGranularity = _data['quantityGranularity'];
    this.minimumQuantity = _data['minimumQuantity'];
    this.ispGateOpen = _data['ispGateOpen'];
    this.ispGateClose = _data['ispGateClose'];
    this.quantityType = _data['quantityType'];
    this.name = _data['name'];
    this.ownerOrganizationId = _data['ownerOrganizationId'];
    this.currencyId = _data['currencyId'];
    this.timeZone = _data['timeZone'];
    this.invoicingSchedule = _data['invoicingSchedule'];
    this.invoiceDueDateRule = _data['invoiceDueDateRule'];
    this.auctionType = _data['auctionType'];
    this.tradeVisibility = _data['tradeVisibility'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.allowedToBuy = this.allowedToBuy;
    data.allowedToSell = this.allowedToSell;
    data.billingPolicy = this.billingPolicy;
    data.allowOrderCreationWithoutBaseLine = this.allowOrderCreationWithoutBaseLine;
    data.allowEditingBaseLinesInTradedPeriods = this.allowEditingBaseLinesInTradedPeriods;
    data.requiresMarketParticipation = this.requiresMarketParticipation;
    data.ispGateClosedPolicy = this.ispGateClosedPolicy;
    data.minimumBlockSizeInSeconds = this.minimumBlockSizeInSeconds;
    data.quantityGranularity = this.quantityGranularity;
    data.minimumQuantity = this.minimumQuantity;
    data.ispGateOpen = this.ispGateOpen;
    data.ispGateClose = this.ispGateClose;
    data.quantityType = this.quantityType;
    data.name = this.name;
    data.ownerOrganizationId = this.ownerOrganizationId;
    data.currencyId = this.currencyId;
    data.timeZone = this.timeZone;
    data.invoicingSchedule = this.invoicingSchedule;
    data.invoiceDueDateRule = this.invoiceDueDateRule;
    data.auctionType = this.auctionType;
    data.tradeVisibility = this.tradeVisibility;
    super.toJSON(data);
    return data;
  }
}
exports.Market = Market;
class MarketMessage extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new MarketMessage();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.notifyOnUpdates = _data['notifyOnUpdates'];
    this.isPubliclyVisible = _data['isPubliclyVisible'];
    this.periodFrom = _data['periodFrom'] ? new Date(_data['periodFrom'].toString()) : undefined;
    this.periodTo = _data['periodTo'] ? new Date(_data['periodTo'].toString()) : undefined;
    this.header = _data['header'];
    this.body = _data['body'];
    this.marketId = _data['marketId'];
    this.ownerOrganizationId = _data['ownerOrganizationId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.notifyOnUpdates = this.notifyOnUpdates;
    data.isPubliclyVisible = this.isPubliclyVisible;
    data['periodFrom'] = this.periodFrom ? this.periodFrom.toISOString() : undefined;
    data['periodTo'] = this.periodTo ? this.periodTo.toISOString() : undefined;
    data.header = this.header;
    data.body = this.body;
    data.marketId = this.marketId;
    data.ownerOrganizationId = this.ownerOrganizationId;
    super.toJSON(data);
    return data;
  }
}
exports.MarketMessage = MarketMessage;
class MarketParticipation extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new MarketParticipation();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.marketId = _data['marketId'];
    this.ownerOrganizationId = _data['ownerOrganizationId'];
    this.permissionSetId = _data['permissionSetId'];
    this.rejectionComment = _data['rejectionComment'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.marketId = this.marketId;
    data.ownerOrganizationId = this.ownerOrganizationId;
    data.permissionSetId = this.permissionSetId;
    data.rejectionComment = this.rejectionComment;
    super.toJSON(data);
    return data;
  }
}
exports.MarketParticipation = MarketParticipation;
class MarketParticipationRequirement extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new MarketParticipationRequirement();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.marketId = _data['marketId'];
    this.preQualificationRequirementId = _data['preQualificationRequirementId'];
    this.permissionSetId = _data['permissionSetId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.marketId = this.marketId;
    data.preQualificationRequirementId = this.preQualificationRequirementId;
    data.permissionSetId = this.permissionSetId;
    super.toJSON(data);
    return data;
  }
}
exports.MarketParticipationRequirement = MarketParticipationRequirement;
class MarketPermission extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new MarketPermission();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.permission = _data['permission'];
    this.organizationId = _data['organizationId'];
    this.marketId = _data['marketId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.permission = this.permission;
    data.organizationId = this.organizationId;
    data.marketId = this.marketId;
    super.toJSON(data);
    return data;
  }
}
exports.MarketPermission = MarketPermission;
class MarketSettlementConfig extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new MarketSettlementConfig();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.shortFlexResolutionInMinutes = _data['shortFlexResolutionInMinutes'];
    this.longFlexResolutionInMinutes = _data['longFlexResolutionInMinutes'];
    this.maxUsageResolutionInMinutes = _data['maxUsageResolutionInMinutes'];
    this.marketId = _data['marketId'];
    this.shortFlexPaymentFactorRule = _data['shortFlexPaymentFactorRule'];
    this.longFlexCalculationRule = _data['longFlexCalculationRule'];
    this.maxUsageCalculationRule = _data['maxUsageCalculationRule'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.shortFlexResolutionInMinutes = this.shortFlexResolutionInMinutes;
    data.longFlexResolutionInMinutes = this.longFlexResolutionInMinutes;
    data.maxUsageResolutionInMinutes = this.maxUsageResolutionInMinutes;
    data.marketId = this.marketId;
    data.shortFlexPaymentFactorRule = this.shortFlexPaymentFactorRule;
    data.longFlexCalculationRule = this.longFlexCalculationRule;
    data.maxUsageCalculationRule = this.maxUsageCalculationRule;
    super.toJSON(data);
    return data;
  }
}
exports.MarketSettlementConfig = MarketSettlementConfig;
class MarketStatistic extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new MarketStatistic();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.statisticType = _data['statisticType'];
    this.vwaPrice = _data['vwaPrice'];
    this.maxPrice = _data['maxPrice'];
    this.minPrice = _data['minPrice'];
    this.tradedVolume = _data['tradedVolume'];
    this.marketId = _data['marketId'];
    this.statisticPeriod = _data['statisticPeriod'];
    this.contractScheduleDescription = _data['contractScheduleDescription'];
    this.notes = _data['notes'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.statisticType = this.statisticType;
    data.vwaPrice = this.vwaPrice;
    data.maxPrice = this.maxPrice;
    data.minPrice = this.minPrice;
    data.tradedVolume = this.tradedVolume;
    data.marketId = this.marketId;
    data.statisticPeriod = this.statisticPeriod;
    data.contractScheduleDescription = this.contractScheduleDescription;
    data.notes = this.notes;
    super.toJSON(data);
    return data;
  }
}
exports.MarketStatistic = MarketStatistic;
class MaxUsageContract extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new MaxUsageContract();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.signedByBuyer = _data['signedByBuyer'];
    this.signedBySeller = _data['signedBySeller'];
    this.buyerSignatureDate = _data['buyerSignatureDate'] ? new Date(_data['buyerSignatureDate'].toString()) : undefined;
    this.sellerSignatureDate = _data['sellerSignatureDate'] ? new Date(_data['sellerSignatureDate'].toString()) : undefined;
    this.tenderPeriodFrom = _data['tenderPeriodFrom'] ? new Date(_data['tenderPeriodFrom'].toString()) : undefined;
    this.tenderPeriodTo = _data['tenderPeriodTo'] ? new Date(_data['tenderPeriodTo'].toString()) : undefined;
    this.periodFrom = _data['periodFrom'] ? new Date(_data['periodFrom'].toString()) : undefined;
    this.periodTo = _data['periodTo'] ? new Date(_data['periodTo'].toString()) : undefined;
    this.limitType = _data['limitType'];
    this.limitValue = _data['limitValue'];
    this.unitPrice = _data['unitPrice'];
    this.dailyMaxValue = _data['dailyMaxValue'];
    this.dailyAverageValue = _data['dailyAverageValue'];
    this.contractPeriodMaxValue = _data['contractPeriodMaxValue'];
    this.contractPeriodAverageValue = _data['contractPeriodAverageValue'];
    this.tenderQuantity = _data['tenderQuantity'];
    this.tenderUnitPrice = _data['tenderUnitPrice'];
    this.name = _data['name'];
    this.comments = _data['comments'];
    this.tenderId = _data['tenderId'];
    this.assetPortfolioId = _data['assetPortfolioId'];
    this.sellerOrganizationId = _data['sellerOrganizationId'];
    this.rejectionComments = _data['rejectionComments'];
    this.signedByBuyerUserId = _data['signedByBuyerUserId'];
    this.signedBySellerUserId = _data['signedBySellerUserId'];
    this.tenderName = _data['tenderName'];
    this.tenderComments = _data['tenderComments'];
    this.tenderMarketId = _data['tenderMarketId'];
    this.tenderGridNodeId = _data['tenderGridNodeId'];
    this.tenderOrganizationId = _data['tenderOrganizationId'];
    this.tenderCrontab = _data['tenderCrontab'];
    this.crontab = _data['crontab'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.signedByBuyer = this.signedByBuyer;
    data.signedBySeller = this.signedBySeller;
    data['buyerSignatureDate'] = this.buyerSignatureDate ? this.buyerSignatureDate.toISOString() : undefined;
    data['sellerSignatureDate'] = this.sellerSignatureDate ? this.sellerSignatureDate.toISOString() : undefined;
    data['tenderPeriodFrom'] = this.tenderPeriodFrom ? this.tenderPeriodFrom.toISOString() : undefined;
    data['tenderPeriodTo'] = this.tenderPeriodTo ? this.tenderPeriodTo.toISOString() : undefined;
    data['periodFrom'] = this.periodFrom ? this.periodFrom.toISOString() : undefined;
    data['periodTo'] = this.periodTo ? this.periodTo.toISOString() : undefined;
    data.limitType = this.limitType;
    data.limitValue = this.limitValue;
    data.unitPrice = this.unitPrice;
    data.dailyMaxValue = this.dailyMaxValue;
    data.dailyAverageValue = this.dailyAverageValue;
    data.contractPeriodMaxValue = this.contractPeriodMaxValue;
    data.contractPeriodAverageValue = this.contractPeriodAverageValue;
    data.tenderQuantity = this.tenderQuantity;
    data.tenderUnitPrice = this.tenderUnitPrice;
    data.name = this.name;
    data.comments = this.comments;
    data.tenderId = this.tenderId;
    data.assetPortfolioId = this.assetPortfolioId;
    data.sellerOrganizationId = this.sellerOrganizationId;
    data.rejectionComments = this.rejectionComments;
    data.signedByBuyerUserId = this.signedByBuyerUserId;
    data.signedBySellerUserId = this.signedBySellerUserId;
    data.tenderName = this.tenderName;
    data.tenderComments = this.tenderComments;
    data.tenderMarketId = this.tenderMarketId;
    data.tenderGridNodeId = this.tenderGridNodeId;
    data.tenderOrganizationId = this.tenderOrganizationId;
    data.tenderCrontab = this.tenderCrontab;
    data.crontab = this.crontab;
    super.toJSON(data);
    return data;
  }
}
exports.MaxUsageContract = MaxUsageContract;
class MaxUsageTender extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new MaxUsageTender();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.isPubliclyVisible = _data['isPubliclyVisible'];
    this.periodFrom = _data['periodFrom'] ? new Date(_data['periodFrom'].toString()) : undefined;
    this.periodTo = _data['periodTo'] ? new Date(_data['periodTo'].toString()) : undefined;
    this.openFrom = _data['openFrom'] ? new Date(_data['openFrom'].toString()) : undefined;
    this.openTo = _data['openTo'] ? new Date(_data['openTo'].toString()) : undefined;
    this.quantity = _data['quantity'];
    this.unitPrice = _data['unitPrice'];
    this.name = _data['name'];
    this.comments = _data['comments'];
    this.marketId = _data['marketId'];
    this.gridNodeId = _data['gridNodeId'];
    this.organizationId = _data['organizationId'];
    this.crontab = _data['crontab'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.isPubliclyVisible = this.isPubliclyVisible;
    data['periodFrom'] = this.periodFrom ? this.periodFrom.toISOString() : undefined;
    data['periodTo'] = this.periodTo ? this.periodTo.toISOString() : undefined;
    data['openFrom'] = this.openFrom ? this.openFrom.toISOString() : undefined;
    data['openTo'] = this.openTo ? this.openTo.toISOString() : undefined;
    data.quantity = this.quantity;
    data.unitPrice = this.unitPrice;
    data.name = this.name;
    data.comments = this.comments;
    data.marketId = this.marketId;
    data.gridNodeId = this.gridNodeId;
    data.organizationId = this.organizationId;
    data.crontab = this.crontab;
    super.toJSON(data);
    return data;
  }
}
exports.MaxUsageTender = MaxUsageTender;
class Membership extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new Membership();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.expiryDate = _data['expiryDate'] ? new Date(_data['expiryDate'].toString()) : undefined;
    this.userId = _data['userId'];
    this.authorizedOrganizationId = _data['authorizedOrganizationId'];
    this.organizationId = _data['organizationId'];
    this.marketId = _data['marketId'];
    this.permissionSetId = _data['permissionSetId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data['expiryDate'] = this.expiryDate ? this.expiryDate.toISOString() : undefined;
    data.userId = this.userId;
    data.authorizedOrganizationId = this.authorizedOrganizationId;
    data.organizationId = this.organizationId;
    data.marketId = this.marketId;
    data.permissionSetId = this.permissionSetId;
    super.toJSON(data);
    return data;
  }
}
exports.Membership = Membership;
class MeterReading extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new MeterReading();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.periodFrom = _data['periodFrom'] ? new Date(_data['periodFrom'].toString()) : undefined;
    this.periodTo = _data['periodTo'] ? new Date(_data['periodTo'].toString()) : undefined;
    this.quantity = _data['quantity'];
    this.quantityType = _data['quantityType'];
    this.assetPortfolioId = _data['assetPortfolioId'];
    this.assetId = _data['assetId'];
    this.assetGridAssignmentId = _data['assetGridAssignmentId'];
    this.batchReference = _data['batchReference'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data['periodFrom'] = this.periodFrom ? this.periodFrom.toISOString() : undefined;
    data['periodTo'] = this.periodTo ? this.periodTo.toISOString() : undefined;
    data.quantity = this.quantity;
    data.quantityType = this.quantityType;
    data.assetPortfolioId = this.assetPortfolioId;
    data.assetId = this.assetId;
    data.assetGridAssignmentId = this.assetGridAssignmentId;
    data.batchReference = this.batchReference;
    super.toJSON(data);
    return data;
  }
}
exports.MeterReading = MeterReading;
class MfrrInterchange extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new MfrrInterchange();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.endpointType = _data['endpointType'];
    this.documentType = _data['documentType'];
    this.timeSeriesId = _data['timeSeriesId'];
    this.documentId = _data['documentId'];
    this.document = _data['document'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.endpointType = this.endpointType;
    data.documentType = this.documentType;
    data.timeSeriesId = this.timeSeriesId;
    data.documentId = this.documentId;
    data.document = this.document;
    super.toJSON(data);
    return data;
  }
}
exports.MfrrInterchange = MfrrInterchange;
class MfrrInterchangeConfiguration extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new MfrrInterchangeConfiguration();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.mfrrEndpoint = _data['mfrrEndpoint'];
    this.rampUpTime = _data['rampUpTime'];
    this.marketId = _data['marketId'];
    this.nodesId = _data['nodesId'];
    this.nodesIdRegistry = _data['nodesIdRegistry'];
    this.recipientGs1Id = _data['recipientGs1Id'];
    this.recipientId = _data['recipientId'];
    this.recipientIdRegistry = _data['recipientIdRegistry'];
    this.domainId = _data['domainId'];
    this.domainIdRegistry = _data['domainIdRegistry'];
    this.acquiringDomainId = _data['acquiringDomainId'];
    this.acquiringDomainIdRegistry = _data['acquiringDomainIdRegistry'];
    this.connectingDomainId = _data['connectingDomainId'];
    this.connectingDomainIdRegistry = _data['connectingDomainIdRegistry'];
    this.connectingDomainEdiId = _data['connectingDomainEdiId'];
    this.resourceId = _data['resourceId'];
    this.resourceIdRegistry = _data['resourceIdRegistry'];
    this.biddingZoneId = _data['biddingZoneId'];
    this.biddingZoneIdRegistry = _data['biddingZoneIdRegistry'];
    this.biddingLocationId = _data['biddingLocationId'];
    this.biddingLocationIdRegistry = _data['biddingLocationIdRegistry'];
    this.auctionId = _data['auctionId'];
    this.auctionIdRegistry = _data['auctionIdRegistry'];
    this.currency = _data['currency'];
    this.createOrdersAsOrganizationId = _data['createOrdersAsOrganizationId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.mfrrEndpoint = this.mfrrEndpoint;
    data.rampUpTime = this.rampUpTime;
    data.marketId = this.marketId;
    data.nodesId = this.nodesId;
    data.nodesIdRegistry = this.nodesIdRegistry;
    data.recipientGs1Id = this.recipientGs1Id;
    data.recipientId = this.recipientId;
    data.recipientIdRegistry = this.recipientIdRegistry;
    data.domainId = this.domainId;
    data.domainIdRegistry = this.domainIdRegistry;
    data.acquiringDomainId = this.acquiringDomainId;
    data.acquiringDomainIdRegistry = this.acquiringDomainIdRegistry;
    data.connectingDomainId = this.connectingDomainId;
    data.connectingDomainIdRegistry = this.connectingDomainIdRegistry;
    data.connectingDomainEdiId = this.connectingDomainEdiId;
    data.resourceId = this.resourceId;
    data.resourceIdRegistry = this.resourceIdRegistry;
    data.biddingZoneId = this.biddingZoneId;
    data.biddingZoneIdRegistry = this.biddingZoneIdRegistry;
    data.biddingLocationId = this.biddingLocationId;
    data.biddingLocationIdRegistry = this.biddingLocationIdRegistry;
    data.auctionId = this.auctionId;
    data.auctionIdRegistry = this.auctionIdRegistry;
    data.currency = this.currency;
    data.createOrdersAsOrganizationId = this.createOrdersAsOrganizationId;
    super.toJSON(data);
    return data;
  }
}
exports.MfrrInterchangeConfiguration = MfrrInterchangeConfiguration;
class MfrrTimeSeries extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new MfrrTimeSeries();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.periodFrom = _data['periodFrom'] ? new Date(_data['periodFrom'].toString()) : undefined;
    this.periodTo = _data['periodTo'] ? new Date(_data['periodTo'].toString()) : undefined;
    this.activatedFrom = _data['activatedFrom'] ? new Date(_data['activatedFrom'].toString()) : undefined;
    this.activatedTo = _data['activatedTo'] ? new Date(_data['activatedTo'].toString()) : undefined;
    this.price = _data['price'];
    this.quantity = _data['quantity'];
    this.configurationId = _data['configurationId'];
    this.externalCorrelationId = _data['externalCorrelationId'];
    this.timeSeriesId = _data['timeSeriesId'];
    this.brpOrganizationId = _data['brpOrganizationId'];
    if (Array.isArray(_data['orderIds'])) {
      this.orderIds = [];
      for (let item of _data['orderIds']) this.orderIds.push(item);
    }
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data['periodFrom'] = this.periodFrom ? this.periodFrom.toISOString() : undefined;
    data['periodTo'] = this.periodTo ? this.periodTo.toISOString() : undefined;
    data['activatedFrom'] = this.activatedFrom ? this.activatedFrom.toISOString() : undefined;
    data['activatedTo'] = this.activatedTo ? this.activatedTo.toISOString() : undefined;
    data.price = this.price;
    data.quantity = this.quantity;
    data.configurationId = this.configurationId;
    data.externalCorrelationId = this.externalCorrelationId;
    data.timeSeriesId = this.timeSeriesId;
    data.brpOrganizationId = this.brpOrganizationId;
    if (Array.isArray(this.orderIds)) {
      data['orderIds'] = [];
      for (let item of this.orderIds) data['orderIds'].push(item);
    }
    super.toJSON(data);
    return data;
  }
}
exports.MfrrTimeSeries = MfrrTimeSeries;
class Order extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new Order();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.customProperties = _data['customProperties'];
    this.counterOrderPolicy = _data['counterOrderPolicy'];
    this.validFrom = _data['validFrom'] ? new Date(_data['validFrom'].toString()) : undefined;
    this.validTo = _data['validTo'] ? new Date(_data['validTo'].toString()) : undefined;
    this.periodFrom = _data['periodFrom'] ? new Date(_data['periodFrom'].toString()) : undefined;
    this.periodTo = _data['periodTo'] ? new Date(_data['periodTo'].toString()) : undefined;
    this.priorityTimestamp = _data['priorityTimestamp'] ? new Date(_data['priorityTimestamp'].toString()) : undefined;
    this.sysStartTime = _data['sysStartTime'] ? new Date(_data['sysStartTime'].toString()) : undefined;
    this.sysEndTime = _data['sysEndTime'] ? new Date(_data['sysEndTime'].toString()) : undefined;
    this.fillType = _data['fillType'];
    this.quantity = _data['quantity'];
    this.minimumQuantity = _data['minimumQuantity'];
    this.unitPrice = _data['unitPrice'];
    this.originalQuantity = _data['originalQuantity'];
    this.quantityCompleted = _data['quantityCompleted'];
    this.blockSizeInSeconds = _data['blockSizeInSeconds'];
    this.minBlocks = _data['minBlocks'];
    this.maxBlocks = _data['maxBlocks'];
    this.minAdjacentBlocks = _data['minAdjacentBlocks'];
    this.maxAdjacentBlocks = _data['maxAdjacentBlocks'];
    this.minAdjacentRestBlocks = _data['minAdjacentRestBlocks'];
    this.minRampUpRate = _data['minRampUpRate'];
    this.maxRampUpRate = _data['maxRampUpRate'];
    this.minRampDownRate = _data['minRampDownRate'];
    this.maxRampDownRate = _data['maxRampDownRate'];
    this.revisionNumber = _data['revisionNumber'];
    this.completionType = _data['completionType'];
    this.side = _data['side'];
    this.visibility = _data['visibility'];
    this.priceType = _data['priceType'];
    this.quantityType = _data['quantityType'];
    this.regulationType = _data['regulationType'];
    this.renewableType = _data['renewableType'];
    this.ownerOrganizationId = _data['ownerOrganizationId'];
    this.gridNodeId = _data['gridNodeId'];
    this.marketId = _data['marketId'];
    this.assetPortfolioId = _data['assetPortfolioId'];
    this.supplierOrganizationId = _data['supplierOrganizationId'];
    this.comments = _data['comments'];
    this.externalReference = _data['externalReference'];
    this.originalOrderId = _data['originalOrderId'];
    this.targetOrganizationId = _data['targetOrganizationId'];
    this.orderGroupId = _data['orderGroupId'];
    this.longFlexContractId = _data['longFlexContractId'];
    this.assetTypeId = _data['assetTypeId'];
    this.targetOrderId = _data['targetOrderId'];
    this.counterOrderOf = _data['counterOrderOf'];
    if (Array.isArray(_data['excludeGridNodeIds'])) {
      this.excludeGridNodeIds = [];
      for (let item of _data['excludeGridNodeIds']) this.excludeGridNodeIds.push(item);
    }
    if (Array.isArray(_data['ownerSubscriptionTypes'])) {
      this.ownerSubscriptionTypes = [];
      for (let item of _data['ownerSubscriptionTypes']) this.ownerSubscriptionTypes.push(item);
    }
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.customProperties = this.customProperties;
    data.counterOrderPolicy = this.counterOrderPolicy;
    data['validFrom'] = this.validFrom ? this.validFrom.toISOString() : undefined;
    data['validTo'] = this.validTo ? this.validTo.toISOString() : undefined;
    data['periodFrom'] = this.periodFrom ? this.periodFrom.toISOString() : undefined;
    data['periodTo'] = this.periodTo ? this.periodTo.toISOString() : undefined;
    data['priorityTimestamp'] = this.priorityTimestamp ? this.priorityTimestamp.toISOString() : undefined;
    data['sysStartTime'] = this.sysStartTime ? this.sysStartTime.toISOString() : undefined;
    data['sysEndTime'] = this.sysEndTime ? this.sysEndTime.toISOString() : undefined;
    data.fillType = this.fillType;
    data.quantity = this.quantity;
    data.minimumQuantity = this.minimumQuantity;
    data.unitPrice = this.unitPrice;
    data.originalQuantity = this.originalQuantity;
    data.quantityCompleted = this.quantityCompleted;
    data.blockSizeInSeconds = this.blockSizeInSeconds;
    data.minBlocks = this.minBlocks;
    data.maxBlocks = this.maxBlocks;
    data.minAdjacentBlocks = this.minAdjacentBlocks;
    data.maxAdjacentBlocks = this.maxAdjacentBlocks;
    data.minAdjacentRestBlocks = this.minAdjacentRestBlocks;
    data.minRampUpRate = this.minRampUpRate;
    data.maxRampUpRate = this.maxRampUpRate;
    data.minRampDownRate = this.minRampDownRate;
    data.maxRampDownRate = this.maxRampDownRate;
    data.revisionNumber = this.revisionNumber;
    data.completionType = this.completionType;
    data.side = this.side;
    data.visibility = this.visibility;
    data.priceType = this.priceType;
    data.quantityType = this.quantityType;
    data.regulationType = this.regulationType;
    data.renewableType = this.renewableType;
    data.ownerOrganizationId = this.ownerOrganizationId;
    data.gridNodeId = this.gridNodeId;
    data.marketId = this.marketId;
    data.assetPortfolioId = this.assetPortfolioId;
    data.supplierOrganizationId = this.supplierOrganizationId;
    data.comments = this.comments;
    data.externalReference = this.externalReference;
    data.originalOrderId = this.originalOrderId;
    data.targetOrganizationId = this.targetOrganizationId;
    data.orderGroupId = this.orderGroupId;
    data.longFlexContractId = this.longFlexContractId;
    data.assetTypeId = this.assetTypeId;
    data.targetOrderId = this.targetOrderId;
    data.counterOrderOf = this.counterOrderOf;
    if (Array.isArray(this.excludeGridNodeIds)) {
      data['excludeGridNodeIds'] = [];
      for (let item of this.excludeGridNodeIds) data['excludeGridNodeIds'].push(item);
    }
    if (Array.isArray(this.ownerSubscriptionTypes)) {
      data['ownerSubscriptionTypes'] = [];
      for (let item of this.ownerSubscriptionTypes) data['ownerSubscriptionTypes'].push(item);
    }
    super.toJSON(data);
    return data;
  }
}
exports.Order = Order;
class Organization extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new Organization();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.isPubliclyVisible = _data['isPubliclyVisible'];
    this.name = _data['name'];
    this.comments = _data['comments'];
    this.externalReference = _data['externalReference'];
    this.countryId = _data['countryId'];
    this.organizationNumber = _data['organizationNumber'];
    this.contactInfo = _data['contactInfo'];
    this.streetAddress1 = _data['streetAddress1'];
    this.streetAddress2 = _data['streetAddress2'];
    this.postalCode = _data['postalCode'];
    this.postalArea = _data['postalArea'];
    this.timeZone = _data['timeZone'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.isPubliclyVisible = this.isPubliclyVisible;
    data.name = this.name;
    data.comments = this.comments;
    data.externalReference = this.externalReference;
    data.countryId = this.countryId;
    data.organizationNumber = this.organizationNumber;
    data.contactInfo = this.contactInfo;
    data.streetAddress1 = this.streetAddress1;
    data.streetAddress2 = this.streetAddress2;
    data.postalCode = this.postalCode;
    data.postalArea = this.postalArea;
    data.timeZone = this.timeZone;
    super.toJSON(data);
    return data;
  }
}
exports.Organization = Organization;
class OrganizationVisibilitySettings extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new OrganizationVisibilitySettings();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.gridAreaDefaultVisibility = _data['gridAreaDefaultVisibility'];
    this.longflexContractDefaultVisibility = _data['longflexContractDefaultVisibility'];
    this.maxUsageTenderDefaultVisibility = _data['maxUsageTenderDefaultVisibility'];
    this.ownerOrganizationId = _data['ownerOrganizationId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.gridAreaDefaultVisibility = this.gridAreaDefaultVisibility;
    data.longflexContractDefaultVisibility = this.longflexContractDefaultVisibility;
    data.maxUsageTenderDefaultVisibility = this.maxUsageTenderDefaultVisibility;
    data.ownerOrganizationId = this.ownerOrganizationId;
    super.toJSON(data);
    return data;
  }
}
exports.OrganizationVisibilitySettings = OrganizationVisibilitySettings;
class PermissionAssignment extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new PermissionAssignment();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.permission = _data['permission'];
    this.userId = _data['userId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.permission = this.permission;
    data.userId = this.userId;
    super.toJSON(data);
    return data;
  }
}
exports.PermissionAssignment = PermissionAssignment;
class PermissionSet extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new PermissionSet();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.permissionSetType = _data['permissionSetType'];
    this.name = _data['name'];
    this.description = _data['description'];
    this.ownerOrganizationId = _data['ownerOrganizationId'];
    if (Array.isArray(_data['permissions'])) {
      this.permissions = [];
      for (let item of _data['permissions']) this.permissions.push(item);
    }
    if (Array.isArray(_data['expandedPermissions'])) {
      this.expandedPermissions = [];
      for (let item of _data['expandedPermissions']) this.expandedPermissions.push(item);
    }
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.permissionSetType = this.permissionSetType;
    data.name = this.name;
    data.description = this.description;
    data.ownerOrganizationId = this.ownerOrganizationId;
    if (Array.isArray(this.permissions)) {
      data['permissions'] = [];
      for (let item of this.permissions) data['permissions'].push(item);
    }
    if (Array.isArray(this.expandedPermissions)) {
      data['expandedPermissions'] = [];
      for (let item of this.expandedPermissions) data['expandedPermissions'].push(item);
    }
    super.toJSON(data);
    return data;
  }
}
exports.PermissionSet = PermissionSet;
class Preferences extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new Preferences();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.items = _data['items'];
    this.organizationId = _data['organizationId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.items = this.items;
    data.organizationId = this.organizationId;
    super.toJSON(data);
    return data;
  }
}
exports.Preferences = Preferences;
class PreQualificationFile extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new PreQualificationFile();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.fileName = _data['fileName'];
    this.mimeType = _data['mimeType'];
    this.data = _data['data'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.fileName = this.fileName;
    data.mimeType = this.mimeType;
    data.data = this.data;
    super.toJSON(data);
    return data;
  }
}
exports.PreQualificationFile = PreQualificationFile;
class PreQualificationRequirement extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new PreQualificationRequirement();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.responseType = _data['responseType'];
    this.ownerOrganizationId = _data['ownerOrganizationId'];
    this.title = _data['title'];
    this.description = _data['description'];
    this.link = _data['link'];
    this.preQualificationFileId = _data['preQualificationFileId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.responseType = this.responseType;
    data.ownerOrganizationId = this.ownerOrganizationId;
    data.title = this.title;
    data.description = this.description;
    data.link = this.link;
    data.preQualificationFileId = this.preQualificationFileId;
    super.toJSON(data);
    return data;
  }
}
exports.PreQualificationRequirement = PreQualificationRequirement;
class PreQualificationSubmission extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new PreQualificationSubmission();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.accepted = _data['accepted'];
    this.ownerOrganizationId = _data['ownerOrganizationId'];
    this.preQualificationRequirementId = _data['preQualificationRequirementId'];
    this.preQualificationSubmissionFileId = _data['preQualificationSubmissionFileId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.accepted = this.accepted;
    data.ownerOrganizationId = this.ownerOrganizationId;
    data.preQualificationRequirementId = this.preQualificationRequirementId;
    data.preQualificationSubmissionFileId = this.preQualificationSubmissionFileId;
    super.toJSON(data);
    return data;
  }
}
exports.PreQualificationSubmission = PreQualificationSubmission;
class PriceArea extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new PriceArea();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.name = _data['name'];
    this.countryId = _data['countryId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.name = this.name;
    data.countryId = this.countryId;
    super.toJSON(data);
    return data;
  }
}
exports.PriceArea = PriceArea;
class PrivateGridNodeData extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new PrivateGridNodeData();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.customProperties = _data['customProperties'];
    this.gridNodeId = _data['gridNodeId'];
    this.ownerOrganizationId = _data['ownerOrganizationId'];
    this.comments = _data['comments'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.customProperties = this.customProperties;
    data.gridNodeId = this.gridNodeId;
    data.ownerOrganizationId = this.ownerOrganizationId;
    data.comments = this.comments;
    super.toJSON(data);
    return data;
  }
}
exports.PrivateGridNodeData = PrivateGridNodeData;
class PublicOrder extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new PublicOrder();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.periodFrom = _data['periodFrom'] ? new Date(_data['periodFrom'].toString()) : undefined;
    this.periodTo = _data['periodTo'] ? new Date(_data['periodTo'].toString()) : undefined;
    this.validTo = _data['validTo'] ? new Date(_data['validTo'].toString()) : undefined;
    this.priorityTimestamp = _data['priorityTimestamp'] ? new Date(_data['priorityTimestamp'].toString()) : undefined;
    this.minBlocks = _data['minBlocks'];
    this.maxBlocks = _data['maxBlocks'];
    this.minAdjacentBlocks = _data['minAdjacentBlocks'];
    this.maxAdjacentBlocks = _data['maxAdjacentBlocks'];
    this.minAdjacentRestBlocks = _data['minAdjacentRestBlocks'];
    this.remainingQuantity = _data['remainingQuantity'];
    this.remainingMinimumQuantity = _data['remainingMinimumQuantity'];
    this.unitPrice = _data['unitPrice'];
    this.completionType = _data['completionType'];
    this.side = _data['side'];
    this.visibility = _data['visibility'];
    this.priceType = _data['priceType'];
    this.quantityType = _data['quantityType'];
    this.regulationType = _data['regulationType'];
    this.renewableType = _data['renewableType'];
    this.orderGroupId = _data['orderGroupId'];
    this.gridNodeId = _data['gridNodeId'];
    this.marketId = _data['marketId'];
    this.targetOrganizationId = _data['targetOrganizationId'];
    this.assetTypeId = _data['assetTypeId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data['periodFrom'] = this.periodFrom ? this.periodFrom.toISOString() : undefined;
    data['periodTo'] = this.periodTo ? this.periodTo.toISOString() : undefined;
    data['validTo'] = this.validTo ? this.validTo.toISOString() : undefined;
    data['priorityTimestamp'] = this.priorityTimestamp ? this.priorityTimestamp.toISOString() : undefined;
    data.minBlocks = this.minBlocks;
    data.maxBlocks = this.maxBlocks;
    data.minAdjacentBlocks = this.minAdjacentBlocks;
    data.maxAdjacentBlocks = this.maxAdjacentBlocks;
    data.minAdjacentRestBlocks = this.minAdjacentRestBlocks;
    data.remainingQuantity = this.remainingQuantity;
    data.remainingMinimumQuantity = this.remainingMinimumQuantity;
    data.unitPrice = this.unitPrice;
    data.completionType = this.completionType;
    data.side = this.side;
    data.visibility = this.visibility;
    data.priceType = this.priceType;
    data.quantityType = this.quantityType;
    data.regulationType = this.regulationType;
    data.renewableType = this.renewableType;
    data.orderGroupId = this.orderGroupId;
    data.gridNodeId = this.gridNodeId;
    data.marketId = this.marketId;
    data.targetOrganizationId = this.targetOrganizationId;
    data.assetTypeId = this.assetTypeId;
    super.toJSON(data);
    return data;
  }
}
exports.PublicOrder = PublicOrder;
class RecommendationTemplate extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new RecommendationTemplate();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.contractType = _data['contractType'];
    if (Array.isArray(_data['parameterWeights'])) {
      this.parameterWeights = [];
      for (let item of _data['parameterWeights']) this.parameterWeights.push(RecommendationWeightedParameter.fromJS(item));
    }
    this.name = _data['name'];
    this.ownerOrganizationId = _data['ownerOrganizationId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.contractType = this.contractType;
    if (Array.isArray(this.parameterWeights)) {
      data['parameterWeights'] = [];
      for (let item of this.parameterWeights) data['parameterWeights'].push(item.toJSON());
    }
    data.name = this.name;
    data.ownerOrganizationId = this.ownerOrganizationId;
    super.toJSON(data);
    return data;
  }
}
exports.RecommendationTemplate = RecommendationTemplate;
class SettledLineBase extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new SettledLineBase();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.periodFrom = _data['periodFrom'] ? new Date(_data['periodFrom'].toString()) : undefined;
    this.periodTo = _data['periodTo'] ? new Date(_data['periodTo'].toString()) : undefined;
    this.settlementResolutionInSeconds = _data['settlementResolutionInSeconds'];
    this.amountToPay = _data['amountToPay'];
    this.amountToReceive = _data['amountToReceive'];
    this.side = _data['side'];
    this.quantityType = _data['quantityType'];
    this.regulationType = _data['regulationType'];
    this.marketId = _data['marketId'];
    this.marketName = _data['marketName'];
    this.currency = _data['currency'];
    this.organizationId = _data['organizationId'];
    this.organizationName = _data['organizationName'];
    this.gridNodeId = _data['gridNodeId'];
    this.gridNodeName = _data['gridNodeName'];
    this.remarks = _data['remarks'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data['periodFrom'] = this.periodFrom ? this.periodFrom.toISOString() : undefined;
    data['periodTo'] = this.periodTo ? this.periodTo.toISOString() : undefined;
    data.settlementResolutionInSeconds = this.settlementResolutionInSeconds;
    data.amountToPay = this.amountToPay;
    data.amountToReceive = this.amountToReceive;
    data.side = this.side;
    data.quantityType = this.quantityType;
    data.regulationType = this.regulationType;
    data.marketId = this.marketId;
    data.marketName = this.marketName;
    data.currency = this.currency;
    data.organizationId = this.organizationId;
    data.organizationName = this.organizationName;
    data.gridNodeId = this.gridNodeId;
    data.gridNodeName = this.gridNodeName;
    data.remarks = this.remarks;
    super.toJSON(data);
    return data;
  }
}
exports.SettledLineBase = SettledLineBase;
class SettledLongFlexLine extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new SettledLongFlexLine();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.periodFrom = _data['periodFrom'] ? new Date(_data['periodFrom'].toString()) : undefined;
    this.periodTo = _data['periodTo'] ? new Date(_data['periodTo'].toString()) : undefined;
    this.deliveryPercentage = _data['deliveryPercentage'];
    this.paymentPercentage = _data['paymentPercentage'];
    this.availabilityPrice = _data['availabilityPrice'];
    this.contractedQuantity = _data['contractedQuantity'];
    this.offeredQuantity = _data['offeredQuantity'];
    this.tradedQuantity = _data['tradedQuantity'];
    this.deliveredTradedQuantity = _data['deliveredTradedQuantity'];
    this.marketMinimumBlockSizeInSeconds = _data['marketMinimumBlockSizeInSeconds'];
    this.settlementResolutionInSeconds = _data['settlementResolutionInSeconds'];
    this.amountToPay = _data['amountToPay'];
    this.amountToReceive = _data['amountToReceive'];
    this.side = _data['side'];
    this.quantityType = _data['quantityType'];
    this.regulationType = _data['regulationType'];
    this.longFlexContractId = _data['longFlexContractId'];
    this.longFlexContractName = _data['longFlexContractName'];
    this.settlementRule = _data['settlementRule'];
    this.marketId = _data['marketId'];
    this.marketName = _data['marketName'];
    this.currency = _data['currency'];
    this.organizationId = _data['organizationId'];
    this.organizationName = _data['organizationName'];
    this.gridNodeId = _data['gridNodeId'];
    this.gridNodeName = _data['gridNodeName'];
    this.remarks = _data['remarks'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data['periodFrom'] = this.periodFrom ? this.periodFrom.toISOString() : undefined;
    data['periodTo'] = this.periodTo ? this.periodTo.toISOString() : undefined;
    data.deliveryPercentage = this.deliveryPercentage;
    data.paymentPercentage = this.paymentPercentage;
    data.availabilityPrice = this.availabilityPrice;
    data.contractedQuantity = this.contractedQuantity;
    data.offeredQuantity = this.offeredQuantity;
    data.tradedQuantity = this.tradedQuantity;
    data.deliveredTradedQuantity = this.deliveredTradedQuantity;
    data.marketMinimumBlockSizeInSeconds = this.marketMinimumBlockSizeInSeconds;
    data.settlementResolutionInSeconds = this.settlementResolutionInSeconds;
    data.amountToPay = this.amountToPay;
    data.amountToReceive = this.amountToReceive;
    data.side = this.side;
    data.quantityType = this.quantityType;
    data.regulationType = this.regulationType;
    data.longFlexContractId = this.longFlexContractId;
    data.longFlexContractName = this.longFlexContractName;
    data.settlementRule = this.settlementRule;
    data.marketId = this.marketId;
    data.marketName = this.marketName;
    data.currency = this.currency;
    data.organizationId = this.organizationId;
    data.organizationName = this.organizationName;
    data.gridNodeId = this.gridNodeId;
    data.gridNodeName = this.gridNodeName;
    data.remarks = this.remarks;
    super.toJSON(data);
    return data;
  }
}
exports.SettledLongFlexLine = SettledLongFlexLine;
class SettledMaxUsageLine extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new SettledMaxUsageLine();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.periodFrom = _data['periodFrom'] ? new Date(_data['periodFrom'].toString()) : undefined;
    this.periodTo = _data['periodTo'] ? new Date(_data['periodTo'].toString()) : undefined;
    this.paymentPercentage = _data['paymentPercentage'];
    this.contractLimit = _data['contractLimit'];
    this.meteredQuantity = _data['meteredQuantity'];
    this.quantityDeltaMWh = _data['quantityDeltaMWh'];
    this.unitPrice = _data['unitPrice'];
    this.settlementResolutionInSeconds = _data['settlementResolutionInSeconds'];
    this.amountToPay = _data['amountToPay'];
    this.amountToReceive = _data['amountToReceive'];
    this.side = _data['side'];
    this.quantityType = _data['quantityType'];
    this.regulationType = _data['regulationType'];
    this.contractId = _data['contractId'];
    this.contractName = _data['contractName'];
    this.tenderId = _data['tenderId'];
    this.tenderName = _data['tenderName'];
    this.settlementRule = _data['settlementRule'];
    this.marketId = _data['marketId'];
    this.marketName = _data['marketName'];
    this.currency = _data['currency'];
    this.organizationId = _data['organizationId'];
    this.organizationName = _data['organizationName'];
    this.gridNodeId = _data['gridNodeId'];
    this.gridNodeName = _data['gridNodeName'];
    this.remarks = _data['remarks'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data['periodFrom'] = this.periodFrom ? this.periodFrom.toISOString() : undefined;
    data['periodTo'] = this.periodTo ? this.periodTo.toISOString() : undefined;
    data.paymentPercentage = this.paymentPercentage;
    data.contractLimit = this.contractLimit;
    data.meteredQuantity = this.meteredQuantity;
    data.quantityDeltaMWh = this.quantityDeltaMWh;
    data.unitPrice = this.unitPrice;
    data.settlementResolutionInSeconds = this.settlementResolutionInSeconds;
    data.amountToPay = this.amountToPay;
    data.amountToReceive = this.amountToReceive;
    data.side = this.side;
    data.quantityType = this.quantityType;
    data.regulationType = this.regulationType;
    data.contractId = this.contractId;
    data.contractName = this.contractName;
    data.tenderId = this.tenderId;
    data.tenderName = this.tenderName;
    data.settlementRule = this.settlementRule;
    data.marketId = this.marketId;
    data.marketName = this.marketName;
    data.currency = this.currency;
    data.organizationId = this.organizationId;
    data.organizationName = this.organizationName;
    data.gridNodeId = this.gridNodeId;
    data.gridNodeName = this.gridNodeName;
    data.remarks = this.remarks;
    super.toJSON(data);
    return data;
  }
}
exports.SettledMaxUsageLine = SettledMaxUsageLine;
class SettledTradeLine extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new SettledTradeLine();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.periodFrom = _data['periodFrom'] ? new Date(_data['periodFrom'].toString()) : undefined;
    this.periodTo = _data['periodTo'] ? new Date(_data['periodTo'].toString()) : undefined;
    this.quantityTraded = _data['quantityTraded'];
    this.unitPrice = _data['unitPrice'];
    this.totalQuantityTraded = _data['totalQuantityTraded'];
    this.quantityTradedPerHour = _data['quantityTradedPerHour'];
    this.meteredQuantity = _data['meteredQuantity'];
    this.baselineQuantity = _data['baselineQuantity'];
    this.totalPrice = _data['totalPrice'];
    this.delivery = _data['delivery'];
    this.deliveryPercentage = _data['deliveryPercentage'];
    this.deliveryPerHour = _data['deliveryPerHour'];
    this.paymentRule = _data['paymentRule'];
    this.expBaselineMinutes = _data['expBaselineMinutes'];
    this.actBaselineMinutes = _data['actBaselineMinutes'];
    this.expMeterReadingMinutes = _data['expMeterReadingMinutes'];
    this.actMeterReadingMinutes = _data['actMeterReadingMinutes'];
    this.marketMinimumBlockSizeInSeconds = _data['marketMinimumBlockSizeInSeconds'];
    this.settlementResolutionInSeconds = _data['settlementResolutionInSeconds'];
    this.amountToPay = _data['amountToPay'];
    this.amountToReceive = _data['amountToReceive'];
    this.side = _data['side'];
    this.quantityType = _data['quantityType'];
    this.regulationType = _data['regulationType'];
    this.tradeId = _data['tradeId'];
    this.dealId = _data['dealId'];
    this.assetPortfolioId = _data['assetPortfolioId'];
    this.assetPortfolioName = _data['assetPortfolioName'];
    this.longflexContractId = _data['longflexContractId'];
    this.marketId = _data['marketId'];
    this.marketName = _data['marketName'];
    this.currency = _data['currency'];
    this.organizationId = _data['organizationId'];
    this.organizationName = _data['organizationName'];
    this.gridNodeId = _data['gridNodeId'];
    this.gridNodeName = _data['gridNodeName'];
    this.remarks = _data['remarks'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data['periodFrom'] = this.periodFrom ? this.periodFrom.toISOString() : undefined;
    data['periodTo'] = this.periodTo ? this.periodTo.toISOString() : undefined;
    data.quantityTraded = this.quantityTraded;
    data.unitPrice = this.unitPrice;
    data.totalQuantityTraded = this.totalQuantityTraded;
    data.quantityTradedPerHour = this.quantityTradedPerHour;
    data.meteredQuantity = this.meteredQuantity;
    data.baselineQuantity = this.baselineQuantity;
    data.totalPrice = this.totalPrice;
    data.delivery = this.delivery;
    data.deliveryPercentage = this.deliveryPercentage;
    data.deliveryPerHour = this.deliveryPerHour;
    data.paymentRule = this.paymentRule;
    data.expBaselineMinutes = this.expBaselineMinutes;
    data.actBaselineMinutes = this.actBaselineMinutes;
    data.expMeterReadingMinutes = this.expMeterReadingMinutes;
    data.actMeterReadingMinutes = this.actMeterReadingMinutes;
    data.marketMinimumBlockSizeInSeconds = this.marketMinimumBlockSizeInSeconds;
    data.settlementResolutionInSeconds = this.settlementResolutionInSeconds;
    data.amountToPay = this.amountToPay;
    data.amountToReceive = this.amountToReceive;
    data.side = this.side;
    data.quantityType = this.quantityType;
    data.regulationType = this.regulationType;
    data.tradeId = this.tradeId;
    data.dealId = this.dealId;
    data.assetPortfolioId = this.assetPortfolioId;
    data.assetPortfolioName = this.assetPortfolioName;
    data.longflexContractId = this.longflexContractId;
    data.marketId = this.marketId;
    data.marketName = this.marketName;
    data.currency = this.currency;
    data.organizationId = this.organizationId;
    data.organizationName = this.organizationName;
    data.gridNodeId = this.gridNodeId;
    data.gridNodeName = this.gridNodeName;
    data.remarks = this.remarks;
    super.toJSON(data);
    return data;
  }
}
exports.SettledTradeLine = SettledTradeLine;
class Subscription extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new Subscription();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.ownerOrganizationId = _data['ownerOrganizationId'];
    this.subscriptionType = _data['subscriptionType'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.ownerOrganizationId = this.ownerOrganizationId;
    data.subscriptionType = this.subscriptionType;
    super.toJSON(data);
    return data;
  }
}
exports.Subscription = Subscription;
class Trade extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new Trade();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.customProperties = _data['customProperties'];
    this.periodFrom = _data['periodFrom'] ? new Date(_data['periodFrom'].toString()) : undefined;
    this.periodTo = _data['periodTo'] ? new Date(_data['periodTo'].toString()) : undefined;
    this.quantity = _data['quantity'];
    this.unitPrice = _data['unitPrice'];
    this.side = _data['side'];
    this.quantityType = _data['quantityType'];
    this.regulationType = _data['regulationType'];
    this.marketId = _data['marketId'];
    this.dealId = _data['dealId'];
    this.orderId = _data['orderId'];
    this.ownerOrganizationId = _data['ownerOrganizationId'];
    this.supplierOrganizationId = _data['supplierOrganizationId'];
    this.gridNodeId = _data['gridNodeId'];
    this.counterpartGridNodeId = _data['counterpartGridNodeId'];
    this.assetPortfolioId = _data['assetPortfolioId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.customProperties = this.customProperties;
    data['periodFrom'] = this.periodFrom ? this.periodFrom.toISOString() : undefined;
    data['periodTo'] = this.periodTo ? this.periodTo.toISOString() : undefined;
    data.quantity = this.quantity;
    data.unitPrice = this.unitPrice;
    data.side = this.side;
    data.quantityType = this.quantityType;
    data.regulationType = this.regulationType;
    data.marketId = this.marketId;
    data.dealId = this.dealId;
    data.orderId = this.orderId;
    data.ownerOrganizationId = this.ownerOrganizationId;
    data.supplierOrganizationId = this.supplierOrganizationId;
    data.gridNodeId = this.gridNodeId;
    data.counterpartGridNodeId = this.counterpartGridNodeId;
    data.assetPortfolioId = this.assetPortfolioId;
    super.toJSON(data);
    return data;
  }
}
exports.Trade = Trade;
class TradingThreshold extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new TradingThreshold();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.periodFrom = _data['periodFrom'] ? new Date(_data['periodFrom'].toString()) : undefined;
    this.periodTo = _data['periodTo'] ? new Date(_data['periodTo'].toString()) : undefined;
    this.upThresholdA = _data['upThresholdA'];
    this.upThresholdB = _data['upThresholdB'];
    this.downThresholdA = _data['downThresholdA'];
    this.downThresholdB = _data['downThresholdB'];
    this.quantityType = _data['quantityType'];
    this.marketId = _data['marketId'];
    this.ownerOrganizationId = _data['ownerOrganizationId'];
    this.gridNodeId = _data['gridNodeId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data['periodFrom'] = this.periodFrom ? this.periodFrom.toISOString() : undefined;
    data['periodTo'] = this.periodTo ? this.periodTo.toISOString() : undefined;
    data.upThresholdA = this.upThresholdA;
    data.upThresholdB = this.upThresholdB;
    data.downThresholdA = this.downThresholdA;
    data.downThresholdB = this.downThresholdB;
    data.quantityType = this.quantityType;
    data.marketId = this.marketId;
    data.ownerOrganizationId = this.ownerOrganizationId;
    data.gridNodeId = this.gridNodeId;
    super.toJSON(data);
    return data;
  }
}
exports.TradingThreshold = TradingThreshold;
class User extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new User();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.privacyPolicyAcceptedAt = _data['privacyPolicyAcceptedAt'] ? new Date(_data['privacyPolicyAcceptedAt'].toString()) : undefined;
    this.loginHandle = _data['loginHandle'];
    this.email = _data['email'];
    this.givenName = _data['givenName'];
    this.familyName = _data['familyName'];
    this.nodesReferenceInB2C = _data['nodesReferenceInB2C'];
    this.ownerOrganizationId = _data['ownerOrganizationId'];
    this.userType = _data['userType'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data['privacyPolicyAcceptedAt'] = this.privacyPolicyAcceptedAt ? this.privacyPolicyAcceptedAt.toISOString() : undefined;
    data.loginHandle = this.loginHandle;
    data.email = this.email;
    data.givenName = this.givenName;
    data.familyName = this.familyName;
    data.nodesReferenceInB2C = this.nodesReferenceInB2C;
    data.ownerOrganizationId = this.ownerOrganizationId;
    data.userType = this.userType;
    super.toJSON(data);
    return data;
  }
}
exports.User = User;
class VatRate extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new VatRate();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.percentage = _data['percentage'];
    this.countryId = _data['countryId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.percentage = this.percentage;
    data.countryId = this.countryId;
    super.toJSON(data);
    return data;
  }
}
exports.VatRate = VatRate;
class AssetPortfolioInfo extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new AssetPortfolioInfo();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.marketAggregationCounts = _data['marketAggregationCounts'];
    this.customProperties = _data['customProperties'];
    this.baselineProvider = _data['baselineProvider'];
    this.aggregateBaselinesFromAssets = _data['aggregateBaselinesFromAssets'];
    this.aggregateMeterReadingsFromAssets = _data['aggregateMeterReadingsFromAssets'];
    this.meterReadingProvider = _data['meterReadingProvider'];
    this.meterReadingsAggregationLevel = _data['meterReadingsAggregationLevel'];
    this.assetCount = _data['assetCount'];
    this.dispatchConfigurationCount = _data['dispatchConfigurationCount'];
    this.baselinesInTheFutureCount = _data['baselinesInTheFutureCount'];
    this.activeOrdersCount = _data['activeOrdersCount'];
    this.longflexContractsCount = _data['longflexContractsCount'];
    this.rampUpRate = _data['rampUpRate'];
    this.rampDownRate = _data['rampDownRate'];
    this.minRampUpRate = _data['minRampUpRate'];
    this.maxRampUpRate = _data['maxRampUpRate'];
    this.minRampDownRate = _data['minRampDownRate'];
    this.maxRampDownRate = _data['maxRampDownRate'];
    if (Array.isArray(_data['supplierOrganizations'])) {
      this.supplierOrganizations = [];
      for (let item of _data['supplierOrganizations']) this.supplierOrganizations.push(Organization.fromJS(item));
    }
    this.renewableType = _data['renewableType'];
    this.gridNodeName = _data['gridNodeName'];
    this.managedByOrganizationId = _data['managedByOrganizationId'];
    this.supplierOrganizationId = _data['supplierOrganizationId'];
    this.retailerOrganizationId = _data['retailerOrganizationId'];
    this.marketId = _data['marketId'];
    this.name = _data['name'];
    this.baselineReference = _data['baselineReference'];
    this.meterReadingReference = _data['meterReadingReference'];
    this.externalReference = _data['externalReference'];
    this.comments = _data['comments'];
    this.assetTypeId = _data['assetTypeId'];
    this.gridNodeId = _data['gridNodeId'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.marketAggregationCounts = this.marketAggregationCounts;
    data.customProperties = this.customProperties;
    data.baselineProvider = this.baselineProvider;
    data.aggregateBaselinesFromAssets = this.aggregateBaselinesFromAssets;
    data.aggregateMeterReadingsFromAssets = this.aggregateMeterReadingsFromAssets;
    data.meterReadingProvider = this.meterReadingProvider;
    data.meterReadingsAggregationLevel = this.meterReadingsAggregationLevel;
    data.assetCount = this.assetCount;
    data.dispatchConfigurationCount = this.dispatchConfigurationCount;
    data.baselinesInTheFutureCount = this.baselinesInTheFutureCount;
    data.activeOrdersCount = this.activeOrdersCount;
    data.longflexContractsCount = this.longflexContractsCount;
    data.rampUpRate = this.rampUpRate;
    data.rampDownRate = this.rampDownRate;
    data.minRampUpRate = this.minRampUpRate;
    data.maxRampUpRate = this.maxRampUpRate;
    data.minRampDownRate = this.minRampDownRate;
    data.maxRampDownRate = this.maxRampDownRate;
    if (Array.isArray(this.supplierOrganizations)) {
      data['supplierOrganizations'] = [];
      for (let item of this.supplierOrganizations) data['supplierOrganizations'].push(item.toJSON());
    }
    data.renewableType = this.renewableType;
    data.gridNodeName = this.gridNodeName;
    data.managedByOrganizationId = this.managedByOrganizationId;
    data.supplierOrganizationId = this.supplierOrganizationId;
    data.retailerOrganizationId = this.retailerOrganizationId;
    data.marketId = this.marketId;
    data.name = this.name;
    data.baselineReference = this.baselineReference;
    data.meterReadingReference = this.meterReadingReference;
    data.externalReference = this.externalReference;
    data.comments = this.comments;
    data.assetTypeId = this.assetTypeId;
    data.gridNodeId = this.gridNodeId;
    super.toJSON(data);
    return data;
  }
}
exports.AssetPortfolioInfo = AssetPortfolioInfo;
class FSPAssetView extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new FSPAssetView();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.location = _data['location'];
    this.installedCapacity = _data['installedCapacity'];
    this.rampUpRate = _data['rampUpRate'];
    this.rampDownRate = _data['rampDownRate'];
    this.assetGridAssignmentStatus = _data['assetGridAssignmentStatus'];
    this.assetName = _data['assetName'];
    this.assetTypeId = _data['assetTypeId'];
    this.assetTypeName = _data['assetTypeName'];
    this.operatedByOrganizationId = _data['operatedByOrganizationId'];
    this.supplierOrganizationId = _data['supplierOrganizationId'];
    this.mpid = _data['mpid'];
    this.externalReference = _data['externalReference'];
    this.gridNodeId = _data['gridNodeId'];
    this.gridNodeName = _data['gridNodeName'];
    this.assetGridAssignmentId = _data['assetGridAssignmentId'];
    if (Array.isArray(_data['assetPortfolioIds'])) {
      this.assetPortfolioIds = [];
      for (let item of _data['assetPortfolioIds']) this.assetPortfolioIds.push(item);
    }
    if (Array.isArray(_data['assetPortfolioNames'])) {
      this.assetPortfolioNames = [];
      for (let item of _data['assetPortfolioNames']) this.assetPortfolioNames.push(item);
    }
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.location = this.location;
    data.installedCapacity = this.installedCapacity;
    data.rampUpRate = this.rampUpRate;
    data.rampDownRate = this.rampDownRate;
    data.assetGridAssignmentStatus = this.assetGridAssignmentStatus;
    data.assetName = this.assetName;
    data.assetTypeId = this.assetTypeId;
    data.assetTypeName = this.assetTypeName;
    data.operatedByOrganizationId = this.operatedByOrganizationId;
    data.supplierOrganizationId = this.supplierOrganizationId;
    data.mpid = this.mpid;
    data.externalReference = this.externalReference;
    data.gridNodeId = this.gridNodeId;
    data.gridNodeName = this.gridNodeName;
    data.assetGridAssignmentId = this.assetGridAssignmentId;
    if (Array.isArray(this.assetPortfolioIds)) {
      data['assetPortfolioIds'] = [];
      for (let item of this.assetPortfolioIds) data['assetPortfolioIds'].push(item);
    }
    if (Array.isArray(this.assetPortfolioNames)) {
      data['assetPortfolioNames'] = [];
      for (let item of this.assetPortfolioNames) data['assetPortfolioNames'].push(item);
    }
    super.toJSON(data);
    return data;
  }
}
exports.FSPAssetView = FSPAssetView;
class AssetGridAssignmentView extends DTOBase {
  static fromJS(data) {
    data = typeof data === 'object' ? data : {};
    let result = new AssetGridAssignmentView();
    result.init(data);
    return result;
  }
  init(_data) {
    if (!_data) return;
    super.init(_data);
    this.location = _data['location'];
    this.installedCapacity = _data['installedCapacity'];
    this.rampUpRate = _data['rampUpRate'];
    this.rampDownRate = _data['rampDownRate'];
    this.mpid = _data['mpid'];
    this.comments = _data['comments'];
    this.externalReference = _data['externalReference'];
    this.managedByOrganizationId = _data['managedByOrganizationId'];
    this.managedByOrganizationName = _data['managedByOrganizationName'];
    this.operatedByOrganizationId = _data['operatedByOrganizationId'];
    this.operatedByOrganizationName = _data['operatedByOrganizationName'];
    this.supplierOrganizationId = _data['supplierOrganizationId'];
    this.supplierOrganizationName = _data['supplierOrganizationName'];
    this.gridNodeId = _data['gridNodeId'];
    this.gridNodeName = _data['gridNodeName'];
    this.assetId = _data['assetId'];
    this.assetName = _data['assetName'];
    this.assetTypeId = _data['assetTypeId'];
    this.assetTypeName = _data['assetTypeName'];
  }
  toJSON(data) {
    data = typeof data === 'object' ? data : {};
    data.location = this.location;
    data.installedCapacity = this.installedCapacity;
    data.rampUpRate = this.rampUpRate;
    data.rampDownRate = this.rampDownRate;
    data.mpid = this.mpid;
    data.comments = this.comments;
    data.externalReference = this.externalReference;
    data.managedByOrganizationId = this.managedByOrganizationId;
    data.managedByOrganizationName = this.managedByOrganizationName;
    data.operatedByOrganizationId = this.operatedByOrganizationId;
    data.operatedByOrganizationName = this.operatedByOrganizationName;
    data.supplierOrganizationId = this.supplierOrganizationId;
    data.supplierOrganizationName = this.supplierOrganizationName;
    data.gridNodeId = this.gridNodeId;
    data.gridNodeName = this.gridNodeName;
    data.assetId = this.assetId;
    data.assetName = this.assetName;
    data.assetTypeId = this.assetTypeId;
    data.assetTypeName = this.assetTypeName;
    super.toJSON(data);
    return data;
  }
}
exports.AssetGridAssignmentView = AssetGridAssignmentView;